(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './ktor-ktor-utils.js', './kotlinx-atomicfu.js', './ktor-ktor-events.js', './ktor-ktor-io.js', './ktor-ktor-http.js', './kotlinx-io-kotlinx-io-core.js', './ktor-ktor-http-cio.js', './ktor-ktor-sse.js', './ktor-ktor-websockets.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./ktor-ktor-utils.js'), require('./kotlinx-atomicfu.js'), require('./ktor-ktor-events.js'), require('./ktor-ktor-io.js'), require('./ktor-ktor-http.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./ktor-ktor-http-cio.js'), require('./ktor-ktor-sse.js'), require('./ktor-ktor-websockets.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-utils'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-utils' was not found. Please, check whether 'ktor-ktor-utils' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-events'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-events' was not found. Please, check whether 'ktor-ktor-events' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-io'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-io' was not found. Please, check whether 'ktor-ktor-io' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-http'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-http' was not found. Please, check whether 'ktor-ktor-http' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-http-cio'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-http-cio' was not found. Please, check whether 'ktor-ktor-http-cio' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-sse'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-sse' was not found. Please, check whether 'ktor-ktor-sse' is loaded prior to 'ktor-ktor-client-core'.");
    }
    if (typeof globalThis['ktor-ktor-websockets'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-client-core'. Its dependency 'ktor-ktor-websockets' was not found. Please, check whether 'ktor-ktor-websockets' is loaded prior to 'ktor-ktor-client-core'.");
    }
    globalThis['ktor-ktor-client-core'] = factory(typeof globalThis['ktor-ktor-client-core'] === 'undefined' ? {} : globalThis['ktor-ktor-client-core'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['ktor-ktor-utils'], globalThis['kotlinx-atomicfu'], globalThis['ktor-ktor-events'], globalThis['ktor-ktor-io'], globalThis['ktor-ktor-http'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['ktor-ktor-http-cio'], globalThis['ktor-ktor-sse'], globalThis['ktor-ktor-websockets']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_io_ktor_ktor_utils, kotlin_org_jetbrains_kotlinx_atomicfu, kotlin_io_ktor_ktor_events, kotlin_io_ktor_ktor_io, kotlin_io_ktor_ktor_http, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_io_ktor_ktor_http_cio, kotlin_io_ktor_ktor_sse, kotlin_io_ktor_ktor_websockets) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var Key_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var protoOf = kotlin_kotlin.$_$.eh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var CancellationException = kotlin_kotlin.$_$.fd;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.s4;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i3;
  var CoroutineImpl = kotlin_kotlin.$_$.xd;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var PipelineContext = kotlin_io_ktor_ktor_utils.$_$.i;
  var toString = kotlin_kotlin.$_$.hh;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.gd;
  var initMetadataForLambda = kotlin_kotlin.$_$.hg;
  var VOID = kotlin_kotlin.$_$.d;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.eg;
  var atomic$boolean$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.b;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.c3;
  var AttributesJsFn = kotlin_io_ktor_ktor_utils.$_$.o;
  var Events = kotlin_io_ktor_ktor_events.$_$.b;
  var AttributeKey = kotlin_io_ktor_ktor_utils.$_$.n;
  var AutoCloseable = kotlin_kotlin.$_$.wm;
  var isInterface = kotlin_kotlin.$_$.rg;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y2;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var PlatformUtils_getInstance = kotlin_io_ktor_ktor_utils.$_$.a;
  var ByteReadChannel = kotlin_io_ktor_ktor_io.$_$.m1;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var arrayOf = kotlin_kotlin.$_$.fo;
  var createKType = kotlin_kotlin.$_$.qi;
  var TypeInfo = kotlin_io_ktor_ktor_utils.$_$.l;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var instanceOf = kotlin_io_ktor_ktor_utils.$_$.m;
  var NullBody_instance = kotlin_io_ktor_ktor_http.$_$.a;
  var equals = kotlin_kotlin.$_$.sf;
  var cancel_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k3;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var IllegalStateException = kotlin_kotlin.$_$.in;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.t5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var defineProp = kotlin_kotlin.$_$.pf;
  var UnsupportedOperationException = kotlin_kotlin.$_$.do;
  var UnsupportedOperationException_init_$Init$ = kotlin_kotlin.$_$.m6;
  var trimIndent = kotlin_kotlin.$_$.km;
  var contentLength = kotlin_io_ktor_ktor_http.$_$.m1;
  var fromInt = kotlin_kotlin.$_$.pe;
  var ByteReadChannel_0 = kotlin_io_ktor_ktor_io.$_$.l1;
  var readRemaining = kotlin_io_ktor_ktor_io.$_$.k;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var IllegalStateException_init_$Init$_0 = kotlin_kotlin.$_$.v5;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var GlobalScope_instance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.i;
  var writer = kotlin_io_ktor_ktor_io.$_$.x1;
  var WriteChannelContent = kotlin_io_ktor_ktor_http.$_$.s;
  var ReadChannelContent = kotlin_io_ktor_ktor_http.$_$.r;
  var Companion_getInstance = kotlin_io_ktor_ktor_io.$_$.c;
  var NoContent = kotlin_io_ktor_ktor_http.$_$.p;
  var ProtocolUpgrade = kotlin_io_ktor_ktor_http.$_$.q;
  var ByteArrayContent = kotlin_io_ktor_ktor_http.$_$.n;
  var ContentWrapper = kotlin_io_ktor_ktor_http.$_$.o;
  var WriterScope = kotlin_io_ktor_ktor_io.$_$.o1;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var OutgoingContent = kotlin_io_ktor_ktor_http.$_$.t;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p3;
  var async = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.h3;
  var emptySet = kotlin_kotlin.$_$.e9;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.a4;
  var HttpHeaders_getInstance = kotlin_io_ktor_ktor_http.$_$.g;
  var UnsafeHeaderException = kotlin_io_ktor_ktor_http.$_$.d1;
  var CancellationException_init_$Create$_0 = kotlin_kotlin.$_$.q4;
  var CoroutineName = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w2;
  var getKClass = kotlin_kotlin.$_$.si;
  var getStarKTypeProjection = kotlin_kotlin.$_$.ti;
  var ioDispatcher = kotlin_io_ktor_ktor_io.$_$.u1;
  var SilentSupervisor = kotlin_io_ktor_ktor_utils.$_$.q;
  var atomic$int$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.e;
  var lazy = kotlin_kotlin.$_$.to;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var CompletableJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.t2;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var createInvariantKTypeProjection = kotlin_kotlin.$_$.oi;
  var setOf = kotlin_kotlin.$_$.rb;
  var get = kotlin_kotlin.$_$.td;
  var fold = kotlin_kotlin.$_$.sd;
  var minusKey = kotlin_kotlin.$_$.ud;
  var plus = kotlin_kotlin.$_$.wd;
  var Element = kotlin_kotlin.$_$.vd;
  var joinToString = kotlin_kotlin.$_$.aa;
  var setOf_0 = kotlin_kotlin.$_$.sb;
  var PipelinePhase = kotlin_io_ktor_ktor_utils.$_$.j;
  var isSuspendFunction = kotlin_kotlin.$_$.tg;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var URLBuilder = kotlin_io_ktor_ktor_http.$_$.b1;
  var ParametersBuilder = kotlin_io_ktor_ktor_http.$_$.z;
  var appendAll = kotlin_io_ktor_ktor_utils.$_$.x;
  var takeFrom = kotlin_io_ktor_ktor_http.$_$.c2;
  var first = kotlin_kotlin.$_$.o9;
  var checkBuilderCapacity = kotlin_kotlin.$_$.y7;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.z3;
  var KtMap = kotlin_kotlin.$_$.g7;
  var HeadersBuilder = kotlin_io_ktor_ktor_http.$_$.x;
  var URLBuilder_0 = kotlin_io_ktor_ktor_http.$_$.c1;
  var KtorSimpleLogger = kotlin_io_ktor_ktor_utils.$_$.g;
  var MalformedInputException = kotlin_io_ktor_ktor_io.$_$.q;
  var Unit = kotlin_kotlin.$_$.co;
  var Application_getInstance = kotlin_io_ktor_ktor_http.$_$.b;
  var toLong = kotlin_kotlin.$_$.bm;
  var contentType = kotlin_io_ktor_ktor_http.$_$.n1;
  var isByteArray = kotlin_kotlin.$_$.lg;
  var Text_getInstance = kotlin_io_ktor_ktor_http.$_$.e;
  var TextContent = kotlin_io_ktor_ktor_http.$_$.u;
  var Long = kotlin_kotlin.$_$.kn;
  var copyTo = kotlin_io_ktor_ktor_io.$_$.f;
  var rethrowCloseCauseIfNeeded = kotlin_io_ktor_ktor_io.$_$.w1;
  var Companion_getInstance_0 = kotlin_io_ktor_ktor_http.$_$.c;
  var MultiPart_getInstance = kotlin_io_ktor_ktor_http.$_$.d;
  var CIOMultipartDataBase = kotlin_io_ktor_ktor_http_cio.$_$.a;
  var MultiPartData = kotlin_io_ktor_ktor_http.$_$.l;
  var cancel_1 = kotlin_io_ktor_ktor_io.$_$.q1;
  var HttpStatusCode = kotlin_io_ktor_ktor_http.$_$.y;
  var invokeOnCompletion = kotlin_io_ktor_ktor_io.$_$.t1;
  var attachWriterJob = kotlin_io_ktor_ktor_io.$_$.p1;
  var toByteArray = kotlin_io_ktor_ktor_io.$_$.o;
  var Source = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.h;
  var readText = kotlin_io_ktor_ktor_io.$_$.v1;
  var toInt = kotlin_kotlin.$_$.yl;
  var reversed = kotlin_kotlin.$_$.pb;
  var Attributes = kotlin_io_ktor_ktor_utils.$_$.p;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var Charsets_getInstance = kotlin_io_ktor_ktor_io.$_$.b;
  var toList = kotlin_kotlin.$_$.jc;
  var sortedWith = kotlin_kotlin.$_$.yb;
  var Collection = kotlin_kotlin.$_$.y6;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var get_name = kotlin_io_ktor_ktor_io.$_$.u;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var firstOrNull = kotlin_kotlin.$_$.k9;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var Comparator = kotlin_kotlin.$_$.bn;
  var hashCode = kotlin_kotlin.$_$.bg;
  var compareValues = kotlin_kotlin.$_$.ad;
  var charset = kotlin_io_ktor_ktor_http.$_$.l1;
  var withCharset = kotlin_io_ktor_ktor_http.$_$.f2;
  var charset_0 = kotlin_io_ktor_ktor_http.$_$.k1;
  var readText_0 = kotlin_io_ktor_ktor_io.$_$.z;
  var Companion_getInstance_1 = kotlin_io_ktor_ktor_http.$_$.j;
  var get_authority = kotlin_io_ktor_ktor_http.$_$.j1;
  var takeFrom_0 = kotlin_io_ktor_ktor_http.$_$.d2;
  var isSecure = kotlin_io_ktor_ktor_http.$_$.v1;
  var get_authority_0 = kotlin_io_ktor_ktor_http.$_$.i1;
  var Companion_getInstance_2 = kotlin_io_ktor_ktor_http.$_$.h;
  var EventDefinition = kotlin_io_ktor_ktor_events.$_$.a;
  var KFunctionImpl = kotlin_kotlin.$_$.ni;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.fg;
  var SupervisorJob = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g3;
  var cancel_2 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l3;
  var Default_getInstance = kotlin_kotlin.$_$.z2;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var delay = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x;
  var toLongOrNull = kotlin_kotlin.$_$.am;
  var multiply = kotlin_kotlin.$_$.ue;
  var compare = kotlin_kotlin.$_$.je;
  var toNumber = kotlin_kotlin.$_$.bf;
  var numberToLong = kotlin_kotlin.$_$.we;
  var add = kotlin_kotlin.$_$.fe;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var Result__exceptionOrNull_impl_p6xea9 = kotlin_kotlin.$_$.a1;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var trimMargin = kotlin_kotlin.$_$.lm;
  var IOException = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.g;
  var IOException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.d;
  var CopyableThrowable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u2;
  var isWebsocket = kotlin_io_ktor_ktor_http.$_$.x1;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q3;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.d3;
  var DurationUnit_MILLISECONDS_getInstance = kotlin_kotlin.$_$.q3;
  var toDuration = kotlin_kotlin.$_$.sm;
  var delay_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.y;
  var get_isTraceEnabled = kotlin_io_ktor_ktor_utils.$_$.h;
  var KProperty0 = kotlin_kotlin.$_$.xi;
  var createKTypeParameter = kotlin_kotlin.$_$.pi;
  var NullBody = kotlin_io_ktor_ktor_http.$_$.m;
  var withContext = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var cancel_3 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.j3;
  var removePrefix = kotlin_kotlin.$_$.rk;
  var removeSuffix = kotlin_kotlin.$_$.sk;
  var FlowCollector = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p1;
  var get_isActive = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n3;
  var get_rootCause = kotlin_io_ktor_ktor_utils.$_$.c1;
  var isBlank = kotlin_kotlin.$_$.dk;
  var substringBefore = kotlin_kotlin.$_$.ll;
  var substringAfter = kotlin_kotlin.$_$.jl;
  var contains = kotlin_kotlin.$_$.nj;
  var startsWith = kotlin_kotlin.$_$.dl;
  var ServerSentEvent = kotlin_io_ktor_ktor_sse.$_$.a;
  var LineEnding_Lenient_getInstance = kotlin_io_ktor_ktor_io.$_$.e;
  var readLine = kotlin_io_ktor_ktor_io.$_$.i;
  var _Duration___get_inWholeMilliseconds__impl__msfiry = kotlin_kotlin.$_$.i;
  var flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d2;
  var catch_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.w1;
  var onCompletion = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.f2;
  var contentType_0 = kotlin_io_ktor_ktor_http.$_$.o1;
  var Duration = kotlin_kotlin.$_$.om;
  var TypedServerSentEvent = kotlin_io_ktor_ktor_sse.$_$.b;
  var Flow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q1;
  var contentType_1 = kotlin_io_ktor_ktor_http.$_$.p1;
  var ArrayDeque_init_$Create$ = kotlin_kotlin.$_$.x3;
  var append = kotlin_io_ktor_ktor_http.$_$.h1;
  var toDuration_0 = kotlin_kotlin.$_$.tm;
  var WebSocketSession = kotlin_io_ktor_ktor_websockets.$_$.o;
  var DefaultWebSocketSession = kotlin_io_ktor_ktor_websockets.$_$.k;
  var generateNonce = kotlin_io_ktor_ktor_utils.$_$.z;
  var Default_getInstance_0 = kotlin_kotlin.$_$.r2;
  var emptyList = kotlin_kotlin.$_$.c9;
  var addAll = kotlin_kotlin.$_$.o7;
  var parseWebSocketExtensions = kotlin_io_ktor_ktor_websockets.$_$.q;
  var WebSocketExtensionsConfig = kotlin_io_ktor_ktor_websockets.$_$.m;
  var WebSocketChannelsConfig = kotlin_io_ktor_ktor_websockets.$_$.l;
  var Companion_getInstance_4 = kotlin_io_ktor_ktor_websockets.$_$.b;
  var DefaultWebSocketSession_0 = kotlin_io_ktor_ktor_websockets.$_$.j;
  var IllegalStateException_init_$Init$_1 = kotlin_kotlin.$_$.x5;
  var KtList = kotlin_kotlin.$_$.e7;
  var WebSocketExtension = kotlin_io_ktor_ktor_websockets.$_$.n;
  var ByteChannel = kotlin_io_ktor_ktor_io.$_$.j1;
  var putAll = kotlin_io_ktor_ktor_utils.$_$.b1;
  var GMTDate = kotlin_io_ktor_ktor_utils.$_$.d;
  var Pipeline = kotlin_io_ktor_ktor_utils.$_$.k;
  var takeFrom_1 = kotlin_io_ktor_ktor_http.$_$.b2;
  var decode = kotlin_io_ktor_ktor_io.$_$.r;
  var Key_instance_0 = kotlin_kotlin.$_$.p2;
  var get_ByteArrayPool = kotlin_io_ktor_ktor_io.$_$.g1;
  var readAvailable = kotlin_io_ktor_ktor_io.$_$.g;
  var writeFully = kotlin_io_ktor_ktor_io.$_$.p;
  var close = kotlin_io_ktor_ktor_io.$_$.r1;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var Companion_getInstance_5 = kotlin_io_ktor_ktor_http.$_$.i;
  var CoroutineScope_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.x2;
  var equals_0 = kotlin_kotlin.$_$.wj;
  var flatten = kotlin_kotlin.$_$.r9;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var await_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.u;
  var CancellationException_0 = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r2;
  var Companion_getInstance_6 = kotlin_io_ktor_ktor_http.$_$.f;
  var headersOf = kotlin_io_ktor_ktor_http.$_$.u1;
  var intercepted = kotlin_kotlin.$_$.jd;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q2;
  var arrayConcat = kotlin_kotlin.$_$.a;
  var listOf = kotlin_kotlin.$_$.ta;
  var DisposableHandle = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b3;
  var SafeContinuation_init_$Create$ = kotlin_kotlin.$_$.t4;
  var Error_init_$Create$ = kotlin_kotlin.$_$.d5;
  var Companion_getInstance_7 = kotlin_io_ktor_ktor_websockets.$_$.a;
  var Codes_CLOSED_ABNORMALLY_getInstance = kotlin_io_ktor_ktor_websockets.$_$.c;
  var Text_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.h;
  var Binary_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.f;
  var CloseReason = kotlin_io_ktor_ktor_websockets.$_$.i;
  var Close_init_$Create$ = kotlin_io_ktor_ktor_websockets.$_$.g;
  var Codes_NORMAL_getInstance = kotlin_io_ktor_ktor_websockets.$_$.d;
  var decodeToString = kotlin_kotlin.$_$.qj;
  var Buffer = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.f;
  var writeFully_0 = kotlin_io_ktor_ktor_io.$_$.e1;
  var cancelConsumed = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.n1;
  var CompletableDeferred = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.s2;
  var Factory_getInstance = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.d;
  var from = kotlin_io_ktor_ktor_websockets.$_$.p;
  var send = kotlin_io_ktor_ktor_websockets.$_$.e;
  var toTypedArray = kotlin_kotlin.$_$.vc;
  var get_supportsRequestBody = kotlin_io_ktor_ktor_http.$_$.a2;
  var isEmpty = kotlin_io_ktor_ktor_http.$_$.v;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  //endregion
  //region block: pre-declaration
  initMetadataForLambda(HttpClient$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClient$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpClient, 'HttpClient', VOID, VOID, [CoroutineScope, AutoCloseable], [1]);
  initMetadataForClass(HttpClientConfig, 'HttpClientConfig', HttpClientConfig);
  initMetadataForClass(HttpClientCall, 'HttpClientCall', VOID, VOID, [CoroutineScope], [0, 1]);
  initMetadataForClass(DelegatedCall, 'DelegatedCall', VOID, HttpClientCall, VOID, [0, 1]);
  function get_coroutineContext() {
    return this.mtt().q19();
  }
  initMetadataForInterface(HttpRequest_0, 'HttpRequest', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(DelegatedRequest, 'DelegatedRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(HttpResponse, 'HttpResponse', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(DelegatedResponse, 'DelegatedResponse', VOID, HttpResponse);
  initMetadataForCompanion(Companion);
  initMetadataForCoroutine($bodyNullableCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DoubleReceiveException, 'DoubleReceiveException', VOID, IllegalStateException);
  initMetadataForClass(NoTransformationFoundException, 'NoTransformationFoundException', VOID, UnsupportedOperationException);
  initMetadataForClass(SavedHttpCall, 'SavedHttpCall', VOID, HttpClientCall, VOID, [0, 1]);
  initMetadataForClass(SavedHttpRequest, 'SavedHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(SavedHttpResponse, 'SavedHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($saveCOROUTINE$, CoroutineImpl);
  initMetadataForClass(UnsupportedContentTypeException, 'UnsupportedContentTypeException', VOID, IllegalStateException);
  initMetadataForLambda(ObservableContent$getContent$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(ObservableContent, 'ObservableContent', VOID, ReadChannelContent);
  initMetadataForInterface(ProgressListener, 'ProgressListener', VOID, VOID, VOID, [2]);
  initMetadataForLambda(HttpClientEngine$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpClientEngine$executeWithinCallContext$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeWithinCallContextCOROUTINE$, CoroutineImpl);
  function get_supportedCapabilities() {
    return emptySet();
  }
  function install(client) {
    var tmp = Phases_getInstance().its_1;
    client.vtp_1.ost(tmp, HttpClientEngine$install$slambda_0(client, this, null));
  }
  initMetadataForInterface(HttpClientEngine, 'HttpClientEngine', VOID, VOID, [CoroutineScope, AutoCloseable], [1]);
  initMetadataForClass(HttpClientEngineBase, 'HttpClientEngineBase', VOID, VOID, [HttpClientEngine], [1]);
  initMetadataForClass(ClientEngineClosedException, 'ClientEngineClosedException', ClientEngineClosedException, IllegalStateException);
  initMetadataForInterface(HttpClientEngineCapability, 'HttpClientEngineCapability');
  initMetadataForClass(HttpClientEngineConfig, 'HttpClientEngineConfig', HttpClientEngineConfig);
  function create$default(block, $super) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClientEngineFactory$create$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    return $super === VOID ? this.btt(block) : $super.btt.call(this, block);
  }
  initMetadataForInterface(HttpClientEngineFactory, 'HttpClientEngineFactory');
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(KtorCallContextElement, 'KtorCallContextElement', VOID, VOID, [Element]);
  initMetadataForLambda(AfterRenderHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(AfterRenderHook, 'AfterRenderHook');
  initMetadataForLambda(AfterReceiveHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(AfterReceiveHook, 'AfterReceiveHook');
  initMetadataForLambda(BodyProgress$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(BodyProgress$lambda$slambda_1, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultRequest$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Plugin, 'Plugin');
  initMetadataForClass(DefaultRequestBuilder, 'DefaultRequestBuilder');
  initMetadataForClass(DefaultRequest, 'DefaultRequest');
  initMetadataForClass(ResponseException, 'ResponseException', VOID, IllegalStateException);
  initMetadataForClass(RedirectResponseException, 'RedirectResponseException', VOID, ResponseException);
  initMetadataForClass(ClientRequestException, 'ClientRequestException', VOID, ResponseException);
  initMetadataForClass(ServerResponseException, 'ServerResponseException', VOID, ResponseException);
  initMetadataForLambda(addDefaultResponseValidation$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(defaultTransformers$1$content$1, VOID, VOID, ByteArrayContent);
  initMetadataForClass(defaultTransformers$1$content$2, VOID, VOID, ReadChannelContent);
  initMetadataForLambda(defaultTransformers$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(defaultTransformers$slambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(defaultTransformers$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HttpCallValidatorConfig, 'HttpCallValidatorConfig', HttpCallValidatorConfig);
  initMetadataForClass(ExceptionHandlerWrapper, 'ExceptionHandlerWrapper');
  initMetadataForClass(RequestExceptionHandlerWrapper, 'RequestExceptionHandlerWrapper');
  initMetadataForLambda(RequestError$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(RequestError, 'RequestError');
  initMetadataForLambda(ReceiveError$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(ReceiveError, 'ReceiveError');
  initMetadataForLambda(HttpCallValidator$lambda$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(HttpCallValidator$lambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$lambda$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpCallValidator$lambda$slambda_5, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($invoke$validateResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($invoke$processExceptionCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpRequest$1, VOID, VOID, VOID, [HttpRequest_0]);
  initMetadataForClass(HttpPlainTextConfig, 'HttpPlainTextConfig', HttpPlainTextConfig);
  initMetadataForLambda(RenderRequestHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(RenderRequestHook, 'RenderRequestHook');
  initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
  initMetadataForLambda(HttpPlainText$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(HttpPlainText$lambda$slambda_1, CoroutineImpl, VOID, [4]);
  initMetadataForClass(HttpRedirectConfig, 'HttpRedirectConfig', HttpRedirectConfig);
  initMetadataForLambda(HttpRedirect$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($invoke$handleCallCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($invokeCOROUTINE$, CoroutineImpl);
  initMetadataForFunctionReference(PipelineContext$proceed$ref, KFunctionImpl, VOID, [0]);
  initMetadataForLambda(SetupRequestContext$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(SetupRequestContext, 'SetupRequestContext');
  initMetadataForLambda(HttpRequestLifecycle$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HttpRetryEventData, 'HttpRetryEventData');
  initMetadataForLambda(HttpRequestRetryConfig$delay$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HttpRequestRetryConfig, 'HttpRequestRetryConfig', HttpRequestRetryConfig);
  initMetadataForClass(HttpRetryShouldRetryContext, 'HttpRetryShouldRetryContext');
  initMetadataForClass(HttpRetryDelayContext, 'HttpRetryDelayContext');
  initMetadataForClass(HttpRetryModifyRequestContext, 'HttpRetryModifyRequestContext');
  initMetadataForLambda(HttpRequestRetry$lambda$slambda, CoroutineImpl, VOID, [3]);
  initMetadataForLambda(HttpRequestRetry$lambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($throwOnInvalidResponseBodyCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(HttpSend$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($executeCOROUTINE$_0, CoroutineImpl);
  initMetadataForClass(Config, 'Config', Config);
  initMetadataForObject(Plugin_0, 'Plugin');
  initMetadataForInterface(Sender, 'Sender', VOID, VOID, VOID, [1]);
  initMetadataForClass(InterceptedSender, 'InterceptedSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(DefaultSender, 'DefaultSender', VOID, VOID, [Sender], [1]);
  initMetadataForClass(HttpSend, 'HttpSend');
  initMetadataForClass(SendCountExceedException, 'SendCountExceedException', VOID, IllegalStateException);
  initMetadataForObject(HttpTimeoutCapability, 'HttpTimeoutCapability', VOID, VOID, [HttpClientEngineCapability]);
  initMetadataForClass(HttpRequestTimeoutException, 'HttpRequestTimeoutException', VOID, IOException, [CopyableThrowable]);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(HttpTimeoutConfig, 'HttpTimeoutConfig', HttpTimeoutConfig_init_$Create$);
  initMetadataForLambda(HttpTimeout$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(applyRequestTimeout$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(SaveBodyPluginConfig, 'SaveBodyPluginConfig', SaveBodyPluginConfig);
  initMetadataForLambda(SaveBody$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForClass(HookHandler, 'HookHandler');
  initMetadataForClass(ClientPluginBuilder, 'ClientPluginBuilder');
  initMetadataForClass(ClientPluginInstance, 'ClientPluginInstance', VOID, VOID, [AutoCloseable]);
  initMetadataForClass(Sender_0, 'Sender', VOID, VOID, [CoroutineScope], [1]);
  initMetadataForLambda(Send$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(Send, 'Send');
  initMetadataForLambda(SetupRequest$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(SetupRequest, 'SetupRequest');
  initMetadataForClass(ClientPluginImpl, 'ClientPluginImpl');
  initMetadataForClass(TransformRequestBodyContext, 'TransformRequestBodyContext');
  initMetadataForClass(TransformResponseBodyContext, 'TransformResponseBodyContext');
  initMetadataForClass(OnRequestContext, 'OnRequestContext');
  initMetadataForLambda(RequestHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(RequestHook, 'RequestHook');
  initMetadataForLambda(TransformRequestBodyHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(TransformRequestBodyHook, 'TransformRequestBodyHook');
  initMetadataForLambda(TransformResponseBodyHook$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(TransformResponseBodyHook, 'TransformResponseBodyHook');
  initMetadataForInterface(SSESession, 'SSESession', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(ClientSSESession, 'ClientSSESession', VOID, VOID, [SSESession]);
  initMetadataForClass(ClientSSESessionWithDeserialization, 'ClientSSESessionWithDeserialization', VOID, VOID, [CoroutineScope]);
  initMetadataForLambda(DefaultClientSSESession$_incoming$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForLambda(DefaultClientSSESession$_incoming$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(DefaultClientSSESession$_incoming$slambda_3, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(DefaultClientSSESession$doReconnection$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($tryParseEventCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($parseEventCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($readLineWithSaveCOROUTINE$, CoroutineImpl);
  initMetadataForClass(DefaultClientSSESession, 'DefaultClientSSESession', VOID, VOID, [SSESession], [0, 1]);
  initMetadataForLambda(AfterRender$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForObject(AfterRender, 'AfterRender');
  initMetadataForObject(SSECapability, 'SSECapability', VOID, VOID, [HttpClientEngineCapability]);
  initMetadataForClass(SSEClientException, 'SSEClientException', SSEClientException, IllegalStateException);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, [FlowCollector, FunctionAdapter], [1]);
  initMetadataForLambda(SSE$lambda$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(SSE$lambda$slambda$o$incoming$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$, CoroutineImpl);
  initMetadataForClass(SSE$2$2$1$incoming$$inlined$map$1, VOID, VOID, VOID, [Flow], [1]);
  initMetadataForClass(SSE$2$2$clientSSESession$1, VOID, VOID, VOID, [CoroutineScope]);
  initMetadataForLambda(SSE$lambda$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForCoroutine($checkResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($savedCOROUTINE$, CoroutineImpl);
  initMetadataForInterface(SSEBufferPolicy, 'SSEBufferPolicy');
  initMetadataForObject(Off, 'Off', VOID, VOID, [SSEBufferPolicy]);
  initMetadataForClass(LastEvents, 'LastEvents', VOID, VOID, [SSEBufferPolicy]);
  initMetadataForClass(LastLines, 'LastLines', VOID, VOID, [SSEBufferPolicy]);
  initMetadataForObject(LastEvent, 'LastEvent', VOID, VOID, [SSEBufferPolicy]);
  initMetadataForObject(All, 'All', VOID, VOID, [SSEBufferPolicy]);
  function appendLine(line) {
  }
  function appendEvent(event) {
  }
  initMetadataForInterface(BodyBuffer, 'BodyBuffer');
  initMetadataForClass(Events_0, 'Events', VOID, VOID, [BodyBuffer]);
  initMetadataForClass(Lines, 'Lines', VOID, VOID, [BodyBuffer]);
  initMetadataForObject(Empty, 'Empty', VOID, VOID, [BodyBuffer]);
  initMetadataForClass(SSEClientContent, 'SSEClientContent', VOID, ContentWrapper);
  initMetadataForClass(SSEConfig, 'SSEConfig', SSEConfig);
  initMetadataForClass(DefaultClientWebSocketSession, 'DefaultClientWebSocketSession', VOID, VOID, [WebSocketSession, DefaultWebSocketSession], [1, 0]);
  initMetadataForClass(DelegatingClientWebSocketSession, 'DelegatingClientWebSocketSession', VOID, VOID, [WebSocketSession], [1, 0]);
  initMetadataForClass(ClientUpgradeContent, 'ClientUpgradeContent', VOID, NoContent, VOID, [1]);
  initMetadataForClass(WebSocketContent, 'WebSocketContent', WebSocketContent, ClientUpgradeContent, VOID, [1]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda, CoroutineImpl, VOID, [2]);
  initMetadataForLambda(WebSockets$Plugin$install$slambda_1, CoroutineImpl, VOID, [2]);
  initMetadataForClass(Config_0, 'Config', Config_0);
  initMetadataForObject(Plugin_1, 'Plugin');
  initMetadataForClass(WebSockets, 'WebSockets');
  initMetadataForObject(WebSocketExtensionsCapability, 'WebSocketExtensionsCapability', VOID, VOID, [HttpClientEngineCapability]);
  initMetadataForObject(WebSocketCapability, 'WebSocketCapability', VOID, VOID, [HttpClientEngineCapability]);
  initMetadataForClass(WebSocketException, 'WebSocketException', VOID, IllegalStateException);
  initMetadataForClass(DefaultHttpRequest, 'DefaultHttpRequest', VOID, VOID, [HttpRequest_0]);
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(HttpRequestBuilder, 'HttpRequestBuilder', HttpRequestBuilder);
  initMetadataForClass(HttpRequestData, 'HttpRequestData');
  initMetadataForClass(HttpResponseData, 'HttpResponseData');
  initMetadataForInterface(ResponseAdapter, 'ResponseAdapter');
  initMetadataForClass(SSEClientResponseAdapter, 'SSEClientResponseAdapter', SSEClientResponseAdapter, VOID, [ResponseAdapter]);
  initMetadataForObject(Phases, 'Phases');
  initMetadataForClass(HttpSendPipeline, 'HttpSendPipeline', HttpSendPipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_0, 'Phases');
  initMetadataForClass(HttpRequestPipeline, 'HttpRequestPipeline', HttpRequestPipeline, Pipeline, VOID, [2]);
  initMetadataForClass(DefaultHttpResponse, 'DefaultHttpResponse', VOID, HttpResponse);
  initMetadataForCoroutine($bodyAsChannelCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($bodyAsTextCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpResponseContainer, 'HttpResponseContainer');
  initMetadataForObject(Phases_1, 'Phases');
  initMetadataForClass(HttpReceivePipeline, 'HttpReceivePipeline', HttpReceivePipeline, Pipeline, VOID, [2]);
  initMetadataForObject(Phases_2, 'Phases');
  initMetadataForClass(HttpResponsePipeline, 'HttpResponsePipeline', HttpResponsePipeline, Pipeline, VOID, [2]);
  initMetadataForLambda(HttpStatement$execute$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($executeCOROUTINE$_1, CoroutineImpl);
  initMetadataForCoroutine($fetchStreamingResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($fetchResponseCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($cleanupCOROUTINE$, CoroutineImpl);
  initMetadataForClass(HttpStatement, 'HttpStatement', VOID, VOID, VOID, [1, 0, 2]);
  initMetadataForCoroutine($readRawBytesCOROUTINE$, CoroutineImpl);
  initMetadataForLambda(observable$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(HttpResponseReceiveFail, 'HttpResponseReceiveFail');
  initMetadataForObject(EmptyContent, 'EmptyContent', VOID, NoContent);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(FetchOptions, 'FetchOptions');
  initMetadataForObject(Js, 'Js', VOID, VOID, [HttpClientEngineFactory]);
  initMetadataForClass(JsClientEngineConfig, 'JsClientEngineConfig', JsClientEngineConfig, HttpClientEngineConfig);
  initMetadataForClass(JsClientEngine$createWebSocket$headers_capturingHack$1);
  initMetadataForCoroutine($executeCOROUTINE$_2, CoroutineImpl);
  initMetadataForCoroutine($createWebSocketCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($executeWebSocketRequestCOROUTINE$, CoroutineImpl);
  initMetadataForClass(JsClientEngine, 'JsClientEngine', VOID, HttpClientEngineBase, VOID, [1, 2]);
  initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
  initMetadataForLambda(channelFromStream$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(sam$kotlinx_coroutines_DisposableHandle$0_0, 'sam$kotlinx_coroutines_DisposableHandle$0', VOID, VOID, [DisposableHandle, FunctionAdapter]);
  initMetadataForLambda(JsWebSocketSession$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(JsWebSocketSession, 'JsWebSocketSession', VOID, VOID, [DefaultWebSocketSession], [0, 1]);
  initMetadataForLambda(getBodyBytes$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($toRawCOROUTINE$, CoroutineImpl);
  initMetadataForCoroutine($getBodyBytesCOROUTINE$, CoroutineImpl);
  initMetadataForClass(Node, 'Node');
  initMetadataForClass(engines$iterator$1);
  initMetadataForObject(engines, 'engines');
  initMetadataForClass(ConnectTimeoutException, 'ConnectTimeoutException', VOID, IOException);
  initMetadataForClass(InterruptedIOException, 'InterruptedIOException', VOID, IOException);
  initMetadataForClass(SocketTimeoutException, 'SocketTimeoutException', VOID, InterruptedIOException);
  //endregion
  function HttpClient_init_$Init$(engine, userConfig, manageEngine, $this) {
    HttpClient.call($this, engine, userConfig);
    $this.ptp_1 = manageEngine;
    if ($this.ptp_1) {
      if (engine instanceof HttpClientEngineBase) {
        engine.dtq_1.atomicfu$incrementAndGet();
      }
      var tmp = ensureNotNull($this.stp_1.aa(Key_instance));
      tmp.t1a(HttpClient$_init_$lambda_36nm6w(engine));
    }
    return $this;
  }
  function HttpClient_init_$Create$(engine, userConfig, manageEngine) {
    return HttpClient_init_$Init$(engine, userConfig, manageEngine, objectCreate(protoOf(HttpClient)));
  }
  function HttpClient$_init_$lambda_36nm6w($engine) {
    return function (cause) {
      var tmp;
      if (!($engine instanceof HttpClientEngineBase)) {
        tmp = true;
      } else {
        tmp = $engine.dtq_1.atomicfu$decrementAndGet() <= 0;
      }
      var shouldClose = tmp;
      var tmp_0;
      if (shouldClose) {
        var tmp_1;
        if (cause == null) {
          $engine.j4();
          tmp_1 = Unit_instance;
        } else {
          var tmp0_elvis_lhs = cause instanceof CancellationException ? cause : null;
          cancel($engine, tmp0_elvis_lhs == null ? CancellationException_init_$Create$('Client scope is canceled', cause) : tmp0_elvis_lhs);
          tmp_1 = Unit_instance;
        }
        tmp_0 = tmp_1;
      }
      return Unit_instance;
    };
  }
  function HttpClient$slambda(this$0, resultContinuation) {
    this.otq_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda).rtq = function ($this$intercept, call, $completion) {
    var tmp = this.stq($this$intercept, call, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClient$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this.qtq_1;
            if (!(tmp_0 instanceof HttpClientCall)) {
              var message = 'Error: HttpClientCall expected, but found ' + toString(this.qtq_1) + '(' + toString(getKClassFromExpression(this.qtq_1)) + ').';
              throw IllegalStateException_init_$Create$(toString(message));
            }

            this.n9_1 = 1;
            suspendResult = this.otq_1.wtp_1.jst(Unit_instance, this.qtq_1.ytq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var response = suspendResult;
            this.qtq_1.ztq(response);
            this.n9_1 = 2;
            suspendResult = this.ptq_1.pss(this.qtq_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda).stq = function ($this$intercept, call, completion) {
    var i = new HttpClient$slambda(this.otq_1, completion);
    i.ptq_1 = $this$intercept;
    i.qtq_1 = call;
    return i;
  };
  function HttpClient$slambda_0(this$0, resultContinuation) {
    var i = new HttpClient$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$intercept, call, $completion) {
      return i.rtq($this$intercept, call, $completion);
    }, 2);
  }
  function HttpClient$lambda($this$install) {
    defaultTransformers($this$install);
    return Unit_instance;
  }
  function HttpClient$slambda_1(this$0, resultContinuation) {
    this.itr_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClient$slambda_1).mtr = function ($this$intercept, it, $completion) {
    var tmp = this.ntr($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClient$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClient$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.jtr_1.qss(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.ltr_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              var tmp_1 = this;
              this.itr_1.ztp_1.usu(get_HttpResponseReceiveFailed(), new HttpResponseReceiveFail(this.jtr_1.kst_1.ytq(), cause));
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClient$slambda_1).ntr = function ($this$intercept, it, completion) {
    var i = new HttpClient$slambda_1(this.itr_1, completion);
    i.jtr_1 = $this$intercept;
    i.ktr_1 = it;
    return i;
  };
  function HttpClient$slambda_2(this$0, resultContinuation) {
    var i = new HttpClient$slambda_1(this$0, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.mtr($this$intercept, it, $completion);
    }, 2);
  }
  function $executeCOROUTINE$(_this__u8e3s4, builder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.wtr_1 = _this__u8e3s4;
    this.xtr_1 = builder;
  }
  protoOf($executeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.wtr_1.ztp_1.usu(get_HttpRequestCreated(), this.xtr_1);
            this.n9_1 = 1;
            suspendResult = this.wtr_1.ttp_1.jst(this.xtr_1, this.xtr_1.bts_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult instanceof HttpClientCall ? suspendResult : THROW_CCE();
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpClient(engine, userConfig) {
    userConfig = userConfig === VOID ? new HttpClientConfig() : userConfig;
    this.ntp_1 = engine;
    this.otp_1 = userConfig;
    this.ptp_1 = false;
    this.qtp_1 = atomic$boolean$1(false);
    this.rtp_1 = Job(this.ntp_1.q19().aa(Key_instance));
    this.stp_1 = this.ntp_1.q19().xj(this.rtp_1);
    this.ttp_1 = new HttpRequestPipeline();
    this.utp_1 = new HttpResponsePipeline();
    this.vtp_1 = new HttpSendPipeline();
    this.wtp_1 = new HttpReceivePipeline();
    this.xtp_1 = AttributesJsFn(true);
    this.ytp_1 = this.ntp_1.ebw();
    this.ztp_1 = new Events();
    this.atq_1 = new HttpClientConfig();
    this.ntp_1.ets(this);
    var tmp = Phases_getInstance().jts_1;
    this.vtp_1.ost(tmp, HttpClient$slambda_0(this, null));
    // Inline function 'kotlin.with' call
    var $this$with = this.otp_1;
    this.atq_1.sts(get_HttpRequestLifecycle());
    this.atq_1.sts(get_BodyProgress());
    this.atq_1.sts(get_SaveBody());
    if ($this$with.pts_1) {
      this.atq_1.tts('DefaultTransformers', HttpClient$lambda);
    }
    this.atq_1.sts(Plugin_getInstance_0());
    this.atq_1.sts(get_HttpCallValidator());
    if ($this$with.ots_1) {
      this.atq_1.sts(get_HttpRedirect());
    }
    this.atq_1.uts($this$with);
    if ($this$with.pts_1) {
      this.atq_1.sts(get_HttpPlainText());
    }
    addDefaultResponseValidation(this.atq_1);
    this.atq_1.ets(this);
    var tmp_0 = Phases_getInstance_2().vts_1;
    this.utp_1.ost(tmp_0, HttpClient$slambda_2(this, null));
  }
  protoOf(HttpClient).q19 = function () {
    return this.stp_1;
  };
  protoOf(HttpClient).att = function (builder, $completion) {
    var tmp = new $executeCOROUTINE$(this, builder, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClient).j4 = function () {
    var success = this.qtp_1.atomicfu$compareAndSet(false, true);
    if (!success)
      return Unit_instance;
    var installedFeatures = this.xtp_1.tsn(get_PLUGIN_INSTALLED_LIST());
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = installedFeatures.aso().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var plugin = installedFeatures.tsn(element instanceof AttributeKey ? element : THROW_CCE());
      if (isInterface(plugin, AutoCloseable)) {
        plugin.j4();
      }
    }
    this.rtp_1.w1g();
  };
  protoOf(HttpClient).toString = function () {
    return 'HttpClient[' + toString(this.ntp_1) + ']';
  };
  function HttpClient_0(engineFactory, block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_0;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientConfig();
    block(this_0);
    var config = this_0;
    var engine = engineFactory.btt(config.nts_1);
    return HttpClient_init_$Create$(engine, config, true);
  }
  function HttpClient_1(engine, block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new HttpClientConfig();
    block(this_0);
    return HttpClient_init_$Create$(engine, this_0, false);
  }
  function HttpClient$lambda_0(_this__u8e3s4) {
    return Unit_instance;
  }
  function installPlugin($this, plugin) {
    if ($this.kts_1.u2(plugin.t1()))
      return Unit_instance;
    var tmp0 = $this.kts_1;
    var tmp2 = plugin.t1();
    // Inline function 'kotlin.collections.set' call
    var value = HttpClientConfig$installPlugin$lambda(plugin);
    tmp0.z2(tmp2, value);
  }
  function HttpClientConfig$engineConfig$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function HttpClientConfig$install$lambda_0($previousConfigBlock, $configure) {
    return function (_this__u8e3s4) {
      var tmp0_safe_receiver = $previousConfigBlock;
      if (tmp0_safe_receiver == null)
        null;
      else
        tmp0_safe_receiver(_this__u8e3s4);
      $configure(!(_this__u8e3s4 == null) ? _this__u8e3s4 : THROW_CCE());
      return Unit_instance;
    };
  }
  function HttpClientConfig$installPlugin$lambda$lambda() {
    return AttributesJsFn(true);
  }
  function HttpClientConfig$installPlugin$lambda($plugin) {
    return function (scope) {
      var tmp = get_PLUGIN_INSTALLED_LIST();
      var attributes = scope.xtp_1.zsn(tmp, HttpClientConfig$installPlugin$lambda$lambda);
      var config = ensureNotNull(scope.atq_1.lts_1.w2($plugin.t1()));
      var pluginData = $plugin.ctt(config);
      $plugin.dtt(pluginData, scope);
      attributes.wsn($plugin.t1(), pluginData);
      return Unit_instance;
    };
  }
  function HttpClientConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp.kts_1 = LinkedHashMap_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.lts_1 = LinkedHashMap_init_$Create$();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_1.mts_1 = LinkedHashMap_init_$Create$();
    var tmp_2 = this;
    tmp_2.nts_1 = HttpClientConfig$engineConfig$lambda;
    this.ots_1 = true;
    this.pts_1 = true;
    this.qts_1 = false;
    this.rts_1 = PlatformUtils_getInstance().tsp_1;
  }
  protoOf(HttpClientConfig).ett = function (plugin, configure) {
    var previousConfigBlock = this.lts_1.w2(plugin.t1());
    var tmp0 = this.lts_1;
    var tmp2 = plugin.t1();
    // Inline function 'kotlin.collections.set' call
    var value = HttpClientConfig$install$lambda_0(previousConfigBlock, configure);
    tmp0.z2(tmp2, value);
    installPlugin(this, plugin);
  };
  protoOf(HttpClientConfig).sts = function (plugin, configure, $super) {
    var tmp;
    if (configure === VOID) {
      tmp = HttpClientConfig$install$lambda;
    } else {
      tmp = configure;
    }
    configure = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.ett(plugin, configure);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.ett.call(this, plugin, configure);
    }
    return tmp_0;
  };
  protoOf(HttpClientConfig).tts = function (key, block) {
    // Inline function 'kotlin.collections.set' call
    this.mts_1.z2(key, block);
  };
  protoOf(HttpClientConfig).ets = function (client) {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = this.kts_1.y2().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.apply' call
      element(client);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = this.mts_1.y2().t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.apply' call
      element_0(client);
    }
  };
  protoOf(HttpClientConfig).uts = function (other) {
    this.ots_1 = other.ots_1;
    this.pts_1 = other.pts_1;
    this.qts_1 = other.qts_1;
    var tmp0 = this.kts_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map = other.kts_1;
    tmp0.b3(map);
    var tmp0_0 = this.lts_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_0 = other.lts_1;
    tmp0_0.b3(map_0);
    var tmp0_1 = this.mts_1;
    // Inline function 'kotlin.collections.plusAssign' call
    var map_1 = other.mts_1;
    tmp0_1.b3(map_1);
  };
  function replaceResponse(_this__u8e3s4, headers, content) {
    headers = headers === VOID ? _this__u8e3s4.ytq().dt2() : headers;
    return new DelegatedCall(_this__u8e3s4.ttq_1, _this__u8e3s4, content, headers);
  }
  function DelegatedCall(client, originCall, responseContent, responseHeaders) {
    responseHeaders = responseHeaders === VOID ? originCall.ytq().dt2() : responseHeaders;
    HttpClientCall.call(this, client);
    this.vtq_1 = new DelegatedRequest(this, originCall.ftt());
    this.wtq_1 = new DelegatedResponse(this, originCall.ytq(), responseContent, responseHeaders);
  }
  function DelegatedRequest(call, origin) {
    this.ktt_1 = origin;
    this.ltt_1 = call;
  }
  protoOf(DelegatedRequest).mtt = function () {
    return this.ltt_1;
  };
  protoOf(DelegatedRequest).q19 = function () {
    return this.ktt_1.q19();
  };
  protoOf(DelegatedRequest).ntt = function () {
    return this.ktt_1.ntt();
  };
  protoOf(DelegatedRequest).ott = function () {
    return this.ktt_1.ott();
  };
  protoOf(DelegatedRequest).gtt = function () {
    return this.ktt_1.gtt();
  };
  protoOf(DelegatedRequest).rj3 = function () {
    return this.ktt_1.rj3();
  };
  protoOf(DelegatedRequest).dt2 = function () {
    return this.ktt_1.dt2();
  };
  function DelegatedResponse(call, origin, content, headers) {
    headers = headers === VOID ? origin.dt2() : headers;
    HttpResponse.call(this);
    this.ptt_1 = call;
    this.qtt_1 = origin;
    this.rtt_1 = content;
    this.stt_1 = headers;
    this.ttt_1 = this.qtt_1.q19();
  }
  protoOf(DelegatedResponse).mtt = function () {
    return this.ptt_1;
  };
  protoOf(DelegatedResponse).dt2 = function () {
    return this.stt_1;
  };
  protoOf(DelegatedResponse).utt = function () {
    return this.rtt_1(this.qtt_1);
  };
  protoOf(DelegatedResponse).q19 = function () {
    return this.ttt_1;
  };
  protoOf(DelegatedResponse).zbq = function () {
    return this.qtt_1.zbq();
  };
  protoOf(DelegatedResponse).vtt = function () {
    return this.qtt_1.vtt();
  };
  protoOf(DelegatedResponse).wtt = function () {
    return this.qtt_1.wtt();
  };
  protoOf(DelegatedResponse).xtt = function () {
    return this.qtt_1.xtt();
  };
  function HttpClientCall_init_$Init$(client, requestData, responseData, $this) {
    HttpClientCall.call($this, client);
    $this.vtq_1 = new DefaultHttpRequest($this, requestData);
    $this.wtq_1 = new DefaultHttpResponse($this, responseData);
    $this.gtt().ysn(Companion_getInstance_8().ytt_1);
    var tmp = responseData.dtu_1;
    if (!isInterface(tmp, ByteReadChannel)) {
      $this.gtt().wsn(Companion_getInstance_8().ytt_1, responseData.dtu_1);
    }
    return $this;
  }
  function HttpClientCall_init_$Create$(client, requestData, responseData) {
    return HttpClientCall_init_$Init$(client, requestData, responseData, objectCreate(protoOf(HttpClientCall)));
  }
  function Companion() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'CustomResponse';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().gc();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.ytt_1 = new AttributeKey(name, tmp$ret$1);
  }
  var Companion_instance_0;
  function Companion_getInstance_8() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function $bodyNullableCOROUTINE$(_this__u8e3s4, info, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.otu_1 = _this__u8e3s4;
    this.ptu_1 = info;
  }
  protoOf($bodyNullableCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 4;
            if (instanceOf(this.otu_1.ytq(), this.ptu_1.bsu_1))
              return this.otu_1.ytq();
            if (!this.otu_1.htt() && !get_isSaved(this.otu_1.ytq()) && !this.otu_1.utq_1.atomicfu$compareAndSet(false, true)) {
              throw new DoubleReceiveException(this.otu_1);
            }

            var tmp0_elvis_lhs = this.otu_1.gtt().usn(Companion_getInstance_8().ytt_1);
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 1;
              suspendResult = this.otu_1.itt(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.qtu_1 = tmp0_elvis_lhs;
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.qtu_1 = suspendResult;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            var responseData = this.qtu_1;
            var subject = new HttpResponseContainer(this.ptu_1, responseData);
            this.n9_1 = 3;
            suspendResult = this.otu_1.ttq_1.utp_1.jst(this.otu_1, subject, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var this_0 = suspendResult.stu_1;
            var tmp_0;
            if (!equals(this_0, NullBody_instance)) {
              tmp_0 = this_0;
            } else {
              tmp_0 = null;
            }

            var result = tmp_0;
            if (!(result == null) && !instanceOf(result, this.ptu_1.bsu_1)) {
              var from = getKClassFromExpression(result);
              var to = this.ptu_1.bsu_1;
              throw new NoTransformationFoundException(this.otu_1.ytq(), from, to);
            }

            return result;
          case 4:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.q9_1;
              cancel_0(this.otu_1.ytq(), 'Receive failed', cause);
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpClientCall(client) {
    Companion_getInstance_8();
    this.ttq_1 = client;
    this.utq_1 = atomic$boolean$1(false);
    this.xtq_1 = false;
  }
  protoOf(HttpClientCall).q19 = function () {
    return this.ytq().q19();
  };
  protoOf(HttpClientCall).gtt = function () {
    return this.ftt().gtt();
  };
  protoOf(HttpClientCall).ftt = function () {
    var tmp = this.vtq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('request');
    }
  };
  protoOf(HttpClientCall).ytq = function () {
    var tmp = this.wtq_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('response');
    }
  };
  protoOf(HttpClientCall).htt = function () {
    return this.xtq_1;
  };
  protoOf(HttpClientCall).itt = function ($completion) {
    return this.ytq().utt();
  };
  protoOf(HttpClientCall).jtt = function (info, $completion) {
    var tmp = new $bodyNullableCOROUTINE$(this, info, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClientCall).toString = function () {
    return 'HttpClientCall[' + this.ftt().ott().toString() + ', ' + this.ytq().zbq().toString() + ']';
  };
  protoOf(HttpClientCall).ztq = function (response) {
    this.wtq_1 = response;
  };
  function DoubleReceiveException(call) {
    IllegalStateException_init_$Init$(this);
    captureStack(this, DoubleReceiveException);
    this.ttu_1 = 'Response already received: ' + call.toString();
    delete this.message;
  }
  protoOf(DoubleReceiveException).e = function () {
    return this.ttu_1;
  };
  function NoTransformationFoundException(response, from, to) {
    UnsupportedOperationException_init_$Init$(this);
    captureStack(this, NoTransformationFoundException);
    this.utu_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).ott().toString() + '`\n        Response status `' + response.zbq().toString() + '`\n        Response header `ContentType: ' + response.dt2().je('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).dt2().je('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
    delete this.message;
  }
  protoOf(NoTransformationFoundException).e = function () {
    return this.utu_1;
  };
  function save(_this__u8e3s4, $completion) {
    var tmp = new $saveCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function SavedHttpCall(client, request, response, responseBody) {
    HttpClientCall.call(this, client);
    this.jtv_1 = responseBody;
    this.vtq_1 = new SavedHttpRequest(this, request);
    this.wtq_1 = new SavedHttpResponse(this, this.jtv_1, response);
    checkContentLength(contentLength(response), fromInt(this.jtv_1.length), request.ntt());
    this.ktv_1 = true;
  }
  protoOf(SavedHttpCall).htt = function () {
    return this.ktv_1;
  };
  function SavedHttpRequest(call, origin) {
    this.ltv_1 = origin;
    this.mtv_1 = call;
  }
  protoOf(SavedHttpRequest).mtt = function () {
    return this.mtv_1;
  };
  protoOf(SavedHttpRequest).q19 = function () {
    return this.ltv_1.q19();
  };
  protoOf(SavedHttpRequest).ntt = function () {
    return this.ltv_1.ntt();
  };
  protoOf(SavedHttpRequest).ott = function () {
    return this.ltv_1.ott();
  };
  protoOf(SavedHttpRequest).gtt = function () {
    return this.ltv_1.gtt();
  };
  protoOf(SavedHttpRequest).rj3 = function () {
    return this.ltv_1.rj3();
  };
  protoOf(SavedHttpRequest).dt2 = function () {
    return this.ltv_1.dt2();
  };
  function SavedHttpResponse(call, body, origin) {
    HttpResponse.call(this);
    this.ntv_1 = call;
    this.otv_1 = body;
    this.ptv_1 = origin.zbq();
    this.qtv_1 = origin.vtt();
    this.rtv_1 = origin.wtt();
    this.stv_1 = origin.xtt();
    this.ttv_1 = origin.dt2();
    this.utv_1 = origin.q19();
  }
  protoOf(SavedHttpResponse).mtt = function () {
    return this.ntv_1;
  };
  protoOf(SavedHttpResponse).zbq = function () {
    return this.ptv_1;
  };
  protoOf(SavedHttpResponse).vtt = function () {
    return this.qtv_1;
  };
  protoOf(SavedHttpResponse).wtt = function () {
    return this.rtv_1;
  };
  protoOf(SavedHttpResponse).xtt = function () {
    return this.stv_1;
  };
  protoOf(SavedHttpResponse).dt2 = function () {
    return this.ttv_1;
  };
  protoOf(SavedHttpResponse).q19 = function () {
    return this.utv_1;
  };
  protoOf(SavedHttpResponse).utt = function () {
    return ByteReadChannel_0(this.otv_1);
  };
  function $saveCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.dtv_1 = _this__u8e3s4;
  }
  protoOf($saveCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = this.dtv_1;
            if (tmp_0 instanceof SavedHttpCall)
              return this.dtv_1;
            this.n9_1 = 1;
            suspendResult = readRemaining(this.dtv_1.ytq().utt(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            var responseBody = readByteArray(ARGUMENT);
            return new SavedHttpCall(this.dtv_1.ttq_1, this.dtv_1.ftt(), this.dtv_1.ytq(), responseBody);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function UnsupportedContentTypeException(content) {
    IllegalStateException_init_$Init$_0('Failed to write body: ' + toString(getKClassFromExpression(content)), this);
    captureStack(this, UnsupportedContentTypeException);
  }
  function getContent($this, delegate) {
    var tmp;
    if (delegate instanceof ContentWrapper) {
      tmp = getContent($this, delegate.gt8());
    } else {
      if (delegate instanceof ByteArrayContent) {
        tmp = ByteReadChannel_0(delegate.xt7());
      } else {
        if (delegate instanceof ProtocolUpgrade) {
          throw new UnsupportedContentTypeException(delegate);
        } else {
          if (delegate instanceof NoContent) {
            tmp = Companion_getInstance().pse_1;
          } else {
            if (delegate instanceof ReadChannelContent) {
              tmp = delegate.at8();
            } else {
              if (delegate instanceof WriteChannelContent) {
                var tmp_0 = GlobalScope_instance;
                tmp = writer(tmp_0, $this.xtv_1, true, ObservableContent$getContent$slambda_0(delegate, null)).lse_1;
              } else {
                noWhenBranchMatchedException();
              }
            }
          }
        }
      }
    }
    return tmp;
  }
  function ObservableContent$getContent$slambda($delegate, resultContinuation) {
    this.htw_1 = $delegate;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ObservableContent$getContent$slambda).vtc = function ($this$writer, $completion) {
    var tmp = this.wtc($this$writer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ObservableContent$getContent$slambda).ja = function (p1, $completion) {
    return this.vtc(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(ObservableContent$getContent$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.htw_1.ct8(this.itw_1.xsk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ObservableContent$getContent$slambda).wtc = function ($this$writer, completion) {
    var i = new ObservableContent$getContent$slambda(this.htw_1, completion);
    i.itw_1 = $this$writer;
    return i;
  };
  function ObservableContent$getContent$slambda_0($delegate, resultContinuation) {
    var i = new ObservableContent$getContent$slambda($delegate, resultContinuation);
    return constructCallableReference(function ($this$writer, $completion) {
      return i.vtc($this$writer, $completion);
    }, 1);
  }
  function ObservableContent(delegate, callContext, listener) {
    ReadChannelContent.call(this);
    this.wtv_1 = delegate;
    this.xtv_1 = callContext;
    this.ytv_1 = listener;
  }
  protoOf(ObservableContent).vt7 = function () {
    return this.wtv_1.vt7();
  };
  protoOf(ObservableContent).wt7 = function () {
    return this.wtv_1.wt7();
  };
  protoOf(ObservableContent).dt2 = function () {
    return this.wtv_1.dt2();
  };
  protoOf(ObservableContent).at8 = function () {
    return observable(getContent(this, this.wtv_1), this.xtv_1, this.wt7(), this.ytv_1);
  };
  function ProgressListener() {
  }
  function get_CALL_COROUTINE() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CALL_COROUTINE;
  }
  var CALL_COROUTINE;
  function get_CLIENT_CONFIG() {
    _init_properties_HttpClientEngine_kt__h91z5h();
    return CLIENT_CONFIG;
  }
  var CLIENT_CONFIG;
  function HttpClientEngine$install$slambda$lambda($client, $response) {
    return function (it) {
      var tmp;
      if (!(it == null)) {
        $client.ztp_1.usu(get_HttpResponseCancelled(), $response);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function _get_closed__iwkfs1($this) {
    var tmp0_safe_receiver = $this.q19().aa(Key_instance);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.r19();
    return !(tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs);
  }
  function executeWithinCallContext($this, requestData, $completion) {
    var tmp = new $executeWithinCallContextCOROUTINE$($this, requestData, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function checkExtensions($this, requestData) {
    var _iterator__ex2g4s = requestData.atx_1.t();
    while (_iterator__ex2g4s.u()) {
      var requestedExtension = _iterator__ex2g4s.v();
      // Inline function 'kotlin.require' call
      if (!$this.btx().m1(requestedExtension)) {
        var message = "Engine doesn't support " + toString(requestedExtension);
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
    }
  }
  function HttpClientEngine$install$slambda($client, this$0, resultContinuation) {
    this.ktx_1 = $client;
    this.ltx_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$install$slambda).rtq = function ($this$intercept, content, $completion) {
    var tmp = this.stq($this$intercept, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClientEngine$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var this_0 = new HttpRequestBuilder();
            this_0.ptx(this.mtx_1.kst_1);
            var body = this.ntx_1;
            if (body == null) {
              this_0.bts_1 = NullBody_instance;
              var tmp_0 = PrimitiveClasses_getInstance().gc();
              var tmp_1;
              try {
                tmp_1 = createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), false);
              } catch ($p) {
                var tmp_2;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_2 = null;
                } else {
                  throw $p;
                }
                tmp_1 = tmp_2;
              }
              this_0.qtx(new TypeInfo(tmp_0, tmp_1));
            } else {
              if (body instanceof OutgoingContent) {
                this_0.bts_1 = body;
                this_0.qtx(null);
              } else {
                this_0.bts_1 = body;
                var tmp_3 = PrimitiveClasses_getInstance().gc();
                var tmp_4;
                try {
                  tmp_4 = createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), false);
                } catch ($p_0) {
                  var tmp_5;
                  if ($p_0 instanceof Error) {
                    var _unused_var__etf5q3_0 = $p_0;
                    tmp_5 = null;
                  } else {
                    throw $p_0;
                  }
                  tmp_4 = tmp_5;
                }
                this_0.qtx(new TypeInfo(tmp_3, tmp_4));
              }
            }

            var builder = this_0;
            this.ktx_1.ztp_1.usu(get_HttpRequestIsReadyForSending(), builder);
            var tmp_6 = this;
            var this_1 = builder.g3d();
            this_1.ztw_1.wsn(get_CLIENT_CONFIG(), this.ktx_1.atq_1);
            tmp_6.otx_1 = this_1;
            validateHeaders(this.otx_1);
            checkExtensions(this.ltx_1, this.otx_1);
            this.n9_1 = 1;
            suspendResult = executeWithinCallContext(this.ltx_1, this.otx_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var responseData = suspendResult;
            var call = HttpClientCall_init_$Create$(this.ktx_1, this.otx_1, responseData);
            var response = call.ytq();
            this.ktx_1.ztp_1.usu(get_HttpResponseReceived(), response);
            var tmp_7 = get_job(response.q19());
            tmp_7.t1a(HttpClientEngine$install$slambda$lambda(this.ktx_1, response));
            this.n9_1 = 2;
            suspendResult = this.mtx_1.pss(call, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p_1) {
        var e = $p_1;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$install$slambda).stq = function ($this$intercept, content, completion) {
    var i = new HttpClientEngine$install$slambda(this.ktx_1, this.ltx_1, completion);
    i.mtx_1 = $this$intercept;
    i.ntx_1 = content;
    return i;
  };
  function HttpClientEngine$install$slambda_0($client, this$0, resultContinuation) {
    var i = new HttpClientEngine$install$slambda($client, this$0, resultContinuation);
    return constructCallableReference(function ($this$intercept, content, $completion) {
      return i.rtq($this$intercept, content, $completion);
    }, 2);
  }
  function HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation) {
    this.ztx_1 = this$0;
    this.aty_1 = $requestData;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).cty = function ($this$async, $completion) {
    var tmp = this.q24($this$async, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).ja = function (p1, $completion) {
    return this.cty((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (_get_closed__iwkfs1(this.ztx_1)) {
              throw new ClientEngineClosedException();
            }

            this.n9_1 = 1;
            suspendResult = this.ztx_1.dty(this.aty_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpClientEngine$executeWithinCallContext$slambda).q24 = function ($this$async, completion) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this.ztx_1, this.aty_1, completion);
    i.bty_1 = $this$async;
    return i;
  };
  function HttpClientEngine$executeWithinCallContext$slambda_0(this$0, $requestData, resultContinuation) {
    var i = new HttpClientEngine$executeWithinCallContext$slambda(this$0, $requestData, resultContinuation);
    return constructCallableReference(function ($this$async, $completion) {
      return i.cty($this$async, $completion);
    }, 1);
  }
  function $executeWithinCallContextCOROUTINE$(_this__u8e3s4, requestData, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.stw_1 = _this__u8e3s4;
    this.ttw_1 = requestData;
  }
  protoOf($executeWithinCallContextCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = createCallContext(this.stw_1, this.ttw_1.ytw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var callContext = suspendResult;
            var context = callContext.xj(new KtorCallContextElement(callContext));
            this.n9_1 = 2;
            suspendResult = async(this.stw_1, context, VOID, HttpClientEngine$executeWithinCallContext$slambda_0(this.stw_1, this.ttw_1, null)).r1c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpClientEngine() {
  }
  function validateHeaders(request) {
    _init_properties_HttpClientEngine_kt__h91z5h();
    var requestHeaders = request.wtw_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = requestHeaders.csq();
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (HttpHeaders_getInstance().vt1_1.m1(element)) {
        destination.j1(element);
      }
    }
    var unsafeRequestHeaders = destination;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!unsafeRequestHeaders.r()) {
      throw new UnsafeHeaderException(toString(unsafeRequestHeaders));
    }
  }
  function createCallContext(_this__u8e3s4, parentJob, $completion) {
    var callJob = Job(parentJob);
    var callContext = _this__u8e3s4.q19().xj(callJob).xj(get_CALL_COROUTINE());
    $l$block: {
      // Inline function 'io.ktor.client.engine.attachToUserJob' call
      // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
      // Inline function 'kotlin.js.getCoroutineContext' call
      var tmp0_elvis_lhs = $completion.t9().aa(Key_instance);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var userJob = tmp;
      var cleanupHandler = userJob.v1a(true, VOID, createCallContext$lambda(callJob));
      callJob.t1a(createCallContext$lambda_0(cleanupHandler));
    }
    return callContext;
  }
  function createCallContext$lambda($callJob) {
    return function (cause) {
      if (cause == null)
        return Unit_instance;
      var tmp1_elvis_lhs = cause instanceof CancellationException ? cause : null;
      var cancellation = tmp1_elvis_lhs == null ? CancellationException_init_$Create$_0(cause.message) : tmp1_elvis_lhs;
      $callJob.a1b(cancellation);
      return Unit_instance;
    };
  }
  function createCallContext$lambda_0($cleanupHandler) {
    return function (it) {
      $cleanupHandler.s1d();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpClientEngine_kt_5uiebb;
  function _init_properties_HttpClientEngine_kt__h91z5h() {
    if (!properties_initialized_HttpClientEngine_kt_5uiebb) {
      properties_initialized_HttpClientEngine_kt_5uiebb = true;
      CALL_COROUTINE = new CoroutineName('call-context');
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'client-config';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(HttpClientConfig);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(HttpClientConfig), arrayOf([getStarKTypeProjection()]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      CLIENT_CONFIG = new AttributeKey(name, tmp$ret$1);
    }
  }
  function HttpClientEngineBase$dispatcher$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.ebw().fty_1;
      return tmp0_elvis_lhs == null ? ioDispatcher() : tmp0_elvis_lhs;
    };
  }
  function HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v() {
    return constructCallableReference(function (p0) {
      return p0.ity();
    }, 1, 0, 503);
  }
  function HttpClientEngineBase$coroutineContext$delegate$lambda(this$0) {
    return function () {
      return SilentSupervisor().xj(this$0.ity()).xj(new CoroutineName(this$0.btq_1 + '-context'));
    };
  }
  function HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr() {
    return constructCallableReference(function (p0) {
      return p0.q19();
    }, 1, 0, 504);
  }
  function HttpClientEngineBase(engineName) {
    this.btq_1 = engineName;
    this.ctq_1 = atomic$boolean$1(false);
    this.dtq_1 = atomic$int$1(0);
    var tmp = this;
    tmp.etq_1 = lazy(HttpClientEngineBase$dispatcher$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.ftq_1 = lazy(HttpClientEngineBase$coroutineContext$delegate$lambda(this));
  }
  protoOf(HttpClientEngineBase).ity = function () {
    var tmp0 = this.etq_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('dispatcher', 1, tmp, HttpClientEngineBase$_get_dispatcher_$ref_kz5x8v(), null);
    return tmp0.u1();
  };
  protoOf(HttpClientEngineBase).q19 = function () {
    var tmp0 = this.ftq_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('coroutineContext', 1, tmp, HttpClientEngineBase$_get_coroutineContext_$ref_p82ehr(), null);
    return tmp0.u1();
  };
  protoOf(HttpClientEngineBase).j4 = function () {
    if (!this.ctq_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    var tmp = this.q19().aa(Key_instance);
    var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, CompletableJob) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    var requestJob = tmp_0;
    requestJob.w1g();
  };
  function ClientEngineClosedException(cause) {
    cause = cause === VOID ? null : cause;
    IllegalStateException_init_$Init$_0('Client already closed', this);
    captureStack(this, ClientEngineClosedException);
    this.jty_1 = cause;
    delete this.cause;
  }
  protoOf(ClientEngineClosedException).f = function () {
    return this.jty_1;
  };
  function get_ENGINE_CAPABILITIES_KEY() {
    _init_properties_HttpClientEngineCapability_kt__ifvyst();
    return ENGINE_CAPABILITIES_KEY;
  }
  var ENGINE_CAPABILITIES_KEY;
  var DEFAULT_CAPABILITIES;
  function HttpClientEngineCapability() {
  }
  var properties_initialized_HttpClientEngineCapability_kt_qarzcf;
  function _init_properties_HttpClientEngineCapability_kt__ifvyst() {
    if (!properties_initialized_HttpClientEngineCapability_kt_qarzcf) {
      properties_initialized_HttpClientEngineCapability_kt_qarzcf = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'EngineCapabilities';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(KtMutableMap);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(KtMutableMap), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpClientEngineCapability), arrayOf([getStarKTypeProjection()]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), false))]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      ENGINE_CAPABILITIES_KEY = new AttributeKey(name, tmp$ret$1);
      DEFAULT_CAPABILITIES = setOf(HttpTimeoutCapability_instance);
    }
  }
  function HttpClientEngineConfig() {
    this.ety_1 = 4;
    this.fty_1 = null;
    this.gty_1 = false;
    this.hty_1 = null;
  }
  function HttpClientEngineFactory$create$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function HttpClientEngineFactory() {
  }
  function get_KTOR_DEFAULT_USER_AGENT() {
    _init_properties_Utils_kt__jo07cx();
    return KTOR_DEFAULT_USER_AGENT;
  }
  var KTOR_DEFAULT_USER_AGENT;
  function get_DATE_HEADERS() {
    _init_properties_Utils_kt__jo07cx();
    return DATE_HEADERS;
  }
  var DATE_HEADERS;
  function Companion_0() {
  }
  var Companion_instance_1;
  function Companion_getInstance_9() {
    return Companion_instance_1;
  }
  function KtorCallContextElement(callContext) {
    this.lty_1 = callContext;
  }
  protoOf(KtorCallContextElement).t1 = function () {
    return Companion_instance_1;
  };
  function callContext($completion) {
    // Inline function 'kotlin.js.getCoroutineContext' call
    var tmp$ret$0 = $completion.t9();
    return ensureNotNull(tmp$ret$0.aa(Companion_instance_1)).lty_1;
  }
  function mergeHeaders(requestHeaders, content, block) {
    _init_properties_Utils_kt__jo07cx();
    var tmp = buildHeaders(mergeHeaders$lambda(requestHeaders, content));
    tmp.hsq(mergeHeaders$lambda_0(block));
    var missingAgent = requestHeaders.je('User-Agent') == null && content.dt2().je('User-Agent') == null;
    if (missingAgent && needUserAgent()) {
      block('User-Agent', get_KTOR_DEFAULT_USER_AGENT());
    }
    var tmp0_safe_receiver = content.vt7();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.toString();
    var tmp2_elvis_lhs = tmp1_elvis_lhs == null ? content.dt2().je('Content-Type') : tmp1_elvis_lhs;
    var type = tmp2_elvis_lhs == null ? requestHeaders.je('Content-Type') : tmp2_elvis_lhs;
    var tmp3_safe_receiver = content.wt7();
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    var tmp5_elvis_lhs = tmp4_elvis_lhs == null ? content.dt2().je('Content-Length') : tmp4_elvis_lhs;
    var length = tmp5_elvis_lhs == null ? requestHeaders.je('Content-Length') : tmp5_elvis_lhs;
    if (type == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      block('Content-Type', type);
    }
    if (length == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      block('Content-Length', length);
    }
  }
  function needUserAgent() {
    _init_properties_Utils_kt__jo07cx();
    return !PlatformUtils_getInstance().nsp_1;
  }
  function mergeHeaders$lambda($requestHeaders, $content) {
    return function ($this$buildHeaders) {
      $this$buildHeaders.gsq($requestHeaders);
      $this$buildHeaders.gsq($content.dt2());
      return Unit_instance;
    };
  }
  function mergeHeaders$lambda_0($block) {
    return function (key, values) {
      var tmp;
      if ('Content-Length' === key) {
        return Unit_instance;
      }
      var tmp_0;
      if ('Content-Type' === key) {
        return Unit_instance;
      }
      var tmp_1;
      if (get_DATE_HEADERS().m1(key)) {
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = values.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          $block(key, element);
        }
        tmp_1 = Unit_instance;
      } else {
        var separator = 'Cookie' === key ? '; ' : ',';
        tmp_1 = $block(key, joinToString(values, separator));
      }
      return Unit_instance;
    };
  }
  var properties_initialized_Utils_kt_xvi83j;
  function _init_properties_Utils_kt__jo07cx() {
    if (!properties_initialized_Utils_kt_xvi83j) {
      properties_initialized_Utils_kt_xvi83j = true;
      KTOR_DEFAULT_USER_AGENT = 'ktor-client';
      DATE_HEADERS = setOf_0(['Date', 'Expires', 'Last-Modified', 'If-Modified-Since', 'If-Unmodified-Since']);
    }
  }
  function get_UploadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return UploadProgressListenerAttributeKey;
  }
  var UploadProgressListenerAttributeKey;
  function get_DownloadProgressListenerAttributeKey() {
    _init_properties_BodyProgress_kt__s0v569();
    return DownloadProgressListenerAttributeKey;
  }
  var DownloadProgressListenerAttributeKey;
  function get_BodyProgress() {
    _init_properties_BodyProgress_kt__s0v569();
    return BodyProgress;
  }
  var BodyProgress;
  function AfterRenderHook$install$slambda($handler, resultContinuation) {
    this.uty_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AfterRenderHook$install$slambda).rtq = function ($this$intercept, content, $completion) {
    var tmp = this.stq($this$intercept, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AfterRenderHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(AfterRenderHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this.wty_1;
            if (!(tmp_0 instanceof OutgoingContent))
              return Unit_instance;
            this.n9_1 = 1;
            suspendResult = this.uty_1(this.vty_1.kst_1, this.wty_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            var newContent = tmp_1;
            this.n9_1 = 2;
            suspendResult = this.vty_1.pss(newContent, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AfterRenderHook$install$slambda).stq = function ($this$intercept, content, completion) {
    var i = new AfterRenderHook$install$slambda(this.uty_1, completion);
    i.vty_1 = $this$intercept;
    i.wty_1 = content;
    return i;
  };
  function AfterRenderHook$install$slambda_0($handler, resultContinuation) {
    var i = new AfterRenderHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, content, $completion) {
      return i.rtq($this$intercept, content, $completion);
    }, 2);
  }
  function AfterRenderHook() {
  }
  protoOf(AfterRenderHook).xty = function (client, handler) {
    var observableContentPhase = new PipelinePhase('ObservableContent');
    client.ttp_1.lst(Phases_getInstance_0().btz_1, observableContentPhase);
    client.ttp_1.ost(observableContentPhase, AfterRenderHook$install$slambda_0(handler, null));
  };
  protoOf(AfterRenderHook).dtz = function (client, handler) {
    return this.xty(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var AfterRenderHook_instance;
  function AfterRenderHook_getInstance() {
    return AfterRenderHook_instance;
  }
  function AfterReceiveHook$install$slambda($handler, resultContinuation) {
    this.mtz_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AfterReceiveHook$install$slambda).ptz = function ($this$intercept, response, $completion) {
    var tmp = this.qtz($this$intercept, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AfterReceiveHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.ptz(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(AfterReceiveHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.mtz_1(this.otz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newResponse = suspendResult;
            if (!(newResponse == null)) {
              this.n9_1 = 2;
              suspendResult = this.ntz_1.pss(newResponse, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AfterReceiveHook$install$slambda).qtz = function ($this$intercept, response, completion) {
    var i = new AfterReceiveHook$install$slambda(this.mtz_1, completion);
    i.ntz_1 = $this$intercept;
    i.otz_1 = response;
    return i;
  };
  function AfterReceiveHook$install$slambda_0($handler, resultContinuation) {
    var i = new AfterReceiveHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, response, $completion) {
      return i.ptz($this$intercept, response, $completion);
    }, 2);
  }
  function AfterReceiveHook() {
  }
  protoOf(AfterReceiveHook).rtz = function (client, handler) {
    var tmp = Phases_getInstance_1().utz_1;
    client.wtp_1.ost(tmp, AfterReceiveHook$install$slambda_0(handler, null));
  };
  protoOf(AfterReceiveHook).dtz = function (client, handler) {
    return this.rtz(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
  };
  var AfterReceiveHook_instance;
  function AfterReceiveHook_getInstance() {
    return AfterReceiveHook_instance;
  }
  function withObservableDownload(_this__u8e3s4, listener) {
    _init_properties_BodyProgress_kt__s0v569();
    var tmp = _this__u8e3s4.mtt();
    return replaceResponse(tmp, VOID, withObservableDownload$lambda(listener)).ytq();
  }
  function BodyProgress$lambda($this$createClientPlugin) {
    _init_properties_BodyProgress_kt__s0v569();
    var tmp = AfterRenderHook_instance;
    $this$createClientPlugin.au0(tmp, BodyProgress$lambda$slambda_0(null));
    var tmp_0 = AfterReceiveHook_instance;
    $this$createClientPlugin.au0(tmp_0, BodyProgress$lambda$slambda_2(null));
    return Unit_instance;
  }
  function BodyProgress$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$lambda$slambda).lu0 = function (request, content, $completion) {
    var tmp = this.mu0(request, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BodyProgress$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
    return this.lu0(tmp, p2 instanceof OutgoingContent ? p2 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_elvis_lhs = this.ju0_1.dts_1.usn(get_UploadProgressListenerAttributeKey());
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var listener = tmp_0;
          return new ObservableContent(this.ku0_1, this.ju0_1.cts_1, listener);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BodyProgress$lambda$slambda).mu0 = function (request, content, completion) {
    var i = new BodyProgress$lambda$slambda(completion);
    i.ju0_1 = request;
    i.ku0_1 = content;
    return i;
  };
  function BodyProgress$lambda$slambda_0(resultContinuation) {
    var i = new BodyProgress$lambda$slambda(resultContinuation);
    return constructCallableReference(function (request, content, $completion) {
      return i.lu0(request, content, $completion);
    }, 2);
  }
  function BodyProgress$lambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(BodyProgress$lambda$slambda_1).wu0 = function (response, $completion) {
    var tmp = this.xu0(response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(BodyProgress$lambda$slambda_1).ja = function (p1, $completion) {
    return this.wu0(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(BodyProgress$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_elvis_lhs = this.vu0_1.mtt().ftt().gtt().usn(get_DownloadProgressListenerAttributeKey());
          var tmp_0;
          if (tmp0_elvis_lhs == null) {
            return null;
          } else {
            tmp_0 = tmp0_elvis_lhs;
          }
          var listener = tmp_0;
          return withObservableDownload(this.vu0_1, listener);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(BodyProgress$lambda$slambda_1).xu0 = function (response, completion) {
    var i = new BodyProgress$lambda$slambda_1(completion);
    i.vu0_1 = response;
    return i;
  };
  function BodyProgress$lambda$slambda_2(resultContinuation) {
    var i = new BodyProgress$lambda$slambda_1(resultContinuation);
    return constructCallableReference(function (response, $completion) {
      return i.wu0(response, $completion);
    }, 1);
  }
  function withObservableDownload$lambda($listener) {
    return function ($this$replaceResponse) {
      return observable($this$replaceResponse.utt(), $this$replaceResponse.q19(), contentLength($this$replaceResponse), $listener);
    };
  }
  var properties_initialized_BodyProgress_kt_pmfrhr;
  function _init_properties_BodyProgress_kt__s0v569() {
    if (!properties_initialized_BodyProgress_kt_pmfrhr) {
      properties_initialized_BodyProgress_kt_pmfrhr = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'UploadProgressListenerAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(ProgressListener);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(ProgressListener), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      UploadProgressListenerAttributeKey = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'DownloadProgressListenerAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = getKClass(ProgressListener);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(getKClass(ProgressListener), arrayOf([]), false);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_4 = null;
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$2_0 = tmp_3;
      var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
      DownloadProgressListenerAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
      BodyProgress = createClientPlugin_0('BodyProgress', BodyProgress$lambda);
    }
  }
  function get_LOGGER() {
    _init_properties_DefaultRequest_kt__yzsodq();
    return LOGGER;
  }
  var LOGGER;
  function DefaultRequest$Plugin$install$slambda$lambda() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function mergeUrls($this, baseUrl, requestUrl) {
    if (requestUrl.kt5_1 == null) {
      requestUrl.kt5_1 = baseUrl.ft6_1;
    }
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_0 = requestUrl.ht5_1;
    if (charSequenceLength(this_0) > 0)
      return Unit_instance;
    var resultUrl = URLBuilder(baseUrl);
    // Inline function 'kotlin.with' call
    resultUrl.kt5_1 = requestUrl.kt5_1;
    if (!(requestUrl.jt5_1 === 0)) {
      resultUrl.pt6(requestUrl.jt5_1);
    }
    resultUrl.ot5_1 = concatenatePath(Plugin_getInstance(), resultUrl.ot5_1, requestUrl.ot5_1);
    // Inline function 'kotlin.text.isNotEmpty' call
    var this_1 = requestUrl.nt5_1;
    if (charSequenceLength(this_1) > 0) {
      resultUrl.nt5_1 = requestUrl.nt5_1;
    }
    // Inline function 'kotlin.apply' call
    var this_2 = ParametersBuilder();
    appendAll(this_2, resultUrl.pt5_1);
    var defaultParameters = this_2;
    resultUrl.et7(requestUrl.pt5_1);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = defaultParameters.vsp().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var key = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var values = element.u1();
      if (!resultUrl.pt5_1.wso(key)) {
        resultUrl.pt5_1.wsp(key, values);
      }
    }
    takeFrom(requestUrl, resultUrl);
  }
  function concatenatePath($this, parent, child) {
    if (child.r())
      return parent;
    if (parent.r())
      return child;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = first(child);
    if (charSequenceLength(this_0) === 0)
      return child;
    // Inline function 'kotlin.collections.buildList' call
    // Inline function 'kotlin.collections.buildListInternal' call
    var capacity = (parent.n1() + child.n1() | 0) - 1 | 0;
    checkBuilderCapacity(capacity);
    // Inline function 'kotlin.apply' call
    var this_1 = ArrayList_init_$Create$_0(capacity);
    var inductionVariable = 0;
    var last = parent.n1() - 1 | 0;
    if (inductionVariable < last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_1.j1(parent.l1(index));
      }
       while (inductionVariable < last);
    this_1.o1(child);
    return this_1.t5();
  }
  function DefaultRequest$Plugin$install$slambda($plugin, resultContinuation) {
    this.gu1_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultRequest$Plugin$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultRequest$Plugin$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(DefaultRequest$Plugin$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var originalUrlString = this.hu1_1.kst_1.ytr_1.toString();
          var this_0 = new DefaultRequestBuilder();
          appendAll(this_0.ju1_1, this.hu1_1.kst_1.ats_1);
          var userHeaders = this_0.ju1_1.g3d();
          this.gu1_1.mu1_1(this_0);
          var _iterator__ex2g4s = userHeaders.vsp().t();
          while (_iterator__ex2g4s.u()) {
            var element = _iterator__ex2g4s.v();
            l$ret$1: do {
              var key = element.t1();
              var oldValues = element.u1();
              var newValues = this_0.ju1_1.bsq(key);
              if (newValues == null) {
                this_0.ju1_1.wsp(key, oldValues);
                break l$ret$1;
              }
              if (equals(newValues, oldValues) || key === 'Cookie') {
                break l$ret$1;
              }
              this_0.ju1_1.jsq(key);
              this_0.ju1_1.wsp(key, oldValues);
              this_0.ju1_1.isq(key, newValues);
            }
             while (false);
          }
          var defaultRequest = this_0;
          var defaultUrl = defaultRequest.ku1_1.g3d();
          mergeUrls(Plugin_getInstance(), defaultUrl, this.hu1_1.kst_1.ytr_1);
          var _iterator__ex2g4s_0 = defaultRequest.lu1_1.aso().t();
          while (_iterator__ex2g4s_0.u()) {
            var element_0 = _iterator__ex2g4s_0.v();
            if (element_0.equals(get_ENGINE_CAPABILITIES_KEY())) {
              var tmp_0 = get_ENGINE_CAPABILITIES_KEY();
              var capabilities = this.hu1_1.kst_1.dts_1.zsn(tmp_0, DefaultRequest$Plugin$install$slambda$lambda);
              var _iterator__ex2g4s_1 = defaultRequest.lu1_1.tsn(get_ENGINE_CAPABILITIES_KEY()).s1().t();
              while (_iterator__ex2g4s_1.u()) {
                var _destruct__k2r9zo = _iterator__ex2g4s_1.v();
                var key_0 = _destruct__k2r9zo.t1();
                var value = _destruct__k2r9zo.u1();
                if (!(isInterface(capabilities, KtMap) ? capabilities : THROW_CCE()).u2(key_0)) {
                  capabilities.z2(key_0, value);
                }
              }
            } else if (!this.hu1_1.kst_1.dts_1.vsn(element_0)) {
              this.hu1_1.kst_1.dts_1.wsn(element_0 instanceof AttributeKey ? element_0 : THROW_CCE(), defaultRequest.lu1_1.tsn(element_0));
            }
          }
          this.hu1_1.kst_1.ats_1.c3();
          this.hu1_1.kst_1.ats_1.gsq(defaultRequest.ju1_1.g3d());
          get_LOGGER().hsu('Applied DefaultRequest to ' + originalUrlString + '. New url: ' + this.hu1_1.kst_1.ytr_1.toString());
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DefaultRequest$Plugin$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new DefaultRequest$Plugin$install$slambda(this.gu1_1, completion);
    i.hu1_1 = $this$intercept;
    i.iu1_1 = it;
    return i;
  };
  function DefaultRequest$Plugin$install$slambda_0($plugin, resultContinuation) {
    var i = new DefaultRequest$Plugin$install$slambda($plugin, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function Plugin() {
    Plugin_instance = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'DefaultRequest';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(DefaultRequest);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(DefaultRequest), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.nu1_1 = new AttributeKey(name, tmp$ret$1);
  }
  protoOf(Plugin).t1 = function () {
    return this.nu1_1;
  };
  protoOf(Plugin).ou1 = function (block) {
    return new DefaultRequest(block);
  };
  protoOf(Plugin).ctt = function (block) {
    return this.ou1(block);
  };
  protoOf(Plugin).pu1 = function (plugin, scope) {
    var tmp = Phases_getInstance_0().yty_1;
    scope.ttp_1.ost(tmp, DefaultRequest$Plugin$install$slambda_0(plugin, null));
  };
  protoOf(Plugin).dtt = function (plugin, scope) {
    return this.pu1(plugin instanceof DefaultRequest ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance;
  function Plugin_getInstance() {
    if (Plugin_instance == null)
      new Plugin();
    return Plugin_instance;
  }
  function DefaultRequestBuilder() {
    this.ju1_1 = new HeadersBuilder();
    this.ku1_1 = new URLBuilder_0();
    this.lu1_1 = AttributesJsFn(true);
  }
  protoOf(DefaultRequestBuilder).dt2 = function () {
    return this.ju1_1;
  };
  protoOf(DefaultRequestBuilder).pt6 = function (value) {
    this.ku1_1.pt6(value);
  };
  protoOf(DefaultRequestBuilder).qu1 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.ju1_1;
    block(this_0);
    return this_0;
  };
  function DefaultRequest(block) {
    Plugin_getInstance();
    this.mu1_1 = block;
  }
  var properties_initialized_DefaultRequest_kt_au5efk;
  function _init_properties_DefaultRequest_kt__yzsodq() {
    if (!properties_initialized_DefaultRequest_kt_au5efk) {
      properties_initialized_DefaultRequest_kt_au5efk = true;
      LOGGER = KtorSimpleLogger('io.ktor.client.plugins.DefaultRequest');
    }
  }
  function get_ValidateMark() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return ValidateMark;
  }
  var ValidateMark;
  function get_LOGGER_0() {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    return LOGGER_0;
  }
  var LOGGER_0;
  function addDefaultResponseValidation(_this__u8e3s4) {
    _init_properties_DefaultResponseValidation_kt__wcn8vr();
    HttpResponseValidator(_this__u8e3s4, addDefaultResponseValidation$lambda(_this__u8e3s4));
  }
  function ResponseException(response, cachedResponseText) {
    IllegalStateException_init_$Init$_0('Bad response: ' + response.toString() + '. Text: "' + cachedResponseText + '"', this);
    captureStack(this, ResponseException);
    this.ru1_1 = response;
  }
  function RedirectResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, RedirectResponseException);
    this.tu1_1 = 'Unhandled redirect: ' + response.mtt().ftt().ntt().ot2_1 + ' ' + response.mtt().ftt().ott().toString() + '. ' + ('Status: ' + response.zbq().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(RedirectResponseException).e = function () {
    return this.tu1_1;
  };
  function ClientRequestException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ClientRequestException);
    this.vu1_1 = 'Client request(' + response.mtt().ftt().ntt().ot2_1 + ' ' + response.mtt().ftt().ott().toString() + ') ' + ('invalid: ' + response.zbq().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(ClientRequestException).e = function () {
    return this.vu1_1;
  };
  function ServerResponseException(response, cachedResponseText) {
    ResponseException.call(this, response, cachedResponseText);
    captureStack(this, ServerResponseException);
    this.xu1_1 = 'Server error(' + response.mtt().ftt().ntt().ot2_1 + ' ' + response.mtt().ftt().ott().toString() + ': ' + (response.zbq().toString() + '. Text: "' + cachedResponseText + '"');
    delete this.message;
  }
  protoOf(ServerResponseException).e = function () {
    return this.xu1_1;
  };
  function addDefaultResponseValidation$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(addDefaultResponseValidation$lambda$slambda).ku2 = function (response, $completion) {
    var tmp = this.xu0(response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).ja = function (p1, $completion) {
    return this.ku2(p1 instanceof HttpResponse ? p1 : THROW_CCE(), $completion);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            var expectSuccess = this.gu2_1.mtt().gtt().tsn(get_ExpectSuccessAttributeKey());
            if (!expectSuccess) {
              get_LOGGER_0().hsu('Skipping default response validation for ' + this.gu2_1.mtt().ftt().ott().toString());
              return Unit_instance;
            }

            this.iu2_1 = this.gu2_1.zbq().yt2_1;
            var originCall = this.gu2_1.mtt();
            if (this.iu2_1 < 300 || originCall.gtt().vsn(get_ValidateMark())) {
              return Unit_instance;
            }

            this.n9_1 = 1;
            suspendResult = save(originCall, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var this_0 = suspendResult;
            this_0.gtt().wsn(get_ValidateMark(), Unit_instance);
            var exceptionCall = this_0;
            this.hu2_1 = exceptionCall.ytq();
            this.o9_1 = 3;
            this.n9_1 = 2;
            suspendResult = bodyAsText(this.hu2_1, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.ju2_1 = suspendResult;
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof MalformedInputException) {
              var _unused_var__etf5q3 = this.q9_1;
              var tmp_1 = this;
              tmp_1.ju2_1 = '<body failed decoding>';
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            var exceptionResponseText = this.ju2_1;
            var tmp0_subject = this.iu2_1;
            var exception = (300 <= tmp0_subject ? tmp0_subject <= 399 : false) ? new RedirectResponseException(this.hu2_1, exceptionResponseText) : (400 <= tmp0_subject ? tmp0_subject <= 499 : false) ? new ClientRequestException(this.hu2_1, exceptionResponseText) : (500 <= tmp0_subject ? tmp0_subject <= 599 : false) ? new ServerResponseException(this.hu2_1, exceptionResponseText) : new ResponseException(this.hu2_1, exceptionResponseText);
            get_LOGGER_0().hsu('Default response validation for ' + this.gu2_1.mtt().ftt().ott().toString() + ' failed with ' + exception.toString());
            throw exception;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(addDefaultResponseValidation$lambda$slambda).xu0 = function (response, completion) {
    var i = new addDefaultResponseValidation$lambda$slambda(completion);
    i.gu2_1 = response;
    return i;
  };
  function addDefaultResponseValidation$lambda$slambda_0(resultContinuation) {
    var i = new addDefaultResponseValidation$lambda$slambda(resultContinuation);
    return constructCallableReference(function (response, $completion) {
      return i.ku2(response, $completion);
    }, 1);
  }
  function addDefaultResponseValidation$lambda($this_addDefaultResponseValidation) {
    return function ($this$HttpResponseValidator) {
      $this$HttpResponseValidator.nu2_1 = $this_addDefaultResponseValidation.qts_1;
      $this$HttpResponseValidator.ou2(addDefaultResponseValidation$lambda$slambda_0(null));
      return Unit_instance;
    };
  }
  var properties_initialized_DefaultResponseValidation_kt_akvzqt;
  function _init_properties_DefaultResponseValidation_kt__wcn8vr() {
    if (!properties_initialized_DefaultResponseValidation_kt_akvzqt) {
      properties_initialized_DefaultResponseValidation_kt_akvzqt = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'ValidateMark';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(Unit);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      ValidateMark = new AttributeKey(name, tmp$ret$1);
      LOGGER_0 = KtorSimpleLogger('io.ktor.client.plugins.DefaultResponseValidation');
    }
  }
  function get_LOGGER_1() {
    _init_properties_DefaultTransform_kt__20knxx();
    return LOGGER_1;
  }
  var LOGGER_1;
  function defaultTransformers(_this__u8e3s4) {
    _init_properties_DefaultTransform_kt__20knxx();
    var tmp = Phases_getInstance_0().btz_1;
    _this__u8e3s4.ttp_1.ost(tmp, defaultTransformers$slambda_0(null));
    var tmp_0 = Phases_getInstance_2().wts_1;
    _this__u8e3s4.utp_1.ost(tmp_0, defaultTransformers$slambda_2(_this__u8e3s4, null));
    platformResponseDefaultTransformers(_this__u8e3s4);
  }
  function defaultTransformers$1$content$1($contentType, $body) {
    this.su2_1 = $body;
    ByteArrayContent.call(this);
    var tmp = this;
    tmp.qu2_1 = $contentType == null ? Application_getInstance().nsv_1 : $contentType;
    this.ru2_1 = fromInt($body.length);
  }
  protoOf(defaultTransformers$1$content$1).vt7 = function () {
    return this.qu2_1;
  };
  protoOf(defaultTransformers$1$content$1).wt7 = function () {
    return this.ru2_1;
  };
  protoOf(defaultTransformers$1$content$1).xt7 = function () {
    return this.su2_1;
  };
  function defaultTransformers$1$content$2($this_intercept, $contentType, $body) {
    this.wu2_1 = $body;
    ReadChannelContent.call(this);
    var tmp = this;
    var tmp0_safe_receiver = $this_intercept.kst_1.ats_1.je('Content-Length');
    tmp.uu2_1 = tmp0_safe_receiver == null ? null : toLong(tmp0_safe_receiver);
    var tmp_0 = this;
    tmp_0.vu2_1 = $contentType == null ? Application_getInstance().nsv_1 : $contentType;
  }
  protoOf(defaultTransformers$1$content$2).wt7 = function () {
    return this.uu2_1;
  };
  protoOf(defaultTransformers$1$content$2).vt7 = function () {
    return this.vu2_1;
  };
  protoOf(defaultTransformers$1$content$2).at8 = function () {
    return this.wu2_1;
  };
  function defaultTransformers$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda).rtq = function ($this$intercept, body, $completion) {
    var tmp = this.stq($this$intercept, body, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(defaultTransformers$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            if (this.fu3_1.kst_1.ats_1.je('Accept') == null) {
              this.fu3_1.kst_1.ats_1.fsq('Accept', '*/*');
            }

            var contentType_0 = contentType(this.fu3_1.kst_1);
            var tmp0_subject = this.gu3_1;
            var tmp_0;
            if (typeof tmp0_subject === 'string') {
              tmp_0 = new TextContent(this.gu3_1, contentType_0 == null ? Text_getInstance().fsx_1 : contentType_0);
            } else {
              if (isByteArray(tmp0_subject)) {
                tmp_0 = new defaultTransformers$1$content$1(contentType_0, this.gu3_1);
              } else {
                if (isInterface(tmp0_subject, ByteReadChannel)) {
                  tmp_0 = new defaultTransformers$1$content$2(this.fu3_1, contentType_0, this.gu3_1);
                } else {
                  if (tmp0_subject instanceof OutgoingContent) {
                    tmp_0 = this.gu3_1;
                  } else {
                    tmp_0 = platformRequestDefaultTransform(contentType_0, this.fu3_1.kst_1, this.gu3_1);
                  }
                }
              }
            }

            var content = tmp_0;
            if (!((content == null ? null : content.vt7()) == null)) {
              this.fu3_1.kst_1.ats_1.jsq('Content-Type');
              get_LOGGER_1().hsu('Transformed with default transformers request body for ' + this.fu3_1.kst_1.ytr_1.toString() + ' from ' + toString(getKClassFromExpression(this.gu3_1)));
              this.n9_1 = 1;
              suspendResult = this.fu3_1.pss(content, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 1:
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda).stq = function ($this$intercept, body, completion) {
    var i = new defaultTransformers$slambda(completion);
    i.fu3_1 = $this$intercept;
    i.gu3_1 = body;
    return i;
  };
  function defaultTransformers$slambda_0(resultContinuation) {
    var i = new defaultTransformers$slambda(resultContinuation);
    return constructCallableReference(function ($this$intercept, body, $completion) {
      return i.rtq($this$intercept, body, $completion);
    }, 2);
  }
  function defaultTransformers$slambda$slambda($body, $response, resultContinuation) {
    this.pu3_1 = $body;
    this.qu3_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda$slambda).vtc = function ($this$writer, $completion) {
    var tmp = this.wtc($this$writer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(defaultTransformers$slambda$slambda).ja = function (p1, $completion) {
    return this.vtc(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = copyTo(this.pu3_1, this.ru3_1.xsk_1, new Long(-1, 2147483647), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            rethrowCloseCauseIfNeeded(this.pu3_1);
            this.o9_1 = 4;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.o9_1 = 4;
            return Unit_instance;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof CancellationException) {
              var cause = this.q9_1;
              cancel(this.qu3_1, cause);
              throw cause;
            } else {
              var tmp_1 = this.q9_1;
              if (tmp_1 instanceof Error) {
                var cause_0 = this.q9_1;
                cancel_0(this.qu3_1, 'Receive failed', cause_0);
                throw cause_0;
              } else {
                throw this.q9_1;
              }
            }

          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda$slambda).wtc = function ($this$writer, completion) {
    var i = new defaultTransformers$slambda$slambda(this.pu3_1, this.qu3_1, completion);
    i.ru3_1 = $this$writer;
    return i;
  };
  function defaultTransformers$slambda$slambda_0($body, $response, resultContinuation) {
    var i = new defaultTransformers$slambda$slambda($body, $response, resultContinuation);
    return constructCallableReference(function ($this$writer, $completion) {
      return i.vtc($this$writer, $completion);
    }, 1);
  }
  function defaultTransformers$slambda$lambda($responseJobHolder) {
    return function (it) {
      $responseJobHolder.w1g();
      return Unit_instance;
    };
  }
  function defaultTransformers$slambda_1($this_defaultTransformers, resultContinuation) {
    this.au4_1 = $this_defaultTransformers;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(defaultTransformers$slambda_1).mtr = function ($this$intercept, _destruct__k2r9zo, $completion) {
    var tmp = this.ntr($this$intercept, _destruct__k2r9zo, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(defaultTransformers$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(defaultTransformers$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.du4_1 = this.cu4_1.zh();
            var body = this.cu4_1.ai();
            if (!isInterface(body, ByteReadChannel))
              return Unit_instance;
            var response = this.bu4_1.kst_1.ytq();
            var tmp0_subject = this.du4_1.bsu_1;
            if (tmp0_subject.equals(getKClass(Unit))) {
              cancel_1(body);
              this.n9_1 = 10;
              suspendResult = this.bu4_1.pss(new HttpResponseContainer(this.du4_1, Unit_instance), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (tmp0_subject.equals(PrimitiveClasses_getInstance().mc())) {
                this.n9_1 = 8;
                suspendResult = readRemaining(body, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject.equals(getKClass(Source)) || tmp0_subject.equals(getKClass(Source))) {
                  this.n9_1 = 6;
                  suspendResult = readRemaining(body, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject.equals(PrimitiveClasses_getInstance().vc())) {
                    this.n9_1 = 4;
                    suspendResult = toByteArray(body, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject.equals(getKClass(ByteReadChannel))) {
                      var responseJobHolder = Job(get_job(response.q19()));
                      var this_0 = writer(this.bu4_1, this.au4_1.stp_1, VOID, defaultTransformers$slambda$slambda_0(body, response, null));
                      invokeOnCompletion(this_0, defaultTransformers$slambda$lambda(responseJobHolder));
                      attachWriterJob(body, this_0);
                      var channel = this_0.lse_1;
                      this.n9_1 = 3;
                      suspendResult = this.bu4_1.pss(new HttpResponseContainer(this.du4_1, channel), this);
                      if (suspendResult === get_COROUTINE_SUSPENDED()) {
                        return suspendResult;
                      }
                      continue $sm;
                    } else {
                      if (tmp0_subject.equals(getKClass(HttpStatusCode))) {
                        cancel_1(body);
                        this.n9_1 = 2;
                        suspendResult = this.bu4_1.pss(new HttpResponseContainer(this.du4_1, response.zbq()), this);
                        if (suspendResult === get_COROUTINE_SUSPENDED()) {
                          return suspendResult;
                        }
                        continue $sm;
                      } else {
                        if (tmp0_subject.equals(getKClass(MultiPartData))) {
                          var tmp0 = this.bu4_1.kst_1.ytq().dt2().je('Content-Type');
                          var tmp$ret$0;
                          l$ret$1: do {
                            if (tmp0 == null) {
                              var message = 'No content type provided for multipart';
                              throw IllegalStateException_init_$Create$(toString(message));
                            } else {
                              tmp$ret$0 = tmp0;
                              break l$ret$1;
                            }
                          }
                           while (false);
                          var rawContentType = tmp$ret$0;
                          var contentType = Companion_getInstance_0().jr(rawContentType);
                          if (!contentType.tsx(MultiPart_getInstance().zsw_1)) {
                            var message_0 = 'Expected multipart/form-data, got ' + contentType.toString();
                            throw IllegalStateException_init_$Create$(toString(message_0));
                          }
                          var tmp1_safe_receiver = this.bu4_1.kst_1.ytq().dt2().je('Content-Length');
                          var contentLength_0 = tmp1_safe_receiver == null ? null : toLong(tmp1_safe_receiver);
                          var body_0 = new CIOMultipartDataBase(this.bu4_1.q19(), body, rawContentType, contentLength_0);
                          var parsedResponse = new HttpResponseContainer(this.du4_1, body_0);
                          this.n9_1 = 1;
                          suspendResult = this.bu4_1.pss(parsedResponse, this);
                          if (suspendResult === get_COROUTINE_SUSPENDED()) {
                            return suspendResult;
                          }
                          continue $sm;
                        } else {
                          this.eu4_1 = null;
                          this.n9_1 = 11;
                          continue $sm;
                        }
                      }
                    }
                  }
                }
              }
            }

          case 1:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 2:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 3:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 4:
            var bytes = suspendResult;
            checkContentLength(contentLength(this.bu4_1.kst_1.ytq()), fromInt(bytes.length), this.bu4_1.kst_1.ftt().ntt());
            this.n9_1 = 5;
            suspendResult = this.bu4_1.pss(new HttpResponseContainer(this.du4_1, bytes), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 6:
            var ARGUMENT = suspendResult;
            var ARGUMENT_0 = new HttpResponseContainer(this.du4_1, ARGUMENT);
            this.n9_1 = 7;
            suspendResult = this.bu4_1.pss(ARGUMENT_0, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 8:
            var ARGUMENT_1 = suspendResult;
            var ARGUMENT_2 = readText(ARGUMENT_1);
            var ARGUMENT_3 = toInt(ARGUMENT_2);
            var ARGUMENT_4 = new HttpResponseContainer(this.du4_1, ARGUMENT_3);
            this.n9_1 = 9;
            suspendResult = this.bu4_1.pss(ARGUMENT_4, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 10:
            this.eu4_1 = suspendResult;
            this.n9_1 = 11;
            continue $sm;
          case 11:
            var result = this.eu4_1;
            if (!(result == null)) {
              get_LOGGER_1().hsu('Transformed with default transformers response body ' + ('for ' + this.bu4_1.kst_1.ftt().ott().toString() + ' to ' + toString(this.du4_1.bsu_1)));
            }

            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(defaultTransformers$slambda_1).ntr = function ($this$intercept, _destruct__k2r9zo, completion) {
    var i = new defaultTransformers$slambda_1(this.au4_1, completion);
    i.bu4_1 = $this$intercept;
    i.cu4_1 = _destruct__k2r9zo;
    return i;
  };
  function defaultTransformers$slambda_2($this_defaultTransformers, resultContinuation) {
    var i = new defaultTransformers$slambda_1($this_defaultTransformers, resultContinuation);
    return constructCallableReference(function ($this$intercept, _destruct__k2r9zo, $completion) {
      return i.mtr($this$intercept, _destruct__k2r9zo, $completion);
    }, 2);
  }
  var properties_initialized_DefaultTransform_kt_ossax9;
  function _init_properties_DefaultTransform_kt__20knxx() {
    if (!properties_initialized_DefaultTransform_kt_ossax9) {
      properties_initialized_DefaultTransform_kt_ossax9 = true;
      LOGGER_1 = KtorSimpleLogger('io.ktor.client.plugins.defaultTransformers');
    }
  }
  function get_LOGGER_2() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return LOGGER_2;
  }
  var LOGGER_2;
  function get_HttpCallValidator() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return HttpCallValidator;
  }
  var HttpCallValidator;
  function get_ExpectSuccessAttributeKey() {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return ExpectSuccessAttributeKey;
  }
  var ExpectSuccessAttributeKey;
  function HttpCallValidatorConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.lu2_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp_0.mu2_1 = ArrayList_init_$Create$();
    this.nu2_1 = true;
  }
  protoOf(HttpCallValidatorConfig).ou2 = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.lu2_1.j1(block);
  };
  function HttpResponseValidator(_this__u8e3s4, block) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    _this__u8e3s4.ett(get_HttpCallValidator(), block);
  }
  function ExceptionHandlerWrapper() {
  }
  function RequestExceptionHandlerWrapper() {
  }
  function RequestError$install$slambda($handler, resultContinuation) {
    this.nu4_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RequestError$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RequestError$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RequestError$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.ou4_1.qss(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.qu4_1 = suspendResult;
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              this.n9_1 = 3;
              suspendResult = this.nu4_1(HttpRequest(this.ou4_1.kst_1), cause, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            var error = suspendResult;
            var tmp_1 = this;
            if (!(error == null))
              throw error;
            tmp_1.qu4_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RequestError$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new RequestError$install$slambda(this.nu4_1, completion);
    i.ou4_1 = $this$intercept;
    i.pu4_1 = it;
    return i;
  };
  function RequestError$install$slambda_0($handler, resultContinuation) {
    var i = new RequestError$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function RequestError() {
  }
  protoOf(RequestError).ru4 = function (client, handler) {
    var tmp = Phases_getInstance_0().yty_1;
    client.ttp_1.ost(tmp, RequestError$install$slambda_0(handler, null));
  };
  protoOf(RequestError).dtz = function (client, handler) {
    return this.ru4(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var RequestError_instance;
  function RequestError_getInstance() {
    return RequestError_instance;
  }
  function ReceiveError$install$slambda($handler, resultContinuation) {
    this.au5_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(ReceiveError$install$slambda).mtr = function ($this$intercept, it, $completion) {
    var tmp = this.ntr($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(ReceiveError$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(ReceiveError$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.bu5_1.qss(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.du5_1 = suspendResult;
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              this.n9_1 = 3;
              suspendResult = this.au5_1(this.bu5_1.kst_1.ftt(), cause, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            var error = suspendResult;
            var tmp_1 = this;
            if (!(error == null))
              throw error;
            tmp_1.du5_1 = Unit_instance;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 5;
            return Unit_instance;
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(ReceiveError$install$slambda).ntr = function ($this$intercept, it, completion) {
    var i = new ReceiveError$install$slambda(this.au5_1, completion);
    i.bu5_1 = $this$intercept;
    i.cu5_1 = it;
    return i;
  };
  function ReceiveError$install$slambda_0($handler, resultContinuation) {
    var i = new ReceiveError$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.mtr($this$intercept, it, $completion);
    }, 2);
  }
  function ReceiveError() {
  }
  protoOf(ReceiveError).ru4 = function (client, handler) {
    var BeforeReceive = new PipelinePhase('BeforeReceive');
    client.utp_1.nst(Phases_getInstance_2().vts_1, BeforeReceive);
    client.utp_1.ost(BeforeReceive, ReceiveError$install$slambda_0(handler, null));
  };
  protoOf(ReceiveError).dtz = function (client, handler) {
    return this.ru4(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var ReceiveError_instance;
  function ReceiveError_getInstance() {
    return ReceiveError_instance;
  }
  function HttpRequest(builder) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    return new HttpRequest$1(builder);
  }
  function HttpCallValidatorConfig$_init_$ref_m1o2g9() {
    return constructCallableReference(function () {
      return new HttpCallValidatorConfig();
    }, 0, 0, 505, '<init>');
  }
  function HttpCallValidator$lambda($this$createClientPlugin) {
    _init_properties_HttpCallValidator_kt__r6yh2y();
    var responseValidators = reversed($this$createClientPlugin.xtz_1.lu2_1);
    var callExceptionHandlers = reversed($this$createClientPlugin.xtz_1.mu2_1);
    var expectSuccess = $this$createClientPlugin.xtz_1.nu2_1;
    var tmp = SetupRequest_instance;
    $this$createClientPlugin.au0(tmp, HttpCallValidator$lambda$slambda_0(expectSuccess, null));
    var tmp_0 = Send_instance;
    $this$createClientPlugin.au0(tmp_0, HttpCallValidator$lambda$slambda_2(responseValidators, null));
    var tmp_1 = RequestError_instance;
    $this$createClientPlugin.au0(tmp_1, HttpCallValidator$lambda$slambda_4(callExceptionHandlers, null));
    var tmp_2 = ReceiveError_instance;
    $this$createClientPlugin.au0(tmp_2, HttpCallValidator$lambda$slambda_6(callExceptionHandlers, null));
    return Unit_instance;
  }
  function invoke$validateResponse(responseValidators, response, $completion) {
    var tmp = new $invoke$validateResponseCOROUTINE$(responseValidators, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function invoke$processException(callExceptionHandlers, cause, request, $completion) {
    var tmp = new $invoke$processExceptionCOROUTINE$(callExceptionHandlers, cause, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function HttpCallValidator$lambda$slambda$lambda($expectSuccess) {
    return function () {
      return $expectSuccess;
    };
  }
  function HttpCallValidator$lambda$slambda($expectSuccess, resultContinuation) {
    this.ju6_1 = $expectSuccess;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$lambda$slambda).lu6 = function (request, $completion) {
    var tmp = this.mu6(request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpCallValidator$lambda$slambda).ja = function (p1, $completion) {
    return this.lu6(p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = get_ExpectSuccessAttributeKey();
          this.ku6_1.dts_1.zsn(tmp_0, HttpCallValidator$lambda$slambda$lambda(this.ju6_1));
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HttpCallValidator$lambda$slambda).mu6 = function (request, completion) {
    var i = new HttpCallValidator$lambda$slambda(this.ju6_1, completion);
    i.ku6_1 = request;
    return i;
  };
  function HttpCallValidator$lambda$slambda_0($expectSuccess, resultContinuation) {
    var i = new HttpCallValidator$lambda$slambda($expectSuccess, resultContinuation);
    return constructCallableReference(function (request, $completion) {
      return i.lu6(request, $completion);
    }, 1);
  }
  function HttpCallValidator$lambda$slambda_1($responseValidators, resultContinuation) {
    this.vu6_1 = $responseValidators;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$lambda$slambda_1).zu6 = function ($this$on, request, $completion) {
    var tmp = this.au7($this$on, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpCallValidator$lambda$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
    return this.zu6(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.wu6_1.du7(this.xu6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.yu6_1 = suspendResult;
            this.n9_1 = 2;
            suspendResult = invoke$validateResponse(this.vu6_1, this.yu6_1.ytq(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return this.yu6_1;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$lambda$slambda_1).au7 = function ($this$on, request, completion) {
    var i = new HttpCallValidator$lambda$slambda_1(this.vu6_1, completion);
    i.wu6_1 = $this$on;
    i.xu6_1 = request;
    return i;
  };
  function HttpCallValidator$lambda$slambda_2($responseValidators, resultContinuation) {
    var i = new HttpCallValidator$lambda$slambda_1($responseValidators, resultContinuation);
    return constructCallableReference(function ($this$on, request, $completion) {
      return i.zu6($this$on, request, $completion);
    }, 2);
  }
  function HttpCallValidator$lambda$slambda_3($callExceptionHandlers, resultContinuation) {
    this.mu7_1 = $callExceptionHandlers;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$lambda$slambda_3).qu7 = function (request, cause, $completion) {
    var tmp = this.ru7(request, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpCallValidator$lambda$slambda_3).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest_0) : false) ? p1 : THROW_CCE();
    return this.qu7(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$lambda$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.pu7_1 = unwrapCancellationException(this.ou7_1);
            this.n9_1 = 1;
            suspendResult = invoke$processException(this.mu7_1, this.pu7_1, this.nu7_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.pu7_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$lambda$slambda_3).ru7 = function (request, cause, completion) {
    var i = new HttpCallValidator$lambda$slambda_3(this.mu7_1, completion);
    i.nu7_1 = request;
    i.ou7_1 = cause;
    return i;
  };
  function HttpCallValidator$lambda$slambda_4($callExceptionHandlers, resultContinuation) {
    var i = new HttpCallValidator$lambda$slambda_3($callExceptionHandlers, resultContinuation);
    return constructCallableReference(function (request, cause, $completion) {
      return i.qu7(request, cause, $completion);
    }, 2);
  }
  function HttpCallValidator$lambda$slambda_5($callExceptionHandlers, resultContinuation) {
    this.au8_1 = $callExceptionHandlers;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpCallValidator$lambda$slambda_5).qu7 = function (request, cause, $completion) {
    var tmp = this.ru7(request, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpCallValidator$lambda$slambda_5).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, HttpRequest_0) : false) ? p1 : THROW_CCE();
    return this.qu7(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpCallValidator$lambda$slambda_5).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.du8_1 = unwrapCancellationException(this.cu8_1);
            this.n9_1 = 1;
            suspendResult = invoke$processException(this.au8_1, this.du8_1, this.bu8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return this.du8_1;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpCallValidator$lambda$slambda_5).ru7 = function (request, cause, completion) {
    var i = new HttpCallValidator$lambda$slambda_5(this.au8_1, completion);
    i.bu8_1 = request;
    i.cu8_1 = cause;
    return i;
  };
  function HttpCallValidator$lambda$slambda_6($callExceptionHandlers, resultContinuation) {
    var i = new HttpCallValidator$lambda$slambda_5($callExceptionHandlers, resultContinuation);
    return constructCallableReference(function (request, cause, $completion) {
      return i.qu7(request, cause, $completion);
    }, 2);
  }
  function $invoke$validateResponseCOROUTINE$(responseValidators, response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mu5_1 = responseValidators;
    this.nu5_1 = response;
  }
  protoOf($invoke$validateResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            get_LOGGER_2().hsu('Validating response for request ' + this.nu5_1.mtt().ftt().ott().toString());
            this.ou5_1 = this.mu5_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.ou5_1.u()) {
              this.n9_1 = 3;
              continue $sm;
            }

            var element = this.ou5_1.v();
            this.n9_1 = 2;
            suspendResult = element(this.nu5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.n9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $invoke$processExceptionCOROUTINE$(callExceptionHandlers, cause, request, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.xu5_1 = callExceptionHandlers;
    this.yu5_1 = cause;
    this.zu5_1 = request;
  }
  protoOf($invoke$processExceptionCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            get_LOGGER_2().hsu('Processing exception ' + this.yu5_1.toString() + ' for request ' + this.zu5_1.ott().toString());
            this.au6_1 = this.xu5_1.t();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!this.au6_1.u()) {
              this.n9_1 = 5;
              continue $sm;
            }

            var element = this.au6_1.v();
            if (element instanceof ExceptionHandlerWrapper) {
              this.n9_1 = 3;
              suspendResult = element.fu8_1(this.yu5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              if (element instanceof RequestExceptionHandlerWrapper) {
                this.n9_1 = 2;
                suspendResult = element.eu8_1(this.yu5_1, this.zu5_1, this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                noWhenBranchMatchedException();
              }
            }

            break;
          case 2:
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 1;
            continue $sm;
          case 5:
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpRequest$1($builder) {
    this.ku8_1 = $builder;
    this.gu8_1 = $builder.ztr_1;
    this.hu8_1 = $builder.ytr_1.g3d();
    this.iu8_1 = $builder.dts_1;
    this.ju8_1 = $builder.ats_1.g3d();
  }
  protoOf(HttpRequest$1).mtt = function () {
    // Inline function 'kotlin.error' call
    var message = 'Call is not initialized';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(HttpRequest$1).ntt = function () {
    return this.gu8_1;
  };
  protoOf(HttpRequest$1).ott = function () {
    return this.hu8_1;
  };
  protoOf(HttpRequest$1).gtt = function () {
    return this.iu8_1;
  };
  protoOf(HttpRequest$1).dt2 = function () {
    return this.ju8_1;
  };
  protoOf(HttpRequest$1).rj3 = function () {
    var tmp = this.ku8_1.bts_1;
    var tmp0_elvis_lhs = tmp instanceof OutgoingContent ? tmp : null;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'Content was not transformed to OutgoingContent yet. Current body is ' + toString(this.ku8_1.bts_1);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    return tmp_0;
  };
  var properties_initialized_HttpCallValidator_kt_xrx49w;
  function _init_properties_HttpCallValidator_kt__r6yh2y() {
    if (!properties_initialized_HttpCallValidator_kt_xrx49w) {
      properties_initialized_HttpCallValidator_kt_xrx49w = true;
      LOGGER_2 = KtorSimpleLogger('io.ktor.client.plugins.HttpCallValidator');
      var tmp = HttpCallValidatorConfig$_init_$ref_m1o2g9();
      HttpCallValidator = createClientPlugin('HttpResponseValidator', tmp, HttpCallValidator$lambda);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'ExpectSuccessAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_0 = PrimitiveClasses_getInstance().jc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_1;
      try {
        tmp_1 = createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_2 = null;
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      var tmp$ret$2 = tmp_1;
      var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
      ExpectSuccessAttributeKey = new AttributeKey(name, tmp$ret$1);
    }
  }
  function get_PLUGIN_INSTALLED_LIST() {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    return PLUGIN_INSTALLED_LIST;
  }
  var PLUGIN_INSTALLED_LIST;
  function plugin(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_elvis_lhs = pluginOrNull(_this__u8e3s4, plugin);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalStateException_init_$Create$('Plugin ' + toString(plugin) + ' is not installed. Consider using `install(' + plugin.t1().toString() + ')` in client config first.');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function pluginOrNull(_this__u8e3s4, plugin) {
    _init_properties_HttpClientPlugin_kt__cypu1m();
    var tmp0_safe_receiver = _this__u8e3s4.xtp_1.usn(get_PLUGIN_INSTALLED_LIST());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.usn(plugin.t1());
  }
  var properties_initialized_HttpClientPlugin_kt_p98320;
  function _init_properties_HttpClientPlugin_kt__cypu1m() {
    if (!properties_initialized_HttpClientPlugin_kt_p98320) {
      properties_initialized_HttpClientPlugin_kt_p98320 = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'ApplicationPluginRegistry';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(Attributes);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(Attributes), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      PLUGIN_INSTALLED_LIST = new AttributeKey(name, tmp$ret$1);
    }
  }
  function get_LOGGER_3() {
    _init_properties_HttpPlainText_kt__iy89z1();
    return LOGGER_3;
  }
  var LOGGER_3;
  function get_HttpPlainText() {
    _init_properties_HttpPlainText_kt__iy89z1();
    return HttpPlainText;
  }
  var HttpPlainText;
  function HttpPlainTextConfig() {
    var tmp = this;
    // Inline function 'kotlin.collections.mutableSetOf' call
    tmp.lu8_1 = LinkedHashSet_init_$Create$();
    var tmp_0 = this;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp_0.mu8_1 = LinkedHashMap_init_$Create$();
    this.nu8_1 = null;
    this.ou8_1 = Charsets_getInstance().psm_1;
  }
  function RenderRequestHook$install$slambda($handler, resultContinuation) {
    this.xu8_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RenderRequestHook$install$slambda).rtq = function ($this$intercept, content, $completion) {
    var tmp = this.stq($this$intercept, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RenderRequestHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RenderRequestHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.xu8_1(this.yu8_1.kst_1, this.zu8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var result = suspendResult;
            if (!(result == null)) {
              this.n9_1 = 2;
              suspendResult = this.yu8_1.pss(result, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RenderRequestHook$install$slambda).stq = function ($this$intercept, content, completion) {
    var i = new RenderRequestHook$install$slambda(this.xu8_1, completion);
    i.yu8_1 = $this$intercept;
    i.zu8_1 = content;
    return i;
  };
  function RenderRequestHook$install$slambda_0($handler, resultContinuation) {
    var i = new RenderRequestHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, content, $completion) {
      return i.rtq($this$intercept, content, $completion);
    }, 2);
  }
  function RenderRequestHook() {
  }
  protoOf(RenderRequestHook).au9 = function (client, handler) {
    var tmp = Phases_getInstance_0().btz_1;
    client.ttp_1.ost(tmp, RenderRequestHook$install$slambda_0(handler, null));
  };
  protoOf(RenderRequestHook).dtz = function (client, handler) {
    return this.au9(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var RenderRequestHook_instance;
  function RenderRequestHook_getInstance() {
    return RenderRequestHook_instance;
  }
  function HttpPlainTextConfig$_init_$ref_isjudo() {
    return constructCallableReference(function () {
      return new HttpPlainTextConfig();
    }, 0, 0, 506, '<init>');
  }
  function HttpPlainText$lambda($this$createClientPlugin) {
    _init_properties_HttpPlainText_kt__iy89z1();
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_0 = toList($this$createClientPlugin.xtz_1.mu8_1);
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp = HttpPlainText$lambda$lambda;
    var tmp$ret$1 = new sam$kotlin_Comparator$0(tmp);
    var withQuality = sortedWith(this_0, tmp$ret$1);
    var responseCharsetFallback = $this$createClientPlugin.xtz_1.ou8_1;
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$createClientPlugin.xtz_1.lu8_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = tmp0.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (!$this$createClientPlugin.xtz_1.mu8_1.u2(element)) {
        destination.j1(element);
      }
    }
    // Inline function 'kotlin.collections.sortedBy' call
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_0 = HttpPlainText$lambda$lambda_0;
    var tmp$ret$6 = new sam$kotlin_Comparator$0(tmp_0);
    var withoutQuality = sortedWith(destination, tmp$ret$6);
    var tmp_1;
    var tmp0_0 = $this$createClientPlugin.xtz_1.lu8_1;
    var tmp$ret$7;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_2;
      if (isInterface(tmp0_0, Collection)) {
        tmp_2 = tmp0_0.r();
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        tmp$ret$7 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = tmp0_0.t();
      while (_iterator__ex2g4s_0.u()) {
        var element_0 = _iterator__ex2g4s_0.v();
        if (!element_0.equals(Charsets_getInstance().psm_1)) {
          tmp$ret$7 = true;
          break $l$block_0;
        }
      }
      tmp$ret$7 = false;
    }
    if (tmp$ret$7) {
      tmp_1 = true;
    } else {
      var tmp0_1 = $this$createClientPlugin.xtz_1.mu8_1.x2();
      var tmp$ret$9;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_3;
        if (isInterface(tmp0_1, Collection)) {
          tmp_3 = tmp0_1.r();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$9 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_1 = tmp0_1.t();
        while (_iterator__ex2g4s_1.u()) {
          var element_1 = _iterator__ex2g4s_1.v();
          if (!element_1.equals(Charsets_getInstance().psm_1)) {
            tmp$ret$9 = true;
            break $l$block_2;
          }
        }
        tmp$ret$9 = false;
      }
      tmp_1 = tmp$ret$9;
    }
    var hasRegisteredCharsets = tmp_1;
    var tmp_4;
    if (hasRegisteredCharsets) {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_1 = StringBuilder_init_$Create$();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = withoutQuality.t();
      while (_iterator__ex2g4s_2.u()) {
        var element_2 = _iterator__ex2g4s_2.v();
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(this_1) > 0) {
          this_1.q(',');
        }
        this_1.q(get_name(element_2));
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = withQuality.t();
      while (_iterator__ex2g4s_3.u()) {
        var element_3 = _iterator__ex2g4s_3.v();
        var charset = element_3.zh();
        var quality = element_3.ai();
        // Inline function 'kotlin.text.isNotEmpty' call
        if (charSequenceLength(this_1) > 0) {
          this_1.q(',');
        }
        // Inline function 'kotlin.check' call
        if (!(0.0 <= quality ? quality <= 1.0 : false)) {
          throw IllegalStateException_init_$Create$('Check failed.');
        }
        // Inline function 'kotlin.math.roundToInt' call
        var this_2 = 100 * quality;
        var truncatedQuality = roundToInt(this_2) / 100.0;
        this_1.q(get_name(charset) + ';q=' + truncatedQuality);
      }
      tmp_4 = this_1.toString();
    } else {
      tmp_4 = null;
    }
    var acceptCharsetHeader = tmp_4;
    var tmp0_elvis_lhs = $this$createClientPlugin.xtz_1.nu8_1;
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? firstOrNull(withoutQuality) : tmp0_elvis_lhs;
    var tmp_5;
    if (tmp1_elvis_lhs == null) {
      var tmp2_safe_receiver = firstOrNull(withQuality);
      tmp_5 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.xh_1;
    } else {
      tmp_5 = tmp1_elvis_lhs;
    }
    var tmp3_elvis_lhs = tmp_5;
    var requestCharset = tmp3_elvis_lhs == null ? Charsets_getInstance().psm_1 : tmp3_elvis_lhs;
    var tmp_6 = RenderRequestHook_instance;
    $this$createClientPlugin.au0(tmp_6, HttpPlainText$lambda$slambda_0(acceptCharsetHeader, requestCharset, null));
    $this$createClientPlugin.bu9(HttpPlainText$lambda$slambda_2(responseCharsetFallback, null));
    return Unit_instance;
  }
  function sam$kotlin_Comparator$0(function_0) {
    this.cu9_1 = function_0;
  }
  protoOf(sam$kotlin_Comparator$0).ze = function (a, b) {
    return this.cu9_1(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
    return this.ze(a, b);
  };
  protoOf(sam$kotlin_Comparator$0).q3 = function () {
    return this.cu9_1;
  };
  protoOf(sam$kotlin_Comparator$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Comparator) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlin_Comparator$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function HttpPlainText$lambda$lambda(a, b) {
    _init_properties_HttpPlainText_kt__iy89z1();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = b.yh_1;
    var tmp$ret$2 = a.yh_1;
    return compareValues(tmp, tmp$ret$2);
  }
  function HttpPlainText$lambda$lambda_0(a, b) {
    _init_properties_HttpPlainText_kt__iy89z1();
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = get_name(a);
    var tmp$ret$2 = get_name(b);
    return compareValues(tmp, tmp$ret$2);
  }
  function invoke$wrapContent(requestCharset, request, content, requestContentType) {
    var contentType = requestContentType == null ? Text_getInstance().fsx_1 : requestContentType;
    var tmp2_elvis_lhs = requestContentType == null ? null : charset(requestContentType);
    var charset_0 = tmp2_elvis_lhs == null ? requestCharset : tmp2_elvis_lhs;
    get_LOGGER_3().hsu('Sending request body to ' + request.ytr_1.toString() + ' as text/plain with charset ' + charset_0.toString());
    return new TextContent(content, withCharset(contentType, charset_0));
  }
  function invoke$read(responseCharsetFallback, call, body) {
    var tmp0_elvis_lhs = charset_0(call.ytq());
    var actualCharset = tmp0_elvis_lhs == null ? responseCharsetFallback : tmp0_elvis_lhs;
    get_LOGGER_3().hsu('Reading response body for ' + call.ftt().ott().toString() + ' as String with charset ' + actualCharset.toString());
    return readText_0(body, actualCharset);
  }
  function invoke$addAcceptCharsetHeader(_this__u8e3s4, value) {
    if (value == null || !(_this__u8e3s4.ats_1.je('Accept-Charset') == null))
      return Unit_instance;
    get_LOGGER_3().hsu('Adding Accept-Charset=' + value + ' to ' + _this__u8e3s4.ytr_1.toString());
    _this__u8e3s4.ats_1.dsq('Accept-Charset', value);
  }
  function HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset, resultContinuation) {
    this.lu9_1 = $acceptCharsetHeader;
    this.mu9_1 = $requestCharset;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$lambda$slambda).pu9 = function (request, content, $completion) {
    var tmp = this.qu9(request, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpPlainText$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
    return this.pu9(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          invoke$addAcceptCharsetHeader(this.nu9_1, this.lu9_1);
          var tmp_0 = this.ou9_1;
          if (!(typeof tmp_0 === 'string'))
            return null;
          var contentType_0 = contentType(this.nu9_1);
          if (!(contentType_0 == null) && !(contentType_0.psx_1 === Text_getInstance().fsx_1.psx_1)) {
            return null;
          }
          return invoke$wrapContent(this.mu9_1, this.nu9_1, this.ou9_1, contentType_0);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HttpPlainText$lambda$slambda).qu9 = function (request, content, completion) {
    var i = new HttpPlainText$lambda$slambda(this.lu9_1, this.mu9_1, completion);
    i.nu9_1 = request;
    i.ou9_1 = content;
    return i;
  };
  function HttpPlainText$lambda$slambda_0($acceptCharsetHeader, $requestCharset, resultContinuation) {
    var i = new HttpPlainText$lambda$slambda($acceptCharsetHeader, $requestCharset, resultContinuation);
    return constructCallableReference(function (request, content, $completion) {
      return i.pu9(request, content, $completion);
    }, 2);
  }
  function HttpPlainText$lambda$slambda_1($responseCharsetFallback, resultContinuation) {
    this.zu9_1 = $responseCharsetFallback;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpPlainText$lambda$slambda_1).eua = function ($this$transformResponseBody, response, content, requestedType, $completion) {
    var tmp = this.fua($this$transformResponseBody, response, content, requestedType, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpPlainText$lambda$slambda_1).gua = function (p1, p2, p3, p4, $completion) {
    var tmp = p1 instanceof TransformResponseBodyContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpResponse ? p2 : THROW_CCE();
    var tmp_1 = (!(p3 == null) ? isInterface(p3, ByteReadChannel) : false) ? p3 : THROW_CCE();
    return this.eua(tmp, tmp_0, tmp_1, p4 instanceof TypeInfo ? p4 : THROW_CCE(), $completion);
  };
  protoOf(HttpPlainText$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (!this.dua_1.bsu_1.equals(PrimitiveClasses_getInstance().rc()))
              return null;
            this.n9_1 = 1;
            suspendResult = readRemaining(this.cua_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var bodyBytes = suspendResult;
            return invoke$read(this.zu9_1, this.bua_1.mtt(), bodyBytes);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpPlainText$lambda$slambda_1).fua = function ($this$transformResponseBody, response, content, requestedType, completion) {
    var i = new HttpPlainText$lambda$slambda_1(this.zu9_1, completion);
    i.aua_1 = $this$transformResponseBody;
    i.bua_1 = response;
    i.cua_1 = content;
    i.dua_1 = requestedType;
    return i;
  };
  function HttpPlainText$lambda$slambda_2($responseCharsetFallback, resultContinuation) {
    var i = new HttpPlainText$lambda$slambda_1($responseCharsetFallback, resultContinuation);
    return constructCallableReference(function ($this$transformResponseBody, response, content, requestedType, $completion) {
      return i.eua($this$transformResponseBody, response, content, requestedType, $completion);
    }, 4);
  }
  var properties_initialized_HttpPlainText_kt_2nx4ox;
  function _init_properties_HttpPlainText_kt__iy89z1() {
    if (!properties_initialized_HttpPlainText_kt_2nx4ox) {
      properties_initialized_HttpPlainText_kt_2nx4ox = true;
      LOGGER_3 = KtorSimpleLogger('io.ktor.client.plugins.HttpPlainText');
      var tmp = HttpPlainTextConfig$_init_$ref_isjudo();
      HttpPlainText = createClientPlugin('HttpPlainText', tmp, HttpPlainText$lambda);
    }
  }
  function get_ALLOWED_FOR_REDIRECT() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return ALLOWED_FOR_REDIRECT;
  }
  var ALLOWED_FOR_REDIRECT;
  function get_LOGGER_4() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return LOGGER_4;
  }
  var LOGGER_4;
  function get_HttpResponseRedirectEvent() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return HttpResponseRedirectEvent;
  }
  var HttpResponseRedirectEvent;
  function get_HttpRedirect() {
    _init_properties_HttpRedirect_kt__ure7fo();
    return HttpRedirect;
  }
  var HttpRedirect;
  function HttpRedirectConfig() {
    this.hua_1 = true;
    this.iua_1 = false;
  }
  function isRedirect(_this__u8e3s4) {
    _init_properties_HttpRedirect_kt__ure7fo();
    var tmp0_subject = _this__u8e3s4.yt2_1;
    return tmp0_subject === Companion_getInstance_1().mt3_1.yt2_1 || tmp0_subject === Companion_getInstance_1().nt3_1.yt2_1 || (tmp0_subject === Companion_getInstance_1().st3_1.yt2_1 || (tmp0_subject === Companion_getInstance_1().tt3_1.yt2_1 || tmp0_subject === Companion_getInstance_1().ot3_1.yt2_1)) ? true : false;
  }
  function HttpRedirectConfig$_init_$ref_rhym9t() {
    return constructCallableReference(function () {
      return new HttpRedirectConfig();
    }, 0, 0, 507, '<init>');
  }
  function HttpRedirect$lambda($this$createClientPlugin) {
    _init_properties_HttpRedirect_kt__ure7fo();
    var checkHttpMethod = $this$createClientPlugin.xtz_1.hua_1;
    var allowHttpsDowngrade = $this$createClientPlugin.xtz_1.iua_1;
    var tmp = Send_instance;
    $this$createClientPlugin.au0(tmp, HttpRedirect$lambda$slambda_0(checkHttpMethod, allowHttpsDowngrade, $this$createClientPlugin, null));
    return Unit_instance;
  }
  function invoke$handleCall(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion) {
    var tmp = new $invoke$handleCallCOROUTINE$(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation) {
    this.gub_1 = $checkHttpMethod;
    this.hub_1 = $allowHttpsDowngrade;
    this.iub_1 = $this_createClientPlugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRedirect$lambda$slambda).zu6 = function ($this$on, request, $completion) {
    var tmp = this.au7($this$on, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpRedirect$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
    return this.zu6(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRedirect$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.n9_1 = 1;
            suspendResult = this.jub_1.du7(this.kub_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var origin = suspendResult;
            if (this.gub_1 && !get_ALLOWED_FOR_REDIRECT().m1(origin.ftt().ntt())) {
              return origin;
            }

            this.n9_1 = 2;
            suspendResult = invoke$handleCall(this.jub_1, this.kub_1, origin, this.hub_1, this.iub_1.wtz_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return suspendResult;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRedirect$lambda$slambda).au7 = function ($this$on, request, completion) {
    var i = new HttpRedirect$lambda$slambda(this.gub_1, this.hub_1, this.iub_1, completion);
    i.jub_1 = $this$on;
    i.kub_1 = request;
    return i;
  };
  function HttpRedirect$lambda$slambda_0($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation) {
    var i = new HttpRedirect$lambda$slambda($checkHttpMethod, $allowHttpsDowngrade, $this_createClientPlugin, resultContinuation);
    return constructCallableReference(function ($this$on, request, $completion) {
      return i.zu6($this$on, request, $completion);
    }, 2);
  }
  function $invoke$handleCallCOROUTINE$(_this__u8e3s4, context, origin, allowHttpsDowngrade, client, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.rua_1 = _this__u8e3s4;
    this.sua_1 = context;
    this.tua_1 = origin;
    this.uua_1 = allowHttpsDowngrade;
    this.vua_1 = client;
  }
  protoOf($invoke$handleCallCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.wua_1 = this.tua_1;
            this.xua_1 = this.sua_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 4;
              continue $sm;
            }

            var previousProtocol = this.wua_1.ftt().ott().gt6_1;
            var previousAuthority = get_authority(this.wua_1.ftt().ott());
            if (!isRedirect(this.wua_1.ytq().zbq()))
              return this.wua_1;
            var location = this.wua_1.ytq().dt2().je('Location');
            if (location == null) {
              get_LOGGER_4().fs5('Location header missing from redirect response ' + this.wua_1.ftt().ott().toString() + '; returning response as is');
              return this.wua_1;
            }

            this.vua_1.ztp_1.usu(get_HttpResponseRedirectEvent(), this.wua_1.ytq());
            get_LOGGER_4().hsu('Received redirect response to ' + location + ' for request ' + this.wua_1.ftt().ott().toString());
            var tmp_0 = this;
            var this_0 = new HttpRequestBuilder();
            this_0.ptx(this.xua_1);
            this_0.ytr_1.qt5_1.c3();
            takeFrom_0(this_0.ytr_1, location);
            if (!this.uua_1 && isSecure(previousProtocol) && !isSecure(this_0.ytr_1.tt5())) {
              get_LOGGER_4().hsu('Blocked redirect from ' + this.wua_1.ftt().ott().toString() + ' to ' + location + ' due to HTTPS downgrade');
              return this.wua_1;
            }

            if (!(previousAuthority === get_authority_0(this_0.ytr_1))) {
              this_0.ats_1.jsq('Authorization');
              get_LOGGER_4().hsu('Removing Authorization header for cross-authority redirect: ' + (previousAuthority + ' -> ' + this_0.ytr_1.ft7()));
            }

            tmp_0.xua_1 = this_0;
            this.n9_1 = 2;
            suspendResult = this.rua_1.du7(this.xua_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.wua_1 = suspendResult;
            this.n9_1 = 1;
            continue $sm;
          case 3:
            throw this.q9_1;
          case 4:
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_HttpRedirect_kt_klj746;
  function _init_properties_HttpRedirect_kt__ure7fo() {
    if (!properties_initialized_HttpRedirect_kt_klj746) {
      properties_initialized_HttpRedirect_kt_klj746 = true;
      ALLOWED_FOR_REDIRECT = setOf_0([Companion_getInstance_2().et2_1, Companion_getInstance_2().jt2_1]);
      LOGGER_4 = KtorSimpleLogger('io.ktor.client.plugins.HttpRedirect');
      HttpResponseRedirectEvent = new EventDefinition();
      var tmp = HttpRedirectConfig$_init_$ref_rhym9t();
      HttpRedirect = createClientPlugin('HttpRedirect', tmp, HttpRedirect$lambda);
    }
  }
  function get_LOGGER_5() {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    return LOGGER_5;
  }
  var LOGGER_5;
  function get_HttpRequestLifecycle() {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    return HttpRequestLifecycle;
  }
  var HttpRequestLifecycle;
  function $invokeCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tub_1 = _this__u8e3s4;
  }
  protoOf($invokeCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.tub_1.xub_1;
            this.n9_1 = 1;
            suspendResult = tmp0.qss(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function PipelineContext$proceed$ref(p0) {
    KFunctionImpl.call(this, 9, 1, 508);
    this.xub_1 = p0;
  }
  protoOf(PipelineContext$proceed$ref).r2b = function ($completion) {
    var tmp = new $invokeCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(PipelineContext$proceed$ref).ia = function ($completion) {
    return this.r2b($completion);
  };
  function PipelineContext$proceed$ref_0(p0) {
    var i = new PipelineContext$proceed$ref(p0);
    return constructCallableReference(function ($completion) {
      return i.r2b($completion);
    }, 0, 9, 508, VOID, [p0]);
  }
  function SetupRequestContext$install$slambda($handler, resultContinuation) {
    this.guc_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SetupRequestContext$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SetupRequestContext$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SetupRequestContext$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.guc_1(this.huc_1.kst_1, PipelineContext$proceed$ref_0(this.huc_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SetupRequestContext$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new SetupRequestContext$install$slambda(this.guc_1, completion);
    i.huc_1 = $this$intercept;
    i.iuc_1 = it;
    return i;
  };
  function SetupRequestContext$install$slambda_0($handler, resultContinuation) {
    var i = new SetupRequestContext$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function SetupRequestContext() {
  }
  protoOf(SetupRequestContext).juc = function (client, handler) {
    var tmp = Phases_getInstance_0().yty_1;
    client.ttp_1.ost(tmp, SetupRequestContext$install$slambda_0(handler, null));
  };
  protoOf(SetupRequestContext).dtz = function (client, handler) {
    return this.juc(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var SetupRequestContext_instance;
  function SetupRequestContext_getInstance() {
    return SetupRequestContext_instance;
  }
  function attachToClientEngineJob(requestJob, clientEngineJob) {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    var handler = clientEngineJob.t1a(attachToClientEngineJob$lambda(requestJob));
    requestJob.t1a(attachToClientEngineJob$lambda_0(handler));
  }
  function HttpRequestLifecycle$lambda($this$createClientPlugin) {
    _init_properties_HttpRequestLifecycle_kt__jgkmfx();
    var tmp = SetupRequestContext_instance;
    $this$createClientPlugin.au0(tmp, HttpRequestLifecycle$lambda$slambda_0($this$createClientPlugin, null));
    return Unit_instance;
  }
  function HttpRequestLifecycle$lambda$slambda($this_createClientPlugin, resultContinuation) {
    this.suc_1 = $this_createClientPlugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestLifecycle$lambda$slambda).wuc = function (request, proceed, $completion) {
    var tmp = this.xuc(request, proceed, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpRequestLifecycle$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
    return this.wuc(tmp, (!(p2 == null) ? isSuspendFunction(p2, 0) : false) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestLifecycle$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.vuc_1 = SupervisorJob(this.tuc_1.cts_1);
            attachToClientEngineJob(this.vuc_1, ensureNotNull(this.suc_1.wtz_1.stp_1.aa(Key_instance)));
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            this.o9_1 = 3;
            this.tuc_1.cts_1 = this.vuc_1;
            this.n9_1 = 2;
            suspendResult = this.uuc_1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.o9_1 = 6;
            this.n9_1 = 5;
            continue $sm;
          case 3:
            this.o9_1 = 4;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              this.vuc_1.v1g(cause);
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 6;
            var t = this.q9_1;
            this.vuc_1.w1g();
            throw t;
          case 5:
            this.o9_1 = 6;
            this.vuc_1.w1g();
            return Unit_instance;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestLifecycle$lambda$slambda).xuc = function (request, proceed, completion) {
    var i = new HttpRequestLifecycle$lambda$slambda(this.suc_1, completion);
    i.tuc_1 = request;
    i.uuc_1 = proceed;
    return i;
  };
  function HttpRequestLifecycle$lambda$slambda_0($this_createClientPlugin, resultContinuation) {
    var i = new HttpRequestLifecycle$lambda$slambda($this_createClientPlugin, resultContinuation);
    return constructCallableReference(function (request, proceed, $completion) {
      return i.wuc(request, proceed, $completion);
    }, 2);
  }
  function attachToClientEngineJob$lambda($requestJob) {
    return function (cause) {
      if (!(cause == null)) {
        get_LOGGER_5().hsu('Cancelling request because engine Job failed with error: ' + cause.toString());
        cancel_2($requestJob, 'Engine failed', cause);
      } else {
        get_LOGGER_5().hsu('Cancelling request because engine Job completed');
        $requestJob.w1g();
      }
      return Unit_instance;
    };
  }
  function attachToClientEngineJob$lambda_0($handler) {
    return function (it) {
      $handler.s1d();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpRequestLifecycle_kt_3hmcrf;
  function _init_properties_HttpRequestLifecycle_kt__jgkmfx() {
    if (!properties_initialized_HttpRequestLifecycle_kt_3hmcrf) {
      properties_initialized_HttpRequestLifecycle_kt_3hmcrf = true;
      LOGGER_5 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestLifecycle');
      HttpRequestLifecycle = createClientPlugin_0('RequestLifecycle', HttpRequestLifecycle$lambda);
    }
  }
  function get_LOGGER_6() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return LOGGER_6;
  }
  var LOGGER_6;
  function get_HttpRequestRetryEvent() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return HttpRequestRetryEvent;
  }
  var HttpRequestRetryEvent;
  var HttpRequestRetry;
  function get_MaxRetriesPerRequestAttributeKey() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return MaxRetriesPerRequestAttributeKey;
  }
  var MaxRetriesPerRequestAttributeKey;
  function get_ShouldRetryPerRequestAttributeKey() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return ShouldRetryPerRequestAttributeKey;
  }
  var ShouldRetryPerRequestAttributeKey;
  function get_ShouldRetryOnExceptionPerRequestAttributeKey() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return ShouldRetryOnExceptionPerRequestAttributeKey;
  }
  var ShouldRetryOnExceptionPerRequestAttributeKey;
  function get_ModifyRequestPerRequestAttributeKey() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return ModifyRequestPerRequestAttributeKey;
  }
  var ModifyRequestPerRequestAttributeKey;
  function get_RetryDelayPerRequestAttributeKey() {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    return RetryDelayPerRequestAttributeKey;
  }
  var RetryDelayPerRequestAttributeKey;
  function HttpRetryEventData(request, retryCount, response, cause) {
    this.yuc_1 = request;
    this.zuc_1 = retryCount;
    this.aud_1 = response;
    this.bud_1 = cause;
  }
  function randomMs($this, randomizationMs) {
    return equalsLong(randomizationMs, new Long(0, 0)) ? new Long(0, 0) : Default_getInstance().rl(randomizationMs);
  }
  function HttpRequestRetryConfig$delay$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestRetryConfig$delay$slambda).vdf = function (it, $completion) {
    var tmp = this.wdf(it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpRequestRetryConfig$delay$slambda).ja = function (p1, $completion) {
    return this.vdf(p1 instanceof Long ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestRetryConfig$delay$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = delay(this.kud_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestRetryConfig$delay$slambda).wdf = function (it, completion) {
    var i = new HttpRequestRetryConfig$delay$slambda(completion);
    i.kud_1 = it;
    return i;
  };
  function HttpRequestRetryConfig$delay$slambda_0(resultContinuation) {
    var i = new HttpRequestRetryConfig$delay$slambda(resultContinuation);
    return constructCallableReference(function (it, $completion) {
      return i.vdf(it, $completion);
    }, 1);
  }
  function HttpRequestRetryConfig$modifyRequest$lambda(_this__u8e3s4, it) {
    return Unit_instance;
  }
  function HttpRequestRetryConfig$retryOnException$lambda($retryOnTimeout) {
    return function ($this$retryOnExceptionIf, _unused_var__etf5q3, cause) {
      var tmp;
      if (isTimeoutException(cause)) {
        tmp = $retryOnTimeout;
      } else {
        if (cause instanceof CancellationException) {
          tmp = false;
        } else {
          tmp = true;
        }
      }
      return tmp;
    };
  }
  function HttpRequestRetryConfig$retryOnServerErrors$lambda($this$retryIf, _unused_var__etf5q3, response) {
    // Inline function 'kotlin.let' call
    var it = response.zbq().yt2_1;
    return 500 <= it ? it <= 599 : false;
  }
  function HttpRequestRetryConfig$delayMillis$lambda($respectRetryAfterHeader, $block) {
    return function (_this__u8e3s4, it) {
      var tmp;
      if ($respectRetryAfterHeader) {
        var tmp0_safe_receiver = _this__u8e3s4.mud_1;
        var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.dt2();
        var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.je('Retry-After');
        var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toLongOrNull(tmp2_safe_receiver);
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.Long.times' call
          tmp_0 = multiply(tmp3_safe_receiver, fromInt(1000));
        }
        var retryAfter = tmp_0;
        var tmp0 = $block(_this__u8e3s4, it);
        // Inline function 'kotlin.comparisons.maxOf' call
        var b = retryAfter == null ? new Long(0, 0) : retryAfter;
        tmp = compare(tmp0, b) >= 0 ? tmp0 : b;
      } else {
        tmp = $block(_this__u8e3s4, it);
      }
      return tmp;
    };
  }
  function HttpRequestRetryConfig$exponentialDelay$lambda($base, $baseDelayMs, $maxDelayMs, this$0, $randomizationMs) {
    return function ($this$delayMillis, retry) {
      var tmp0 = $base;
      // Inline function 'kotlin.math.pow' call
      var n = retry - 1 | 0;
      var tmp$ret$0 = Math.pow(tmp0, n);
      var tmp0_0 = numberToLong(tmp$ret$0 * toNumber($baseDelayMs));
      // Inline function 'kotlin.comparisons.minOf' call
      var b = $maxDelayMs;
      var delay = compare(tmp0_0, b) <= 0 ? tmp0_0 : b;
      return add(delay, randomMs(this$0, $randomizationMs));
    };
  }
  function HttpRequestRetryConfig() {
    var tmp = this;
    tmp.rud_1 = HttpRequestRetryConfig$delay$slambda_0(null);
    var tmp_0 = this;
    tmp_0.sud_1 = HttpRequestRetryConfig$modifyRequest$lambda;
    this.tud_1 = 0;
    this.uud(3);
    this.vud();
  }
  protoOf(HttpRequestRetryConfig).wud = function () {
    var tmp = this.oud_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shouldRetry');
    }
  };
  protoOf(HttpRequestRetryConfig).xud = function () {
    var tmp = this.pud_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('shouldRetryOnException');
    }
  };
  protoOf(HttpRequestRetryConfig).yud = function () {
    var tmp = this.qud_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('delayMillis');
    }
  };
  protoOf(HttpRequestRetryConfig).zud = function (maxRetries, block) {
    if (!(maxRetries === -1))
      this.tud_1 = maxRetries;
    this.oud_1 = block;
  };
  protoOf(HttpRequestRetryConfig).aue = function (maxRetries, block) {
    if (!(maxRetries === -1))
      this.tud_1 = maxRetries;
    this.pud_1 = block;
  };
  protoOf(HttpRequestRetryConfig).bue = function (maxRetries, retryOnTimeout) {
    this.aue(maxRetries, HttpRequestRetryConfig$retryOnException$lambda(retryOnTimeout));
  };
  protoOf(HttpRequestRetryConfig).cue = function (maxRetries, retryOnTimeout, $super) {
    maxRetries = maxRetries === VOID ? -1 : maxRetries;
    retryOnTimeout = retryOnTimeout === VOID ? false : retryOnTimeout;
    var tmp;
    if ($super === VOID) {
      this.bue(maxRetries, retryOnTimeout);
      tmp = Unit_instance;
    } else {
      tmp = $super.bue.call(this, maxRetries, retryOnTimeout);
    }
    return tmp;
  };
  protoOf(HttpRequestRetryConfig).due = function (maxRetries) {
    this.zud(maxRetries, HttpRequestRetryConfig$retryOnServerErrors$lambda);
  };
  protoOf(HttpRequestRetryConfig).uud = function (maxRetries) {
    this.due(maxRetries);
    this.cue(maxRetries);
  };
  protoOf(HttpRequestRetryConfig).eue = function (respectRetryAfterHeader, block) {
    var tmp = this;
    tmp.qud_1 = HttpRequestRetryConfig$delayMillis$lambda(respectRetryAfterHeader, block);
  };
  protoOf(HttpRequestRetryConfig).fue = function (base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader) {
    // Inline function 'kotlin.check' call
    if (!(base > 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(baseDelayMs, new Long(0, 0)) > 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(maxDelayMs, new Long(0, 0)) > 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    // Inline function 'kotlin.check' call
    if (!(compare(randomizationMs, new Long(0, 0)) >= 0)) {
      throw IllegalStateException_init_$Create$('Check failed.');
    }
    this.eue(respectRetryAfterHeader, HttpRequestRetryConfig$exponentialDelay$lambda(base, baseDelayMs, maxDelayMs, this, randomizationMs));
  };
  protoOf(HttpRequestRetryConfig).vud = function (base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader, $super) {
    base = base === VOID ? 2.0 : base;
    baseDelayMs = baseDelayMs === VOID ? new Long(1000, 0) : baseDelayMs;
    maxDelayMs = maxDelayMs === VOID ? new Long(60000, 0) : maxDelayMs;
    randomizationMs = randomizationMs === VOID ? new Long(1000, 0) : randomizationMs;
    respectRetryAfterHeader = respectRetryAfterHeader === VOID ? true : respectRetryAfterHeader;
    var tmp;
    if ($super === VOID) {
      this.fue(base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
      tmp = Unit_instance;
    } else {
      tmp = $super.fue.call(this, base, baseDelayMs, maxDelayMs, randomizationMs, respectRetryAfterHeader);
    }
    return tmp;
  };
  function HttpRetryShouldRetryContext(retryCount) {
    this.gue_1 = retryCount;
  }
  function HttpRetryDelayContext(request, response, cause) {
    this.lud_1 = request;
    this.mud_1 = response;
    this.nud_1 = cause;
  }
  function HttpRetryModifyRequestContext(request, response, cause, retryCount) {
    this.hue_1 = request;
    this.iue_1 = response;
    this.jue_1 = cause;
    this.kue_1 = retryCount;
  }
  function throwOnInvalidResponseBody(_this__u8e3s4, $completion) {
    var tmp = new $throwOnInvalidResponseBodyCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function isTimeoutException(_this__u8e3s4) {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    var exception = unwrapCancellationException(_this__u8e3s4);
    var tmp;
    var tmp_0;
    if (exception instanceof HttpRequestTimeoutException) {
      tmp_0 = true;
    } else {
      tmp_0 = exception instanceof ConnectTimeoutException;
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = exception instanceof SocketTimeoutException;
    }
    return tmp;
  }
  function HttpRequestRetryConfig$_init_$ref_mqbboi() {
    return constructCallableReference(function () {
      return new HttpRequestRetryConfig();
    }, 0, 0, 509, '<init>');
  }
  function HttpRequestRetry$lambda($this$createClientPlugin) {
    _init_properties_HttpRequestRetry_kt__h4xjtt();
    var shouldRetry = $this$createClientPlugin.xtz_1.wud();
    var shouldRetryOnException = $this$createClientPlugin.xtz_1.xud();
    var delayMillis = $this$createClientPlugin.xtz_1.yud();
    var delay = $this$createClientPlugin.xtz_1.rud_1;
    var maxRetries = $this$createClientPlugin.xtz_1.tud_1;
    var modifyRequest = $this$createClientPlugin.xtz_1.sud_1;
    $this$createClientPlugin.xue(HttpRequestRetry$lambda$slambda_0(maxRetries, null));
    var tmp = Send_instance;
    $this$createClientPlugin.au0(tmp, HttpRequestRetry$lambda$slambda_2(shouldRetry, shouldRetryOnException, maxRetries, delayMillis, modifyRequest, $this$createClientPlugin, delay, null));
    return Unit_instance;
  }
  function HttpRequestRetry$lambda$prepareRequest$lambda($subRequest) {
    return function (cause) {
      var tmp = $subRequest.cts_1;
      var subRequestJob = isInterface(tmp, CompletableJob) ? tmp : THROW_CCE();
      if (cause == null) {
        subRequestJob.w1g();
      } else {
        subRequestJob.v1g(cause);
      }
      return Unit_instance;
    };
  }
  function invoke$shouldRetry(retryCount, maxRetries, shouldRetry, call) {
    return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), call.ftt(), call.ytq());
  }
  function invoke$shouldRetryOnException(retryCount, maxRetries, shouldRetry, subRequest, cause) {
    return retryCount < maxRetries && shouldRetry(new HttpRetryShouldRetryContext(retryCount + 1 | 0), subRequest, cause);
  }
  function invoke$prepareRequest(request) {
    var subRequest = (new HttpRequestBuilder()).yue(request);
    var tmp = request.cts_1;
    tmp.t1a(HttpRequestRetry$lambda$prepareRequest$lambda(subRequest));
    return subRequest;
  }
  function HttpRequestRetry$lambda$slambda($maxRetries, resultContinuation) {
    this.huf_1 = $maxRetries;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestRetry$lambda$slambda).luf = function ($this$onRequest, request, _unused_var__etf5q3, $completion) {
    var tmp = this.muf($this$onRequest, request, _unused_var__etf5q3, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpRequestRetry$lambda$slambda).qqa = function (p1, p2, p3, $completion) {
    var tmp = p1 instanceof OnRequestContext ? p1 : THROW_CCE();
    var tmp_0 = p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE();
    return this.luf(tmp, tmp_0, !(p3 == null) ? p3 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestRetry$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp0_elvis_lhs = this.juf_1.dts_1.usn(get_MaxRetriesPerRequestAttributeKey());
          var maxRetriesValue = tmp0_elvis_lhs == null ? this.huf_1 : tmp0_elvis_lhs;
          this.juf_1.dts_1.wsn(get_MaxRetriesPerRequestAttributeKey(), maxRetriesValue);
          return Unit_instance;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(HttpRequestRetry$lambda$slambda).muf = function ($this$onRequest, request, _unused_var__etf5q3, completion) {
    var i = new HttpRequestRetry$lambda$slambda(this.huf_1, completion);
    i.iuf_1 = $this$onRequest;
    i.juf_1 = request;
    i.kuf_1 = _unused_var__etf5q3;
    return i;
  };
  function HttpRequestRetry$lambda$slambda_0($maxRetries, resultContinuation) {
    var i = new HttpRequestRetry$lambda$slambda($maxRetries, resultContinuation);
    return constructCallableReference(function ($this$onRequest, request, _unused_var__etf5q3, $completion) {
      return i.luf($this$onRequest, request, _unused_var__etf5q3, $completion);
    }, 3);
  }
  function HttpRequestRetry$lambda$slambda_1($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation) {
    this.vuf_1 = $shouldRetry;
    this.wuf_1 = $shouldRetryOnException;
    this.xuf_1 = $maxRetries;
    this.yuf_1 = $delayMillis;
    this.zuf_1 = $modifyRequest;
    this.aug_1 = $this_createClientPlugin;
    this.bug_1 = $delay;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpRequestRetry$lambda$slambda_1).zu6 = function ($this$on, request, $completion) {
    var tmp = this.au7($this$on, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpRequestRetry$lambda$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
    return this.zu6(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpRequestRetry$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.fug_1 = 0;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.dug_1.dts_1.usn(get_ShouldRetryPerRequestAttributeKey());
            tmp_0.mug_1 = tmp0_elvis_lhs == null ? this.vuf_1 : tmp0_elvis_lhs;
            var tmp_1 = this;
            var tmp1_elvis_lhs = this.dug_1.dts_1.usn(get_ShouldRetryOnExceptionPerRequestAttributeKey());
            tmp_1.kug_1 = tmp1_elvis_lhs == null ? this.wuf_1 : tmp1_elvis_lhs;
            var tmp_2 = this;
            var tmp2_elvis_lhs = this.dug_1.dts_1.usn(get_MaxRetriesPerRequestAttributeKey());
            tmp_2.lug_1 = tmp2_elvis_lhs == null ? this.xuf_1 : tmp2_elvis_lhs;
            var tmp_3 = this;
            var tmp3_elvis_lhs = this.dug_1.dts_1.usn(get_RetryDelayPerRequestAttributeKey());
            tmp_3.gug_1 = tmp3_elvis_lhs == null ? this.yuf_1 : tmp3_elvis_lhs;
            var tmp_4 = this;
            var tmp4_elvis_lhs = this.dug_1.dts_1.usn(get_ModifyRequestPerRequestAttributeKey());
            tmp_4.nug_1 = tmp4_elvis_lhs == null ? this.zuf_1 : tmp4_elvis_lhs;
            this.hug_1 = null;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.jug_1 = invoke$prepareRequest(this.dug_1);
            this.o9_1 = 5;
            if (!(this.hug_1 == null)) {
              var modifyRequestContext = new HttpRetryModifyRequestContext(this.dug_1, this.hug_1.aud_1, this.hug_1.bud_1, this.hug_1.zuc_1);
              this.nug_1(modifyRequestContext, this.jug_1);
            }

            this.n9_1 = 2;
            suspendResult = this.cug_1.du7(this.jug_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.eug_1 = suspendResult;
            if (!invoke$shouldRetry(this.fug_1, this.lug_1, this.mug_1, this.eug_1)) {
              this.n9_1 = 4;
              suspendResult = throwOnInvalidResponseBody(this.eug_1.ytq(), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            var tmp_5 = this;
            this.fug_1 = this.fug_1 + 1 | 0;
            tmp_5.iug_1 = new HttpRetryEventData(this.jug_1, this.fug_1, this.eug_1.ytq(), null);
            this.o9_1 = 8;
            this.n9_1 = 6;
            continue $sm;
          case 4:
            this.o9_1 = 8;
            this.n9_1 = 9;
            continue $sm;
          case 5:
            this.o9_1 = 8;
            var tmp_6 = this.q9_1;
            if (tmp_6 instanceof Error) {
              var cause = this.q9_1;
              var tmp_7 = this;
              if (!invoke$shouldRetryOnException(this.fug_1, this.lug_1, this.kug_1, this.jug_1, cause)) {
                throw cause;
              }
              this.fug_1 = this.fug_1 + 1 | 0;
              tmp_7.iug_1 = new HttpRetryEventData(this.jug_1, this.fug_1, null, cause);
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 8;
            var retryData = this.iug_1;
            this.hug_1 = retryData;
            this.aug_1.wtz_1.ztp_1.usu(get_HttpRequestRetryEvent(), this.hug_1);
            var delayContext = new HttpRetryDelayContext(this.hug_1.yuc_1, this.hug_1.aud_1, this.hug_1.bud_1);
            this.n9_1 = 7;
            suspendResult = this.bug_1(this.gug_1(delayContext, this.fug_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            get_LOGGER_6().hsu('Retrying request ' + this.dug_1.ytr_1.toString() + ' attempt: ' + this.fug_1);
            this.n9_1 = 1;
            continue $sm;
          case 8:
            throw this.q9_1;
          case 9:
            return this.eug_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpRequestRetry$lambda$slambda_1).au7 = function ($this$on, request, completion) {
    var i = new HttpRequestRetry$lambda$slambda_1(this.vuf_1, this.wuf_1, this.xuf_1, this.yuf_1, this.zuf_1, this.aug_1, this.bug_1, completion);
    i.cug_1 = $this$on;
    i.dug_1 = request;
    return i;
  };
  function HttpRequestRetry$lambda$slambda_2($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation) {
    var i = new HttpRequestRetry$lambda$slambda_1($shouldRetry, $shouldRetryOnException, $maxRetries, $delayMillis, $modifyRequest, $this_createClientPlugin, $delay, resultContinuation);
    return constructCallableReference(function ($this$on, request, $completion) {
      return i.zu6($this$on, request, $completion);
    }, 2);
  }
  function $throwOnInvalidResponseBodyCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tue_1 = _this__u8e3s4;
  }
  protoOf($throwOnInvalidResponseBodyCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            if (get_isSaved(this.tue_1)) {
              this.uue_1 = this.tue_1.utt();
              this.n9_1 = 1;
              continue $sm;
            } else {
              this.vue_1 = false;
              this.n9_1 = 4;
              continue $sm;
            }

          case 1:
            this.o9_1 = 5;
            this.n9_1 = 2;
            suspendResult = this.uue_1.ssc(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.wue_1 = suspendResult;
            this.o9_1 = 6;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_0 = this.wue_1;
            this.o9_1 = 6;
            var this_0 = this.uue_1;
            var tmp_1;
            try {
              cancel_1(this_0);
              tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Error) {
                var e = $p;
                tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            var this_1 = tmp_1;
            var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              get_LOGGER_6().gsu('Failed to close response body channel', tmp0_safe_receiver);
            }

            this.vue_1 = tmp_0;
            this.n9_1 = 4;
            continue $sm;
          case 4:
            return this.vue_1;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            var this_2 = this.uue_1;
            var tmp_3;
            try {
              cancel_1(this_2);
              tmp_3 = _Result___init__impl__xyqfz8(Unit_instance);
            } catch ($p_0) {
              var tmp_4;
              if ($p_0 instanceof Error) {
                var e_0 = $p_0;
                tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
              } else {
                throw $p_0;
              }
              tmp_3 = tmp_4;
            }

            var this_3 = tmp_3;
            var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_3);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              get_LOGGER_6().gsu('Failed to close response body channel', tmp0_safe_receiver_0);
            }

            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p_1) {
        var e_1 = $p_1;
        if (this.o9_1 === 6) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  var properties_initialized_HttpRequestRetry_kt_jcpv6l;
  function _init_properties_HttpRequestRetry_kt__h4xjtt() {
    if (!properties_initialized_HttpRequestRetry_kt_jcpv6l) {
      properties_initialized_HttpRequestRetry_kt_jcpv6l = true;
      LOGGER_6 = KtorSimpleLogger('io.ktor.client.plugins.HttpRequestRetry');
      HttpRequestRetryEvent = new EventDefinition();
      var tmp = HttpRequestRetryConfig$_init_$ref_mqbboi();
      HttpRequestRetry = createClientPlugin('RetryFeature', tmp, HttpRequestRetry$lambda);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'MaxRetriesPerRequestAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_0 = PrimitiveClasses_getInstance().mc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_1;
      try {
        tmp_1 = createKType(PrimitiveClasses_getInstance().mc(), arrayOf([]), false);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_2 = null;
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      var tmp$ret$2 = tmp_1;
      var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
      MaxRetriesPerRequestAttributeKey = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'ShouldRetryPerRequestAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_3 = PrimitiveClasses_getInstance().functionClass(3);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_4;
      try {
        tmp_4 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequest_0), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpResponse), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false))]), false);
      } catch ($p_0) {
        var tmp_5;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_5 = null;
        } else {
          throw $p_0;
        }
        tmp_4 = tmp_5;
      }
      var tmp$ret$2_0 = tmp_4;
      var tmp$ret$1_0 = new TypeInfo(tmp_3, tmp$ret$2_0);
      ShouldRetryPerRequestAttributeKey = new AttributeKey(name_0, tmp$ret$1_0);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_1 = 'ShouldRetryOnExceptionPerRequestAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_6 = PrimitiveClasses_getInstance().functionClass(3);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_7;
      try {
        tmp_7 = createKType(PrimitiveClasses_getInstance().functionClass(3), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryShouldRetryContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().sc(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false))]), false);
      } catch ($p_1) {
        var tmp_8;
        if ($p_1 instanceof Error) {
          var _unused_var__etf5q3_1 = $p_1;
          tmp_8 = null;
        } else {
          throw $p_1;
        }
        tmp_7 = tmp_8;
      }
      var tmp$ret$2_1 = tmp_7;
      var tmp$ret$1_1 = new TypeInfo(tmp_6, tmp$ret$2_1);
      ShouldRetryOnExceptionPerRequestAttributeKey = new AttributeKey(name_1, tmp$ret$1_1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_2 = 'ModifyRequestPerRequestAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_9 = PrimitiveClasses_getInstance().functionClass(2);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_10;
      try {
        tmp_10 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryModifyRequestContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(HttpRequestBuilder), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Unit), arrayOf([]), false))]), false);
      } catch ($p_2) {
        var tmp_11;
        if ($p_2 instanceof Error) {
          var _unused_var__etf5q3_2 = $p_2;
          tmp_11 = null;
        } else {
          throw $p_2;
        }
        tmp_10 = tmp_11;
      }
      var tmp$ret$2_2 = tmp_10;
      var tmp$ret$1_2 = new TypeInfo(tmp_9, tmp$ret$2_2);
      ModifyRequestPerRequestAttributeKey = new AttributeKey(name_2, tmp$ret$1_2);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_3 = 'RetryDelayPerRequestAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_12 = PrimitiveClasses_getInstance().functionClass(2);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_13;
      try {
        tmp_13 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(HttpRetryDelayContext), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().mc(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(Long), arrayOf([]), false))]), false);
      } catch ($p_3) {
        var tmp_14;
        if ($p_3 instanceof Error) {
          var _unused_var__etf5q3_3 = $p_3;
          tmp_14 = null;
        } else {
          throw $p_3;
        }
        tmp_13 = tmp_14;
      }
      var tmp$ret$2_3 = tmp_13;
      var tmp$ret$1_3 = new TypeInfo(tmp_12, tmp$ret$2_3);
      RetryDelayPerRequestAttributeKey = new AttributeKey(name_3, tmp$ret$1_3);
    }
  }
  function HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation) {
    this.wug_1 = $plugin;
    this.xug_1 = $scope;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpSend$Plugin$install$slambda).rtq = function ($this$intercept, content, $completion) {
    var tmp = this.stq($this$intercept, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpSend$Plugin$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpSend$Plugin$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this.zug_1;
            if (!(tmp_0 instanceof OutgoingContent)) {
              var message = trimMargin('\n|Fail to prepare request body for sending. \n|The body type is: ' + toString(getKClassFromExpression(this.zug_1)) + ', with Content-Type: ' + toString_0(contentType(this.yug_1.kst_1)) + '.\n|\n|If you expect serialized body, please check that you have installed the corresponding plugin(like `ContentNegotiation`) and set `Content-Type` header.');
              throw IllegalStateException_init_$Create$(toString(message));
            }

            var tmp0 = this.yug_1.kst_1;
            var body = this.zug_1;
            if (body == null) {
              tmp0.bts_1 = NullBody_instance;
              var tmp_1 = getKClass(OutgoingContent);
              var tmp_2;
              try {
                tmp_2 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
              } catch ($p) {
                var tmp_3;
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                  tmp_3 = null;
                } else {
                  throw $p;
                }
                tmp_2 = tmp_3;
              }
              tmp0.qtx(new TypeInfo(tmp_1, tmp_2));
            } else {
              if (body instanceof OutgoingContent) {
                tmp0.bts_1 = body;
                tmp0.qtx(null);
              } else {
                tmp0.bts_1 = body;
                var tmp_4 = getKClass(OutgoingContent);
                var tmp_5;
                try {
                  tmp_5 = createKType(getKClass(OutgoingContent), arrayOf([]), false);
                } catch ($p_0) {
                  var tmp_6;
                  if ($p_0 instanceof Error) {
                    var _unused_var__etf5q3_0 = $p_0;
                    tmp_6 = null;
                  } else {
                    throw $p_0;
                  }
                  tmp_5 = tmp_6;
                }
                tmp0.qtx(new TypeInfo(tmp_4, tmp_5));
              }
            }

            var maxRetries = this.yug_1.kst_1.dts_1.usn(get_MaxRetriesPerRequestAttributeKey());
            var tmp_7;
            if (!(maxRetries == null) && maxRetries >= this.wug_1.auh_1) {
              var tmp_8;
              if (maxRetries < 2147483647) {
                tmp_8 = maxRetries + 1 | 0;
              } else {
                tmp_8 = maxRetries;
              }
              tmp_7 = tmp_8;
            } else {
              tmp_7 = this.wug_1.auh_1;
            }

            var maxSendCount = tmp_7;
            var realSender = new DefaultSender(maxSendCount, this.xug_1);
            var interceptedSender = realSender;
            var _iterator__ex2g4s = reversed(this.wug_1.buh_1).t();
            while (_iterator__ex2g4s.u()) {
              var interceptor = _iterator__ex2g4s.v();
              interceptedSender = new InterceptedSender(interceptor, interceptedSender);
            }

            this.n9_1 = 1;
            suspendResult = interceptedSender.cuh(this.yug_1.kst_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var call = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.yug_1.pss(call, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p_1) {
        var e = $p_1;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpSend$Plugin$install$slambda).stq = function ($this$intercept, content, completion) {
    var i = new HttpSend$Plugin$install$slambda(this.wug_1, this.xug_1, completion);
    i.yug_1 = $this$intercept;
    i.zug_1 = content;
    return i;
  };
  function HttpSend$Plugin$install$slambda_0($plugin, $scope, resultContinuation) {
    var i = new HttpSend$Plugin$install$slambda($plugin, $scope, resultContinuation);
    return constructCallableReference(function ($this$intercept, content, $completion) {
      return i.rtq($this$intercept, content, $completion);
    }, 2);
  }
  function $executeCOROUTINE$_0(_this__u8e3s4, requestBuilder, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.luh_1 = _this__u8e3s4;
    this.muh_1 = requestBuilder;
  }
  protoOf($executeCOROUTINE$_0).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_safe_receiver = this.luh_1.quh_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              cancel(tmp0_safe_receiver);
            }

            if (this.luh_1.puh_1 >= this.luh_1.nuh_1) {
              throw new SendCountExceedException('Max send count ' + this.luh_1.nuh_1 + ' exceeded. Consider increasing the property ' + 'maxSendCount if more is required.');
            }

            var _unary__edvuaz = this.luh_1.puh_1;
            this.luh_1.puh_1 = _unary__edvuaz + 1 | 0;
            this.n9_1 = 1;
            suspendResult = this.luh_1.ouh_1.vtp_1.jst(this.muh_1, this.muh_1.bts_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var sendResult = suspendResult;
            var tmp1_elvis_lhs = sendResult instanceof HttpClientCall ? sendResult : null;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              var message = 'Failed to execute send pipeline. Expected [HttpClientCall], but received ' + toString(sendResult);
              throw IllegalStateException_init_$Create$(toString(message));
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var call = tmp_0;
            this.luh_1.quh_1 = call;
            return call;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function Config() {
    this.ruh_1 = 20;
  }
  function Plugin_0() {
    Plugin_instance_0 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'HttpSend';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(HttpSend);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(HttpSend), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.suh_1 = new AttributeKey(name, tmp$ret$1);
  }
  protoOf(Plugin_0).t1 = function () {
    return this.suh_1;
  };
  protoOf(Plugin_0).tuh = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config();
    block(this_0);
    var config = this_0;
    return new HttpSend(config.ruh_1);
  };
  protoOf(Plugin_0).ctt = function (block) {
    return this.tuh(block);
  };
  protoOf(Plugin_0).uuh = function (plugin, scope) {
    var tmp = Phases_getInstance_0().ctz_1;
    scope.ttp_1.ost(tmp, HttpSend$Plugin$install$slambda_0(plugin, scope, null));
  };
  protoOf(Plugin_0).dtt = function (plugin, scope) {
    return this.uuh(plugin instanceof HttpSend ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_0;
  function Plugin_getInstance_0() {
    if (Plugin_instance_0 == null)
      new Plugin_0();
    return Plugin_instance_0;
  }
  function InterceptedSender(interceptor, nextSender) {
    this.vuh_1 = interceptor;
    this.wuh_1 = nextSender;
  }
  protoOf(InterceptedSender).cuh = function (requestBuilder, $completion) {
    return this.vuh_1(this.wuh_1, requestBuilder, $completion);
  };
  function DefaultSender(maxSendCount, client) {
    this.nuh_1 = maxSendCount;
    this.ouh_1 = client;
    this.puh_1 = 0;
    this.quh_1 = null;
  }
  protoOf(DefaultSender).cuh = function (requestBuilder, $completion) {
    var tmp = new $executeCOROUTINE$_0(this, requestBuilder, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function HttpSend(maxSendCount) {
    Plugin_getInstance_0();
    maxSendCount = maxSendCount === VOID ? 20 : maxSendCount;
    this.auh_1 = maxSendCount;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.buh_1 = ArrayList_init_$Create$();
  }
  protoOf(HttpSend).xuh = function (block) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.buh_1.j1(block);
  };
  function Sender() {
  }
  function SendCountExceedException(message) {
    IllegalStateException_init_$Init$_0(message, this);
    captureStack(this, SendCountExceedException);
  }
  function get_LOGGER_7() {
    _init_properties_HttpTimeout_kt__pucqrr();
    return LOGGER_7;
  }
  var LOGGER_7;
  function get_HttpTimeout() {
    _init_properties_HttpTimeout_kt__pucqrr();
    return HttpTimeout;
  }
  var HttpTimeout;
  function HttpTimeoutCapability() {
  }
  protoOf(HttpTimeoutCapability).toString = function () {
    return 'HttpTimeoutCapability';
  };
  protoOf(HttpTimeoutCapability).hashCode = function () {
    return 2058496954;
  };
  protoOf(HttpTimeoutCapability).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpTimeoutCapability))
      return false;
    return true;
  };
  var HttpTimeoutCapability_instance;
  function HttpTimeoutCapability_getInstance() {
    return HttpTimeoutCapability_instance;
  }
  function HttpRequestTimeoutException_init_$Init$(request, $this) {
    var tmp = request.ytr_1.ft7();
    var tmp0_safe_receiver = request.yuh(HttpTimeoutCapability_instance);
    HttpRequestTimeoutException.call($this, tmp, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.cui());
    return $this;
  }
  function HttpRequestTimeoutException_init_$Create$(request) {
    var tmp = HttpRequestTimeoutException_init_$Init$(request, objectCreate(protoOf(HttpRequestTimeoutException)));
    captureStack(tmp, HttpRequestTimeoutException_init_$Create$);
    return tmp;
  }
  function HttpRequestTimeoutException(url, timeoutMillis, cause) {
    cause = cause === VOID ? null : cause;
    IOException_init_$Init$('Request timeout has expired [url=' + url + ', request_timeout=' + toString(timeoutMillis == null ? 'unknown' : timeoutMillis) + ' ms]', cause, this);
    captureStack(this, HttpRequestTimeoutException);
    this.dui_1 = url;
    this.eui_1 = timeoutMillis;
  }
  protoOf(HttpRequestTimeoutException).n1h = function () {
    return new HttpRequestTimeoutException(this.dui_1, this.eui_1, this.cause);
  };
  function HttpTimeoutConfig_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, $this) {
    requestTimeoutMillis = requestTimeoutMillis === VOID ? null : requestTimeoutMillis;
    connectTimeoutMillis = connectTimeoutMillis === VOID ? null : connectTimeoutMillis;
    socketTimeoutMillis = socketTimeoutMillis === VOID ? null : socketTimeoutMillis;
    HttpTimeoutConfig.call($this);
    $this.fui(requestTimeoutMillis);
    $this.gui(connectTimeoutMillis);
    $this.hui(socketTimeoutMillis);
    return $this;
  }
  function HttpTimeoutConfig_init_$Create$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis) {
    return HttpTimeoutConfig_init_$Init$(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, objectCreate(protoOf(HttpTimeoutConfig)));
  }
  function checkTimeoutValue($this, value) {
    // Inline function 'kotlin.require' call
    if (!(value == null || compare(value, new Long(0, 0)) > 0)) {
      var message = 'Only positive timeout values are allowed, for infinite timeout use HttpTimeoutConfig.INFINITE_TIMEOUT_MS';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return value;
  }
  function Companion_1() {
    Companion_instance_2 = this;
    this.iui_1 = new Long(-1, 2147483647);
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'TimeoutConfiguration';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(HttpTimeoutConfig);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(HttpTimeoutConfig), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.jui_1 = new AttributeKey(name, tmp$ret$1);
  }
  var Companion_instance_2;
  function Companion_getInstance_10() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  protoOf(HttpTimeoutConfig).fui = function (value) {
    this.zuh_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutConfig).cui = function () {
    return this.zuh_1;
  };
  protoOf(HttpTimeoutConfig).gui = function (value) {
    this.aui_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutConfig).kui = function () {
    return this.aui_1;
  };
  protoOf(HttpTimeoutConfig).hui = function (value) {
    this.bui_1 = checkTimeoutValue(this, value);
  };
  protoOf(HttpTimeoutConfig).lui = function () {
    return this.bui_1;
  };
  protoOf(HttpTimeoutConfig).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof HttpTimeoutConfig))
      THROW_CCE();
    if (!equals(this.zuh_1, other.zuh_1))
      return false;
    if (!equals(this.aui_1, other.aui_1))
      return false;
    if (!equals(this.bui_1, other.bui_1))
      return false;
    return true;
  };
  protoOf(HttpTimeoutConfig).hashCode = function () {
    var tmp0_safe_receiver = this.zuh_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    var result = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var tmp = imul(31, result);
    var tmp2_safe_receiver = this.aui_1;
    var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.hashCode();
    result = tmp + (tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs) | 0;
    var tmp_0 = imul(31, result);
    var tmp4_safe_receiver = this.bui_1;
    var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.hashCode();
    result = tmp_0 + (tmp5_elvis_lhs == null ? 0 : tmp5_elvis_lhs) | 0;
    return result;
  };
  function HttpTimeoutConfig() {
    Companion_getInstance_10();
    this.zuh_1 = new Long(0, 0);
    this.aui_1 = new Long(0, 0);
    this.bui_1 = new Long(0, 0);
  }
  function get_supportsRequestTimeout(_this__u8e3s4) {
    _init_properties_HttpTimeout_kt__pucqrr();
    var tmp;
    var tmp_0;
    if (!isWebsocket(_this__u8e3s4.ytr_1.tt5())) {
      var tmp_1 = _this__u8e3s4.bts_1;
      tmp_0 = !(tmp_1 instanceof ClientUpgradeContent);
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      var tmp_2 = _this__u8e3s4.bts_1;
      tmp = !(tmp_2 instanceof SSEClientContent);
    } else {
      tmp = false;
    }
    return tmp;
  }
  function applyRequestTimeout(_this__u8e3s4, request, requestTimeout) {
    _init_properties_HttpTimeout_kt__pucqrr();
    if (requestTimeout == null || equals(requestTimeout, new Long(-1, 2147483647)))
      return Unit_instance;
    var executionContext = request.cts_1;
    var tmp = new CoroutineName('request-timeout');
    var killer = launch(_this__u8e3s4, tmp, VOID, applyRequestTimeout$slambda_0(requestTimeout, request, executionContext, null));
    var tmp_0 = request.cts_1;
    tmp_0.t1a(applyRequestTimeout$lambda(killer));
  }
  function timeout(_this__u8e3s4, block) {
    _init_properties_HttpTimeout_kt__pucqrr();
    var tmp = HttpTimeoutCapability_instance;
    // Inline function 'kotlin.apply' call
    var this_0 = HttpTimeoutConfig_init_$Create$();
    block(this_0);
    return _this__u8e3s4.mui(tmp, this_0);
  }
  function HttpTimeoutConfig$_init_$ref_dl1k0m() {
    return constructCallableReference(function () {
      return HttpTimeoutConfig_init_$Create$();
    }, 0, 0, 510);
  }
  function HttpTimeout$lambda($this$createClientPlugin) {
    _init_properties_HttpTimeout_kt__pucqrr();
    var requestTimeoutMillis = $this$createClientPlugin.xtz_1.cui();
    var connectTimeoutMillis = $this$createClientPlugin.xtz_1.kui();
    var socketTimeoutMillis = $this$createClientPlugin.xtz_1.lui();
    var tmp = Send_instance;
    $this$createClientPlugin.au0(tmp, HttpTimeout$lambda$slambda_0(connectTimeoutMillis, socketTimeoutMillis, requestTimeoutMillis, null));
    return Unit_instance;
  }
  function invoke$hasNotNullTimeouts(requestTimeoutMillis, connectTimeoutMillis, socketTimeoutMillis, supportsRequestTimeout) {
    return supportsRequestTimeout && !(requestTimeoutMillis == null) || !(connectTimeoutMillis == null) || !(socketTimeoutMillis == null);
  }
  function HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation) {
    this.vui_1 = $connectTimeoutMillis;
    this.wui_1 = $socketTimeoutMillis;
    this.xui_1 = $requestTimeoutMillis;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpTimeout$lambda$slambda).zu6 = function ($this$on, request, $completion) {
    var tmp = this.au7($this$on, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpTimeout$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof Sender_0 ? p1 : THROW_CCE();
    return this.zu6(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(HttpTimeout$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var supportsRequestTimeout = get_supportsRequestTimeout(this.zui_1);
            var configuration = this.zui_1.yuh(HttpTimeoutCapability_instance);
            if (configuration == null && invoke$hasNotNullTimeouts(this.xui_1, this.vui_1, this.wui_1, supportsRequestTimeout)) {
              configuration = HttpTimeoutConfig_init_$Create$();
              this.zui_1.mui(HttpTimeoutCapability_instance, configuration);
            }

            var tmp0_safe_receiver = configuration;
            if (tmp0_safe_receiver == null)
              null;
            else {
              var tmp0_elvis_lhs = tmp0_safe_receiver.kui();
              tmp0_safe_receiver.gui(tmp0_elvis_lhs == null ? this.vui_1 : tmp0_elvis_lhs);
              var tmp1_elvis_lhs = tmp0_safe_receiver.lui();
              tmp0_safe_receiver.hui(tmp1_elvis_lhs == null ? this.wui_1 : tmp1_elvis_lhs);
              if (supportsRequestTimeout) {
                var tmp2_elvis_lhs = tmp0_safe_receiver.cui();
                tmp0_safe_receiver.fui(tmp2_elvis_lhs == null ? this.xui_1 : tmp2_elvis_lhs);
                applyRequestTimeout(this.yui_1, this.zui_1, tmp0_safe_receiver.cui());
              }
            }

            this.n9_1 = 1;
            suspendResult = this.yui_1.du7(this.zui_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpTimeout$lambda$slambda).au7 = function ($this$on, request, completion) {
    var i = new HttpTimeout$lambda$slambda(this.vui_1, this.wui_1, this.xui_1, completion);
    i.yui_1 = $this$on;
    i.zui_1 = request;
    return i;
  };
  function HttpTimeout$lambda$slambda_0($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation) {
    var i = new HttpTimeout$lambda$slambda($connectTimeoutMillis, $socketTimeoutMillis, $requestTimeoutMillis, resultContinuation);
    return constructCallableReference(function ($this$on, request, $completion) {
      return i.zu6($this$on, request, $completion);
    }, 2);
  }
  function applyRequestTimeout$slambda($requestTimeout, $request, $executionContext, resultContinuation) {
    this.iuj_1 = $requestTimeout;
    this.juj_1 = $request;
    this.kuj_1 = $executionContext;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(applyRequestTimeout$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(applyRequestTimeout$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(applyRequestTimeout$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            Companion_getInstance_3();
            var this_0 = this.iuj_1;
            suspendResult = delay_0(toDuration(this_0, DurationUnit_MILLISECONDS_getInstance()), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var cause = HttpRequestTimeoutException_init_$Create$(this.juj_1);
            var this_1 = get_LOGGER_7();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Request timeout: ' + this.juj_1.ytr_1.toString());
            }

            cancel_2(this.kuj_1, ensureNotNull(cause.message), cause);
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(applyRequestTimeout$slambda).q24 = function ($this$launch, completion) {
    var i = new applyRequestTimeout$slambda(this.iuj_1, this.juj_1, this.kuj_1, completion);
    i.luj_1 = $this$launch;
    return i;
  };
  function applyRequestTimeout$slambda_0($requestTimeout, $request, $executionContext, resultContinuation) {
    var i = new applyRequestTimeout$slambda($requestTimeout, $request, $executionContext, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function applyRequestTimeout$lambda($killer) {
    return function (it) {
      $killer.b1b();
      return Unit_instance;
    };
  }
  var properties_initialized_HttpTimeout_kt_9oyjbd;
  function _init_properties_HttpTimeout_kt__pucqrr() {
    if (!properties_initialized_HttpTimeout_kt_9oyjbd) {
      properties_initialized_HttpTimeout_kt_9oyjbd = true;
      LOGGER_7 = KtorSimpleLogger('io.ktor.client.plugins.HttpTimeout');
      var tmp = HttpTimeoutConfig$_init_$ref_dl1k0m();
      HttpTimeout = createClientPlugin('HttpTimeout', tmp, HttpTimeout$lambda);
    }
  }
  function get_SKIP_SAVE_BODY() {
    _init_properties_SaveBody_kt__lbc3fj();
    return SKIP_SAVE_BODY;
  }
  var SKIP_SAVE_BODY;
  function get_RESPONSE_BODY_SAVED() {
    _init_properties_SaveBody_kt__lbc3fj();
    return RESPONSE_BODY_SAVED;
  }
  var RESPONSE_BODY_SAVED;
  function get_LOGGER_8() {
    _init_properties_SaveBody_kt__lbc3fj();
    var tmp0 = LOGGER$delegate;
    var tmp = KProperty0;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('LOGGER', 0, tmp, _get_LOGGER_$ref_77hhxy(), null);
    return tmp0.u1();
  }
  var LOGGER$delegate;
  function get_SaveBody() {
    _init_properties_SaveBody_kt__lbc3fj();
    return SaveBody;
  }
  var SaveBody;
  var SaveBodyPlugin;
  function get_isSaved(_this__u8e3s4) {
    _init_properties_SaveBody_kt__lbc3fj();
    return _this__u8e3s4.mtt().gtt().vsn(get_RESPONSE_BODY_SAVED());
  }
  function SaveBodyPluginConfig() {
    this.muj_1 = false;
  }
  function skipSaveBody(_this__u8e3s4) {
    _init_properties_SaveBody_kt__lbc3fj();
    _this__u8e3s4.dts_1.wsn(get_SKIP_SAVE_BODY(), Unit_instance);
  }
  function LOGGER$delegate$lambda() {
    _init_properties_SaveBody_kt__lbc3fj();
    return KtorSimpleLogger('io.ktor.client.plugins.SaveBody');
  }
  function _get_LOGGER_$ref_77hhxy() {
    return constructCallableReference(function () {
      return get_LOGGER_8();
    }, 0, 0, 511);
  }
  function SaveBody$lambda($this$createClientPlugin) {
    _init_properties_SaveBody_kt__lbc3fj();
    var tmp = Phases_getInstance_1().stz_1;
    $this$createClientPlugin.wtz_1.wtp_1.ost(tmp, SaveBody$lambda$slambda_0(null));
    return Unit_instance;
  }
  function SaveBody$lambda$slambda(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SaveBody$lambda$slambda).ptz = function ($this$intercept, response, $completion) {
    var tmp = this.qtz($this$intercept, response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SaveBody$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.ptz(tmp, p2 instanceof HttpResponse ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SaveBody$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.zuj_1 = this.wuj_1.mtt();
            this.xuj_1 = this.zuj_1.gtt();
            if (this.xuj_1.vsn(get_SKIP_SAVE_BODY())) {
              var this_0 = get_LOGGER_8();
              if (get_isTraceEnabled(this_0)) {
                this_0.hsu('Skipping body saving for ' + this.zuj_1.ftt().ott().toString());
              }
              return Unit_instance;
            }

            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 5;
            var this_1 = get_LOGGER_8();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Saving body for ' + this.zuj_1.ftt().ott().toString());
            }

            this.n9_1 = 2;
            suspendResult = save(this.zuj_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.yuj_1 = suspendResult.ytq();
            this.o9_1 = 6;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            var tmp_0 = this.yuj_1;
            this.o9_1 = 6;
            this.vuj_1;
            var tmp_1;
            try {
              cancel_1(this.wuj_1.utt());
              tmp_1 = _Result___init__impl__xyqfz8(Unit_instance);
            } catch ($p) {
              var tmp_2;
              if ($p instanceof Error) {
                var e = $p;
                tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
              } else {
                throw $p;
              }
              tmp_1 = tmp_2;
            }

            var this_2 = tmp_1;
            var tmp0_safe_receiver = Result__exceptionOrNull_impl_p6xea9(this_2);
            if (tmp0_safe_receiver == null)
              null;
            else {
              get_LOGGER_8().gsu('Failed to cancel response body', tmp0_safe_receiver);
            }

            var savedResponse = tmp_0;
            this.xuj_1.wsn(get_RESPONSE_BODY_SAVED(), Unit_instance);
            this.n9_1 = 4;
            suspendResult = this.vuj_1.pss(savedResponse, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            return Unit_instance;
          case 5:
            this.o9_1 = 6;
            var t = this.q9_1;
            this.vuj_1;
            var tmp_3;
            try {
              cancel_1(this.wuj_1.utt());
              tmp_3 = _Result___init__impl__xyqfz8(Unit_instance);
            } catch ($p_0) {
              var tmp_4;
              if ($p_0 instanceof Error) {
                var e_0 = $p_0;
                tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
              } else {
                throw $p_0;
              }
              tmp_3 = tmp_4;
            }

            var this_3 = tmp_3;
            var tmp0_safe_receiver_0 = Result__exceptionOrNull_impl_p6xea9(this_3);
            if (tmp0_safe_receiver_0 == null)
              null;
            else {
              get_LOGGER_8().gsu('Failed to cancel response body', tmp0_safe_receiver_0);
            }

            throw t;
          case 6:
            throw this.q9_1;
        }
      } catch ($p_1) {
        var e_1 = $p_1;
        if (this.o9_1 === 6) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(SaveBody$lambda$slambda).qtz = function ($this$intercept, response, completion) {
    var i = new SaveBody$lambda$slambda(completion);
    i.vuj_1 = $this$intercept;
    i.wuj_1 = response;
    return i;
  };
  function SaveBody$lambda$slambda_0(resultContinuation) {
    var i = new SaveBody$lambda$slambda(resultContinuation);
    return constructCallableReference(function ($this$intercept, response, $completion) {
      return i.ptz($this$intercept, response, $completion);
    }, 2);
  }
  function SaveBodyPluginConfig$_init_$ref_lwjaof() {
    return constructCallableReference(function () {
      return new SaveBodyPluginConfig();
    }, 0, 0, 512, '<init>');
  }
  function SaveBodyPlugin$lambda($this$createClientPlugin) {
    _init_properties_SaveBody_kt__lbc3fj();
    if ($this$createClientPlugin.xtz_1.muj_1) {
      get_LOGGER_8().fs5('It is no longer possible to disable body saving for all requests. Use client.prepareRequest(...).execute { ... } syntax to prevent saving the body in memory.\n\nThis API is deprecated and will be removed in Ktor 4.0.0\nIf you were relying on this functionality, share your use case by commenting on this issue: https://youtrack.jetbrains.com/issue/KTOR-8367/');
    } else {
      get_LOGGER_8().fs5('The SaveBodyPlugin plugin is deprecated and can be safely removed. Request bodies are now saved in memory by default for all non-streaming responses.');
    }
    return Unit_instance;
  }
  var properties_initialized_SaveBody_kt_hzvee7;
  function _init_properties_SaveBody_kt__lbc3fj() {
    if (!properties_initialized_SaveBody_kt_hzvee7) {
      properties_initialized_SaveBody_kt_hzvee7 = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'SkipSaveBody';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(Unit);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(Unit), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      SKIP_SAVE_BODY = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'ResponseBodySaved';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = getKClass(Unit);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(getKClass(Unit), arrayOf([]), false);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_4 = null;
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$2_0 = tmp_3;
      var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
      RESPONSE_BODY_SAVED = new AttributeKey(name_0, tmp$ret$1_0);
      LOGGER$delegate = lazy(LOGGER$delegate$lambda);
      SaveBody = createClientPlugin_0('SaveBody', SaveBody$lambda);
      var tmp_5 = SaveBodyPluginConfig$_init_$ref_lwjaof();
      SaveBodyPlugin = createClientPlugin('DoubleReceivePlugin', tmp_5, SaveBodyPlugin$lambda);
    }
  }
  function HookHandler(hook, handler) {
    this.auk_1 = hook;
    this.buk_1 = handler;
  }
  protoOf(HookHandler).ets = function (client) {
    this.auk_1.dtz(client, this.buk_1);
  };
  function ClientPluginBuilder$onClose$lambda() {
    return Unit_instance;
  }
  function ClientPluginBuilder(key, client, pluginConfig) {
    this.vtz_1 = key;
    this.wtz_1 = client;
    this.xtz_1 = pluginConfig;
    var tmp = this;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp.ytz_1 = ArrayList_init_$Create$();
    var tmp_0 = this;
    tmp_0.ztz_1 = ClientPluginBuilder$onClose$lambda;
  }
  protoOf(ClientPluginBuilder).xue = function (block) {
    this.au0(RequestHook_instance, block);
  };
  protoOf(ClientPluginBuilder).cuk = function (block) {
    this.au0(TransformRequestBodyHook_instance, block);
  };
  protoOf(ClientPluginBuilder).bu9 = function (block) {
    this.au0(TransformResponseBodyHook_instance, block);
  };
  protoOf(ClientPluginBuilder).au0 = function (hook, handler) {
    this.ytz_1.j1(new HookHandler(hook, handler));
  };
  function ClientPluginInstance$onClose$lambda() {
    return Unit_instance;
  }
  function ClientPluginInstance(key, config, body) {
    this.duk_1 = key;
    this.euk_1 = config;
    this.fuk_1 = body;
    var tmp = this;
    tmp.guk_1 = ClientPluginInstance$onClose$lambda;
  }
  protoOf(ClientPluginInstance).ets = function (scope) {
    var tmp0 = new ClientPluginBuilder(this.duk_1, scope, this.euk_1);
    // Inline function 'kotlin.apply' call
    this.fuk_1(tmp0);
    var pluginBuilder = tmp0;
    this.guk_1 = pluginBuilder.ztz_1;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = pluginBuilder.ytz_1.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      element.ets(scope);
    }
  };
  protoOf(ClientPluginInstance).j4 = function () {
    this.guk_1();
  };
  function Sender_0(httpSendSender, coroutineContext) {
    this.bu7_1 = httpSendSender;
    this.cu7_1 = coroutineContext;
  }
  protoOf(Sender_0).q19 = function () {
    return this.cu7_1;
  };
  protoOf(Sender_0).du7 = function (requestBuilder, $completion) {
    return this.bu7_1.cuh(requestBuilder, $completion);
  };
  function Send$install$slambda($handler, $client, resultContinuation) {
    this.puk_1 = $handler;
    this.quk_1 = $client;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(Send$install$slambda).tuk = function ($this$intercept, request, $completion) {
    var tmp = this.uuk($this$intercept, request, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(Send$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, Sender) : false) ? p1 : THROW_CCE();
    return this.tuk(tmp, p2 instanceof HttpRequestBuilder ? p2 : THROW_CCE(), $completion);
  };
  protoOf(Send$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.puk_1(new Sender_0(this.ruk_1, this.quk_1.stp_1), this.suk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(Send$install$slambda).uuk = function ($this$intercept, request, completion) {
    var i = new Send$install$slambda(this.puk_1, this.quk_1, completion);
    i.ruk_1 = $this$intercept;
    i.suk_1 = request;
    return i;
  };
  function Send$install$slambda_0($handler, $client, resultContinuation) {
    var i = new Send$install$slambda($handler, $client, resultContinuation);
    return constructCallableReference(function ($this$intercept, request, $completion) {
      return i.tuk($this$intercept, request, $completion);
    }, 2);
  }
  function Send() {
  }
  protoOf(Send).vuk = function (client, handler) {
    var tmp = plugin(client, Plugin_getInstance_0());
    tmp.xuh(Send$install$slambda_0(handler, client, null));
  };
  protoOf(Send).dtz = function (client, handler) {
    return this.vuk(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var Send_instance;
  function Send_getInstance() {
    return Send_instance;
  }
  function SetupRequest$install$slambda($handler, resultContinuation) {
    this.eul_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SetupRequest$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SetupRequest$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SetupRequest$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.eul_1(this.ful_1.kst_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SetupRequest$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new SetupRequest$install$slambda(this.eul_1, completion);
    i.ful_1 = $this$intercept;
    i.gul_1 = it;
    return i;
  };
  function SetupRequest$install$slambda_0($handler, resultContinuation) {
    var i = new SetupRequest$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function SetupRequest() {
  }
  protoOf(SetupRequest).hul = function (client, handler) {
    var tmp = Phases_getInstance_0().yty_1;
    client.ttp_1.ost(tmp, SetupRequest$install$slambda_0(handler, null));
  };
  protoOf(SetupRequest).dtz = function (client, handler) {
    return this.hul(client, (!(handler == null) ? isSuspendFunction(handler, 1) : false) ? handler : THROW_CCE());
  };
  var SetupRequest_instance;
  function SetupRequest_getInstance() {
    return SetupRequest_instance;
  }
  function createClientPlugin(name, createConfiguration, body) {
    return new ClientPluginImpl(name, createConfiguration, body);
  }
  function createClientPlugin_0(name, body) {
    return createClientPlugin(name, createClientPlugin$lambda, body);
  }
  function ClientPluginImpl(name, createConfiguration, body) {
    this.iul_1 = createConfiguration;
    this.jul_1 = body;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(ClientPluginInstance);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(ClientPluginInstance), arrayOf([createInvariantKTypeProjection(createKType(createKTypeParameter('PluginConfigT', arrayOf([createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), false)]), 'invariant', false, 'io.ktor.client.plugins.api.ClientPluginImpl'), arrayOf([]), false))]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.kul_1 = new AttributeKey(name, tmp$ret$1);
  }
  protoOf(ClientPluginImpl).t1 = function () {
    return this.kul_1;
  };
  protoOf(ClientPluginImpl).lul = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.iul_1();
    block(this_0);
    var config = this_0;
    return new ClientPluginInstance(this.kul_1, config, this.jul_1);
  };
  protoOf(ClientPluginImpl).ctt = function (block) {
    return this.lul(block);
  };
  protoOf(ClientPluginImpl).mul = function (plugin, scope) {
    plugin.ets(scope);
  };
  protoOf(ClientPluginImpl).dtt = function (plugin, scope) {
    return this.mul(plugin instanceof ClientPluginInstance ? plugin : THROW_CCE(), scope);
  };
  function createClientPlugin$lambda() {
    return Unit_instance;
  }
  function TransformRequestBodyContext() {
  }
  function TransformResponseBodyContext() {
  }
  function OnRequestContext() {
  }
  function RequestHook$install$slambda($handler, resultContinuation) {
    this.vul_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(RequestHook$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(RequestHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(RequestHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.vul_1(new OnRequestContext(), this.wul_1.kst_1, this.wul_1.oss(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(RequestHook$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new RequestHook$install$slambda(this.vul_1, completion);
    i.wul_1 = $this$intercept;
    i.xul_1 = it;
    return i;
  };
  function RequestHook$install$slambda_0($handler, resultContinuation) {
    var i = new RequestHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function RequestHook() {
  }
  protoOf(RequestHook).yul = function (client, handler) {
    var tmp = Phases_getInstance_0().zty_1;
    client.ttp_1.ost(tmp, RequestHook$install$slambda_0(handler, null));
  };
  protoOf(RequestHook).dtz = function (client, handler) {
    return this.yul(client, (!(handler == null) ? isSuspendFunction(handler, 3) : false) ? handler : THROW_CCE());
  };
  var RequestHook_instance;
  function RequestHook_getInstance() {
    return RequestHook_instance;
  }
  function TransformRequestBodyHook$install$slambda($handler, resultContinuation) {
    this.hum_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TransformRequestBodyHook$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TransformRequestBodyHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(TransformRequestBodyHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            this.n9_1 = 1;
            suspendResult = this.hum_1(new TransformRequestBodyContext(), this.ium_1.kst_1, this.ium_1.oss(), this.ium_1.kst_1.kum(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var newContent = suspendResult;
            if (!(newContent == null)) {
              this.n9_1 = 2;
              suspendResult = this.ium_1.pss(newContent, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 3;
              continue $sm;
            }

          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TransformRequestBodyHook$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new TransformRequestBodyHook$install$slambda(this.hum_1, completion);
    i.ium_1 = $this$intercept;
    i.jum_1 = it;
    return i;
  };
  function TransformRequestBodyHook$install$slambda_0($handler, resultContinuation) {
    var i = new TransformRequestBodyHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function TransformRequestBodyHook() {
  }
  protoOf(TransformRequestBodyHook).lum = function (client, handler) {
    var tmp = Phases_getInstance_0().atz_1;
    client.ttp_1.ost(tmp, TransformRequestBodyHook$install$slambda_0(handler, null));
  };
  protoOf(TransformRequestBodyHook).dtz = function (client, handler) {
    return this.lum(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
  };
  var TransformRequestBodyHook_instance;
  function TransformRequestBodyHook_getInstance() {
    return TransformRequestBodyHook_instance;
  }
  function TransformResponseBodyHook$install$slambda($handler, resultContinuation) {
    this.uum_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(TransformResponseBodyHook$install$slambda).mtr = function ($this$intercept, it, $completion) {
    var tmp = this.ntr($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(TransformResponseBodyHook$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(TransformResponseBodyHook$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var _destruct__k2r9zo = this.vum_1.oss();
            this.xum_1 = _destruct__k2r9zo.zh();
            var content = _destruct__k2r9zo.ai();
            if (!isInterface(content, ByteReadChannel))
              return Unit_instance;
            this.n9_1 = 1;
            suspendResult = this.uum_1(new TransformResponseBodyContext(), this.vum_1.kst_1.ytq(), content, this.xum_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0;
            if (tmp0_elvis_lhs == null) {
              return Unit_instance;
            } else {
              tmp_0 = tmp0_elvis_lhs;
            }

            var newContent = tmp_0;
            var tmp_1;
            if (!(newContent instanceof NullBody)) {
              tmp_1 = !this.xum_1.bsu_1.ob(newContent);
            } else {
              tmp_1 = false;
            }

            if (tmp_1) {
              throw IllegalStateException_init_$Create$('transformResponseBody returned ' + toString(newContent) + ' but expected value of type ' + this.xum_1.toString());
            }

            this.n9_1 = 2;
            suspendResult = this.vum_1.pss(new HttpResponseContainer(this.xum_1, newContent), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(TransformResponseBodyHook$install$slambda).ntr = function ($this$intercept, it, completion) {
    var i = new TransformResponseBodyHook$install$slambda(this.uum_1, completion);
    i.vum_1 = $this$intercept;
    i.wum_1 = it;
    return i;
  };
  function TransformResponseBodyHook$install$slambda_0($handler, resultContinuation) {
    var i = new TransformResponseBodyHook$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.mtr($this$intercept, it, $completion);
    }, 2);
  }
  function TransformResponseBodyHook() {
  }
  protoOf(TransformResponseBodyHook).yum = function (client, handler) {
    var tmp = Phases_getInstance_2().xts_1;
    client.utp_1.ost(tmp, TransformResponseBodyHook$install$slambda_0(handler, null));
  };
  protoOf(TransformResponseBodyHook).dtz = function (client, handler) {
    return this.yum(client, (!(handler == null) ? isSuspendFunction(handler, 4) : false) ? handler : THROW_CCE());
  };
  var TransformResponseBodyHook_instance;
  function TransformResponseBodyHook_getInstance() {
    return TransformResponseBodyHook_instance;
  }
  function ClientSSESession(call, delegate) {
    this.zum_1 = delegate;
    this.aun_1 = call;
  }
  protoOf(ClientSSESession).ctf = function () {
    return this.zum_1.ctf();
  };
  protoOf(ClientSSESession).q19 = function () {
    return this.zum_1.q19();
  };
  function ClientSSESessionWithDeserialization(call, delegate) {
    this.bun_1 = delegate;
    this.cun_1 = call;
  }
  protoOf(ClientSSESessionWithDeserialization).q19 = function () {
    return this.bun_1.q19();
  };
  function SSESession() {
  }
  function DefaultClientSSESession_init_$Init$(content, input, $this) {
    DefaultClientSSESession.call($this, content, input, content.kun_1.xj(Job()).xj(new CoroutineName('DefaultClientSSESession')));
    return $this;
  }
  function DefaultClientSSESession_init_$Create$(content, input) {
    return DefaultClientSSESession_init_$Init$(content, input, objectCreate(protoOf(DefaultClientSSESession)));
  }
  function doReconnection($this, $completion) {
    return withContext($this.oun_1, DefaultClientSSESession$doReconnection$slambda_0($this, null), $completion);
  }
  function getRequestForReconnection($this) {
    // Inline function 'kotlin.apply' call
    var this_0 = (new HttpRequestBuilder()).yue($this.wun_1);
    this_0.dts_1.ysn(get_sseRequestAttr());
    this_0.dts_1.wsn(get_SSEReconnectionRequestAttr(), true);
    var tmp0_safe_receiver = $this.pun_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_0.ats_1.fsq('Last-Event-ID', tmp0_safe_receiver);
    }
    return this_0;
  }
  function close_0($this) {
    if (!$this.zun_1.atomicfu$compareAndSet(false, true))
      return Unit_instance;
    cancel_3($this.oun_1);
    cancel_1($this.nun_1);
    cancel_3($this.yun_1);
  }
  function tryParseEvent($this, $receiver, $completion) {
    var tmp = new $tryParseEventCOROUTINE$($this, $receiver, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function parseEvent($this, $receiver, $completion) {
    var tmp = new $parseEventCOROUTINE$($this, $receiver, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function appendComment($this, $receiver, comment) {
    $receiver.q(removePrefix(removePrefix(comment, ':'), ' ')).q('\r\n');
  }
  function readLineWithSave($this, $receiver, $completion) {
    var tmp = new $readLineWithSaveCOROUTINE$($this, $receiver, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function toText($this, $receiver) {
    return removeSuffix($receiver.toString(), '\r\n');
  }
  function isEmpty_0($this, $receiver) {
    return $receiver.gte_1 == null && $receiver.ite_1 == null && $receiver.hte_1 == null && $receiver.jte_1 == null && $receiver.kte_1 == null;
  }
  function isCommentsEvent($this, $receiver) {
    return $receiver.gte_1 == null && $receiver.hte_1 == null && $receiver.ite_1 == null && $receiver.jte_1 == null && !($receiver.kte_1 == null);
  }
  function isRetryEvent($this, $receiver) {
    return $receiver.gte_1 == null && $receiver.hte_1 == null && $receiver.ite_1 == null && $receiver.kte_1 == null && !($receiver.jte_1 == null);
  }
  function DefaultClientSSESession$_incoming$slambda(this$0, resultContinuation) {
    this.wup_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultClientSSESession$_incoming$slambda).auq = function ($this$flow, $completion) {
    var tmp = this.buq($this$flow, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultClientSSESession$_incoming$slambda).ja = function (p1, $completion) {
    return this.auq((!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 12;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!get_isActive(this.wup_1.oun_1)) {
              this.n9_1 = 11;
              continue $sm;
            }

            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!get_isActive(this.wup_1.oun_1)) {
              this.n9_1 = 8;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = tryParseEvent(this.wup_1, this.wup_1.nun_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 8;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.zup_1 = tmp0_elvis_lhs;
              this.n9_1 = 4;
              continue $sm;
            }

          case 4:
            this.yup_1 = this.zup_1;
            if (isCommentsEvent(this.wup_1, this.yup_1) && !this.wup_1.run_1) {
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 5;
              continue $sm;
            }

          case 5:
            if (isRetryEvent(this.wup_1, this.yup_1) && !this.wup_1.sun_1) {
              this.n9_1 = 2;
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            this.wup_1.vun_1.cuq(this.yup_1);
            this.n9_1 = 7;
            suspendResult = this.xup_1.a1v(this.yup_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            this.n9_1 = 2;
            continue $sm;
          case 8:
            if (this.wup_1.uun_1) {
              this.n9_1 = 9;
              suspendResult = doReconnection(this.wup_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 11;
              continue $sm;
            }

          case 9:
            this.n9_1 = 10;
            continue $sm;
          case 10:
            this.n9_1 = 1;
            continue $sm;
          case 11:
            return Unit_instance;
          case 12:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 12) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda).buq = function ($this$flow, completion) {
    var i = new DefaultClientSSESession$_incoming$slambda(this.wup_1, completion);
    i.xup_1 = $this$flow;
    return i;
  };
  function DefaultClientSSESession$_incoming$slambda_0(this$0, resultContinuation) {
    var i = new DefaultClientSSESession$_incoming$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$flow, $completion) {
      return i.auq($this$flow, $completion);
    }, 1);
  }
  function DefaultClientSSESession$_incoming$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultClientSSESession$_incoming$slambda_1).nuq = function ($this$catch, cause, $completion) {
    var tmp = this.ouq($this$catch, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.nuq(tmp, p2 instanceof Error ? p2 : THROW_CCE(), $completion);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          var tmp_0 = this.muq_1;
          if (tmp_0 instanceof CancellationException) {
            return Unit_instance;
          }
          var this_0 = get_LOGGER_9();
          if (get_isTraceEnabled(this_0)) {
            this_0.hsu('Error during SSE session processing: ' + this.muq_1.toString());
          }
          throw this.muq_1;
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_1).ouq = function ($this$catch, cause, completion) {
    var i = new DefaultClientSSESession$_incoming$slambda_1(completion);
    i.luq_1 = $this$catch;
    i.muq_1 = cause;
    return i;
  };
  function DefaultClientSSESession$_incoming$slambda_2(resultContinuation) {
    var i = new DefaultClientSSESession$_incoming$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$catch, cause, $completion) {
      return i.nuq($this$catch, cause, $completion);
    }, 2);
  }
  function DefaultClientSSESession$_incoming$slambda_3(this$0, resultContinuation) {
    this.xuq_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultClientSSESession$_incoming$slambda_3).aur = function ($this$onCompletion, cause, $completion) {
    var tmp = this.bur($this$onCompletion, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_3).ha = function (p1, p2, $completion) {
    var tmp = (!(p1 == null) ? isInterface(p1, FlowCollector) : false) ? p1 : THROW_CCE();
    return this.aur(tmp, (p2 == null ? true : p2 instanceof Error) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_3).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          close_0(this.xuq_1);
          var tmp0_subject = this.zuq_1;
          if (tmp0_subject == null)
            return Unit_instance;
          else {
            if (tmp0_subject instanceof CancellationException)
              return Unit_instance;
            else {
              throw new SSEClientException(VOID, this.zuq_1, this.zuq_1.message);
            }
          }
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(DefaultClientSSESession$_incoming$slambda_3).bur = function ($this$onCompletion, cause, completion) {
    var i = new DefaultClientSSESession$_incoming$slambda_3(this.xuq_1, completion);
    i.yuq_1 = $this$onCompletion;
    i.zuq_1 = cause;
    return i;
  };
  function DefaultClientSSESession$_incoming$slambda_4(this$0, resultContinuation) {
    var i = new DefaultClientSSESession$_incoming$slambda_3(this$0, resultContinuation);
    return constructCallableReference(function ($this$onCompletion, cause, $completion) {
      return i.aur($this$onCompletion, cause, $completion);
    }, 2);
  }
  function DefaultClientSSESession$lambda(this$0) {
    return function (it) {
      close_0(this$0);
      return Unit_instance;
    };
  }
  function DefaultClientSSESession$doReconnection$slambda(this$0, resultContinuation) {
    this.kur_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(DefaultClientSSESession$doReconnection$slambda).p24 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(DefaultClientSSESession$doReconnection$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(DefaultClientSSESession$doReconnection$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.nur_1 = 1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.nur_1 <= this.kur_1.tun_1)) {
              this.n9_1 = 7;
              continue $sm;
            }

            this.o9_1 = 5;
            cancel_1(this.kur_1.nun_1);
            this.n9_1 = 2;
            suspendResult = delay(this.kur_1.qun_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.pur_1 = getRequestForReconnection(this.kur_1);
            var this_0 = get_LOGGER_9();
            if (get_isTraceEnabled(this_0)) {
              this_0.hsu('Sending SSE request ' + this.pur_1.ytr_1.toString() + ' (attempt ' + (this.nur_1 + 1 | 0) + '/' + (this.kur_1.tun_1 + 1 | 0) + ')');
            }

            this.n9_1 = 3;
            suspendResult = this.kur_1.xun_1.att(this.pur_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.our_1 = suspendResult.ytq();
            var this_1 = get_LOGGER_9();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Receive response for reconnection SSE request to ' + this.pur_1.ytr_1.toString());
            }

            this.n9_1 = 4;
            suspendResult = checkResponse(this.our_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            if (this.our_1.zbq().equals(Companion_getInstance_1().ht3_1)) {
              this.kur_1.uun_1 = false;
            }

            this.kur_1.nun_1 = this.our_1.utt();
            var tmp_0 = this;
            return Unit_instance;
          case 5:
            this.o9_1 = 8;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              var cause = this.q9_1;
              var tmp_2 = this;
              if (this.nur_1 === this.kur_1.tun_1) {
                var this_2 = get_LOGGER_9();
                if (get_isTraceEnabled(this_2)) {
                  this_2.hsu('Max retries (' + this.kur_1.tun_1 + ') reached for SSE reconnection, closing session');
                }
                throw cause;
              }
              var this_3 = get_LOGGER_9();
              if (get_isTraceEnabled(this_3)) {
                this_3.hsu('SSE reconnection attempt ' + (this.nur_1 + 1 | 0) + ' failed');
              }
              var _unary__edvuaz = this.nur_1;
              this.nur_1 = _unary__edvuaz + 1 | 0;
              tmp_2.mur_1 = _unary__edvuaz;
              this.n9_1 = 6;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 6:
            this.o9_1 = 8;
            this.n9_1 = 1;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(DefaultClientSSESession$doReconnection$slambda).q24 = function ($this$withContext, completion) {
    var i = new DefaultClientSSESession$doReconnection$slambda(this.kur_1, completion);
    i.lur_1 = $this$withContext;
    return i;
  };
  function DefaultClientSSESession$doReconnection$slambda_0(this$0, resultContinuation) {
    var i = new DefaultClientSSESession$doReconnection$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.p24($this$withContext, $completion);
    }, 1);
  }
  function $tryParseEventCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.juo_1 = _this__u8e3s4;
    this.kuo_1 = _this__u8e3s4_0;
  }
  protoOf($tryParseEventCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = parseEvent(this.juo_1, this.kuo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.luo_1 = suspendResult;
            this.o9_1 = 3;
            this.n9_1 = 4;
            continue $sm;
          case 2:
            this.o9_1 = 3;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof IOException) {
              var cause = this.q9_1;
              var tmp_1 = this;
              var rootCause = get_rootCause(cause);
              if (rootCause instanceof SocketTimeoutException) {
                throw rootCause;
              }
              tmp_1.luo_1 = null;
              this.n9_1 = 4;
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 3:
            throw this.q9_1;
          case 4:
            this.o9_1 = 3;
            return this.luo_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $parseEventCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.uuo_1 = _this__u8e3s4;
    this.vuo_1 = _this__u8e3s4_0;
  }
  protoOf($parseEventCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 8;
            this.zuo_1 = StringBuilder_init_$Create$();
            this.cup_1 = StringBuilder_init_$Create$();
            this.bup_1 = null;
            this.yuo_1 = null;
            this.xuo_1 = this.uuo_1.pun_1;
            this.aup_1 = false;
            this.dup_1 = false;
            this.n9_1 = 1;
            suspendResult = readLineWithSave(this.uuo_1, this.vuo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_elvis_lhs = suspendResult;
            var tmp_0 = this;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              return null;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.wuo_1 = tmp_1;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            if (!isBlank(this.wuo_1)) {
              this.n9_1 = 4;
              continue $sm;
            }

            this.n9_1 = 3;
            suspendResult = readLineWithSave(this.uuo_1, this.vuo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_2 = this;
            var tmp_3;
            if (tmp1_elvis_lhs == null) {
              return null;
            } else {
              tmp_3 = tmp1_elvis_lhs;
            }

            tmp_2.wuo_1 = tmp_3;
            this.n9_1 = 2;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            continue $sm;
          case 5:
            if (!true) {
              this.n9_1 = 7;
              continue $sm;
            }

            if (isBlank(this.wuo_1)) {
              this.uuo_1.pun_1 = this.xuo_1;
              var event = new ServerSentEvent(this.aup_1 ? toText(this.uuo_1, this.zuo_1) : null, this.bup_1, this.xuo_1, this.yuo_1, this.dup_1 ? toText(this.uuo_1, this.cup_1) : null);
              if (!isEmpty_0(this.uuo_1, event)) {
                return event;
              }
            } else if (startsWith(this.wuo_1, ':')) {
              this.dup_1 = true;
              appendComment(this.uuo_1, this.cup_1, this.wuo_1);
            } else {
              var field = substringBefore(this.wuo_1, ':');
              var value = removePrefix(substringAfter(this.wuo_1, ':', ''), ' ');
              switch (field) {
                case 'event':
                  this.bup_1 = value;
                  break;
                case 'data':
                  this.aup_1 = true;
                  this.zuo_1.q(value).q('\r\n');
                  break;
                case 'retry':
                  var tmp3_safe_receiver = toLongOrNull(value);
                  if (tmp3_safe_receiver == null)
                    null;
                  else {
                    this.uuo_1.qun_1 = tmp3_safe_receiver;
                    this.yuo_1 = tmp3_safe_receiver;
                  }

                  break;
                case 'id':
                  if (!contains(value, '\x00')) {
                    this.xuo_1 = value;
                  }

                  break;
              }
            }

            this.n9_1 = 6;
            suspendResult = readLineWithSave(this.uuo_1, this.vuo_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp4_elvis_lhs = suspendResult;
            var tmp_4 = this;
            var tmp_5;
            if (tmp4_elvis_lhs == null) {
              return null;
            } else {
              tmp_5 = tmp4_elvis_lhs;
            }

            tmp_4.wuo_1 = tmp_5;
            this.n9_1 = 5;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 8) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $readLineWithSaveCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.mup_1 = _this__u8e3s4;
    this.nup_1 = _this__u8e3s4_0;
  }
  protoOf($readLineWithSaveCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = readLine(this.nup_1, LineEnding_Lenient_getInstance(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp0_safe_receiver = suspendResult;
            var tmp_0;
            if (tmp0_safe_receiver == null) {
              tmp_0 = null;
            } else {
              this.mup_1.vun_1.qur(tmp0_safe_receiver);
              tmp_0 = tmp0_safe_receiver;
            }

            return tmp_0;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function DefaultClientSSESession(content, input, coroutineContext) {
    this.nun_1 = input;
    this.oun_1 = coroutineContext;
    this.pun_1 = null;
    this.qun_1 = _Duration___get_inWholeMilliseconds__impl__msfiry(content.fun_1);
    this.run_1 = content.gun_1;
    this.sun_1 = content.hun_1;
    this.tun_1 = content.iun_1;
    this.uun_1 = this.tun_1 > 0;
    this.vun_1 = toBodyBuffer(content.jun_1);
    this.wun_1 = content.lun_1;
    this.xun_1 = this.wun_1.dts_1.tsn(get_SSEClientForReconnectionAttr());
    this.yun_1 = content.kun_1;
    this.zun_1 = atomic$boolean$1(false);
    var tmp = this;
    var tmp_0 = flow(DefaultClientSSESession$_incoming$slambda_0(this, null));
    var tmp_1 = catch_0(tmp_0, DefaultClientSSESession$_incoming$slambda_2(null));
    tmp.auo_1 = onCompletion(tmp_1, DefaultClientSSESession$_incoming$slambda_4(this, null));
    var tmp_2 = get_job(this.oun_1);
    tmp_2.t1a(DefaultClientSSESession$lambda(this));
  }
  protoOf(DefaultClientSSESession).q19 = function () {
    return this.oun_1;
  };
  protoOf(DefaultClientSSESession).ctf = function () {
    return this.auo_1;
  };
  function get_LOGGER_9() {
    _init_properties_SSE_kt__ir0g19();
    return LOGGER_8;
  }
  var LOGGER_8;
  function get_SSE() {
    _init_properties_SSE_kt__ir0g19();
    return SSE;
  }
  var SSE;
  function get_SSEClientForReconnectionAttr() {
    _init_properties_SSE_kt__ir0g19();
    return SSEClientForReconnectionAttr;
  }
  var SSEClientForReconnectionAttr;
  function get_SSEReconnectionRequestAttr() {
    _init_properties_SSE_kt__ir0g19();
    return SSEReconnectionRequestAttr;
  }
  var SSEReconnectionRequestAttr;
  function AfterRender$install$slambda($handler, resultContinuation) {
    this.zur_1 = $handler;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(AfterRender$install$slambda).rtq = function ($this$intercept, content, $completion) {
    var tmp = this.stq($this$intercept, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(AfterRender$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(AfterRender$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp_0 = this.bus_1;
            if (!(tmp_0 instanceof OutgoingContent))
              return Unit_instance;
            this.n9_1 = 1;
            suspendResult = this.zur_1(this.aus_1.kst_1, this.bus_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            this.n9_1 = 2;
            suspendResult = this.aus_1.pss(ARGUMENT, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(AfterRender$install$slambda).stq = function ($this$intercept, content, completion) {
    var i = new AfterRender$install$slambda(this.zur_1, completion);
    i.aus_1 = $this$intercept;
    i.bus_1 = content;
    return i;
  };
  function AfterRender$install$slambda_0($handler, resultContinuation) {
    var i = new AfterRender$install$slambda($handler, resultContinuation);
    return constructCallableReference(function ($this$intercept, content, $completion) {
      return i.rtq($this$intercept, content, $completion);
    }, 2);
  }
  function AfterRender() {
  }
  protoOf(AfterRender).cus = function (client, handler) {
    var phase = new PipelinePhase('AfterRender');
    client.ttp_1.lst(Phases_getInstance_0().btz_1, phase);
    client.ttp_1.ost(phase, AfterRender$install$slambda_0(handler, null));
  };
  protoOf(AfterRender).dtz = function (client, handler) {
    return this.cus(client, (!(handler == null) ? isSuspendFunction(handler, 2) : false) ? handler : THROW_CCE());
  };
  var AfterRender_instance;
  function AfterRender_getInstance() {
    return AfterRender_instance;
  }
  function getAttributeValue(request, attributeKey) {
    _init_properties_SSE_kt__ir0g19();
    return request.dts_1.usn(attributeKey);
  }
  function SSECapability() {
  }
  protoOf(SSECapability).toString = function () {
    return 'SSECapability';
  };
  protoOf(SSECapability).hashCode = function () {
    return -177755299;
  };
  protoOf(SSECapability).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SSECapability))
      return false;
    return true;
  };
  var SSECapability_instance;
  function SSECapability_getInstance() {
    return SSECapability_instance;
  }
  function checkResponse(response, $completion) {
    var tmp = new $checkResponseCOROUTINE$(response, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function SSEClientException(response, cause, message) {
    response = response === VOID ? null : response;
    cause = cause === VOID ? null : cause;
    message = message === VOID ? null : message;
    IllegalStateException_init_$Init$(this);
    captureStack(this, SSEClientException);
    this.ous_1 = response;
    this.pus_1 = cause;
    this.qus_1 = message;
    delete this.cause;
    delete this.message;
  }
  protoOf(SSEClientException).f = function () {
    return this.pus_1;
  };
  protoOf(SSEClientException).e = function () {
    return this.qus_1;
  };
  function saved(_this__u8e3s4, $completion) {
    var tmp = new $savedCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function SSEConfig$_init_$ref_nhmcny() {
    return constructCallableReference(function () {
      return new SSEConfig();
    }, 0, 0, 513, '<init>');
  }
  function SSE$lambda($this$createClientPlugin) {
    _init_properties_SSE_kt__ir0g19();
    var reconnectionTime = $this$createClientPlugin.xtz_1.cut_1;
    var showCommentEvents = $this$createClientPlugin.xtz_1.aut_1;
    var showRetryEvents = $this$createClientPlugin.xtz_1.but_1;
    var maxReconnectionAttempts = $this$createClientPlugin.xtz_1.dut_1;
    var bufferPolicy = $this$createClientPlugin.xtz_1.eut_1;
    var tmp = AfterRender_instance;
    $this$createClientPlugin.au0(tmp, SSE$lambda$slambda_0($this$createClientPlugin, reconnectionTime, showCommentEvents, showRetryEvents, maxReconnectionAttempts, bufferPolicy, null));
    var tmp_0 = Phases_getInstance_2().xts_1;
    $this$createClientPlugin.wtz_1.utp_1.ost(tmp_0, SSE$lambda$slambda_2(null));
    return Unit_instance;
  }
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.fut_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a1v = function (value, $completion) {
    return this.fut_1(value, $completion);
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).q3 = function () {
    return this.fut_1;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, FlowCollector) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function SSE$lambda$slambda($this_createClientPlugin, $reconnectionTime, $showCommentEvents, $showRetryEvents, $maxReconnectionAttempts, $bufferPolicy, resultContinuation) {
    this.out_1 = $this_createClientPlugin;
    this.put_1 = $reconnectionTime;
    this.qut_1 = $showCommentEvents;
    this.rut_1 = $showRetryEvents;
    this.sut_1 = $maxReconnectionAttempts;
    this.tut_1 = $bufferPolicy;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SSE$lambda$slambda).wut = function (request, content, $completion) {
    var tmp = this.mu0(request, content, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SSE$lambda$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof HttpRequestBuilder ? p1 : THROW_CCE();
    return this.wut(tmp, p2 instanceof OutgoingContent ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SSE$lambda$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        if (tmp === 0) {
          this.o9_1 = 1;
          if (!(getAttributeValue(this.uut_1, get_sseRequestAttr()) === true)) {
            return this.vut_1;
          }
          var this_0 = get_LOGGER_9();
          if (get_isTraceEnabled(this_0)) {
            this_0.hsu('Sending SSE request to ' + this.uut_1.ytr_1.toString());
          }
          this.uut_1.mui(SSECapability_instance, Unit_instance);
          var tmp_0 = getAttributeValue(this.uut_1, get_reconnectionTimeAttr());
          var localReconnectionTime = tmp_0 == null ? null : tmp_0.sf_1;
          var localShowCommentEvents = getAttributeValue(this.uut_1, get_showCommentEventsAttr());
          var localShowRetryEvents = getAttributeValue(this.uut_1, get_showRetryEventsAttr());
          var localSseBufferPolicy = getAttributeValue(this.uut_1, get_sseBufferPolicyAttr());
          this.uut_1.dts_1.wsn(get_ResponseAdapterAttributeKey(), new SSEClientResponseAdapter());
          this.uut_1.dts_1.wsn(get_SSEClientForReconnectionAttr(), this.out_1.wtz_1);
          var tmp0_safe_receiver = this.vut_1.vt7();
          if (tmp0_safe_receiver == null)
            null;
          else {
            contentType_0(this.uut_1, tmp0_safe_receiver);
          }
          var tmp_1;
          var tmp_2 = localReconnectionTime;
          if ((tmp_2 == null ? null : new Duration(tmp_2)) == null) {
            tmp_1 = this.put_1;
          } else {
            tmp_1 = localReconnectionTime;
          }
          var tmp_3 = tmp_1;
          var tmp_4 = localShowCommentEvents == null ? this.qut_1 : localShowCommentEvents;
          var tmp_5 = localShowRetryEvents == null ? this.rut_1 : localShowRetryEvents;
          var tmp_6 = localSseBufferPolicy == null ? this.tut_1 : localSseBufferPolicy;
          return new SSEClientContent(tmp_3, tmp_4, tmp_5, this.sut_1, tmp_6, this.t9(), this.uut_1, this.vut_1);
        } else if (tmp === 1) {
          throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        throw e;
      }
     while (true);
  };
  protoOf(SSE$lambda$slambda).mu0 = function (request, content, completion) {
    var i = new SSE$lambda$slambda(this.out_1, this.put_1, this.qut_1, this.rut_1, this.sut_1, this.tut_1, completion);
    i.uut_1 = request;
    i.vut_1 = content;
    return i;
  };
  function SSE$lambda$slambda_0($this_createClientPlugin, $reconnectionTime, $showCommentEvents, $showRetryEvents, $maxReconnectionAttempts, $bufferPolicy, resultContinuation) {
    var i = new SSE$lambda$slambda($this_createClientPlugin, $reconnectionTime, $showCommentEvents, $showRetryEvents, $maxReconnectionAttempts, $bufferPolicy, resultContinuation);
    return constructCallableReference(function (request, content, $completion) {
      return i.wut(request, content, $completion);
    }, 2);
  }
  function SSE$lambda$slambda$o$incoming$o$collect$slambda($$this$unsafeFlow, resultContinuation) {
    this.fuu_1 = $$this$unsafeFlow;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SSE$lambda$slambda$o$incoming$o$collect$slambda).o2k = function (value, $completion) {
    var tmp = this.p2k(value, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SSE$lambda$slambda$o$incoming$o$collect$slambda).ja = function (p1, $completion) {
    return this.o2k(p1, $completion);
  };
  protoOf(SSE$lambda$slambda$o$incoming$o$collect$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0 = this.fuu_1;
            var value = this.guu_1;
            this.n9_1 = 1;
            suspendResult = tmp0.a1v(new TypedServerSentEvent(value.gte_1, value.hte_1, value.ite_1, value.jte_1, value.kte_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SSE$lambda$slambda$o$incoming$o$collect$slambda).p2k = function (value, completion) {
    var i = new SSE$lambda$slambda$o$incoming$o$collect$slambda(this.fuu_1, completion);
    i.guu_1 = value;
    return i;
  };
  function SSE$lambda$slambda$o$incoming$o$collect$slambda_0($$this$unsafeFlow, resultContinuation) {
    var i = new SSE$lambda$slambda$o$incoming$o$collect$slambda($$this$unsafeFlow, resultContinuation);
    return constructCallableReference(function (value, $completion) {
      return i.o2k(value, $completion);
    }, 1);
  }
  function $collectCOROUTINE$(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.puu_1 = _this__u8e3s4;
    this.quu_1 = collector;
  }
  protoOf($collectCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var $this$unsafeFlow = this.quu_1;
            this.n9_1 = 1;
            var tmp_0 = SSE$lambda$slambda$o$incoming$o$collect$slambda_0($this$unsafeFlow, null);
            suspendResult = this.puu_1.ruu_1.l1u(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function SSE$2$2$1$incoming$$inlined$map$1($this) {
    this.ruu_1 = $this;
  }
  protoOf(SSE$2$2$1$incoming$$inlined$map$1).b1v = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$(this, collector, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SSE$2$2$1$incoming$$inlined$map$1).l1u = function (collector, $completion) {
    return this.b1v(collector, $completion);
  };
  function SSE$2$2$clientSSESession$1($session, $deserializer) {
    this.vuu_1 = $session;
    var tmp = this;
    // Inline function 'kotlinx.coroutines.flow.map' call
    // Inline function 'kotlinx.coroutines.flow.unsafeTransform' call
    var this_0 = $session.ctf();
    // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
    tmp.suu_1 = new SSE$2$2$1$incoming$$inlined$map$1(this_0);
    this.tuu_1 = $deserializer;
    this.uuu_1 = $session.q19();
  }
  protoOf(SSE$2$2$clientSSESession$1).q19 = function () {
    return this.uuu_1;
  };
  function SSE$lambda$slambda_1(resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(SSE$lambda$slambda_1).mtr = function ($this$intercept, _destruct__k2r9zo, $completion) {
    var tmp = this.ntr($this$intercept, _destruct__k2r9zo, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(SSE$lambda$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(SSE$lambda$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.huv_1 = this.fuv_1.zh();
            this.guv_1 = this.fuv_1.ai();
            this.iuv_1 = this.euv_1.kst_1.ytq();
            var request = get_request(this.iuv_1);
            if (!(request.gtt().usn(get_sseRequestAttr()) === true)) {
              var this_0 = get_LOGGER_9();
              if (get_isTraceEnabled(this_0)) {
                this_0.hsu('Skipping non SSE response from ' + get_request(this.iuv_1).ott().toString());
              }
              return Unit_instance;
            }

            this.n9_1 = 1;
            suspendResult = checkResponse(this.iuv_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp_0 = this.guv_1;
            if (!isInterface(tmp_0, SSESession)) {
              this.n9_1 = 4;
              suspendResult = saved(this.iuv_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            var this_1 = get_LOGGER_9();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Receive SSE session from ' + get_request(this.iuv_1).ott().toString() + ': ' + toString(this.guv_1));
            }

            var deserializer = get_request(this.iuv_1).gtt().usn(get_deserializerAttr());
            var tmp_1;
            if (deserializer == null) {
              tmp_1 = null;
            } else {
              tmp_1 = new ClientSSESessionWithDeserialization(this.euv_1.kst_1, new SSE$2$2$clientSSESession$1(this.guv_1, deserializer));
            }

            var tmp1_elvis_lhs = tmp_1;
            var clientSSESession = tmp1_elvis_lhs == null ? new ClientSSESession(this.euv_1.kst_1, this.guv_1) : tmp1_elvis_lhs;
            this.n9_1 = 3;
            suspendResult = this.euv_1.pss(new HttpResponseContainer(this.huv_1, clientSSESession), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            var ARGUMENT = suspendResult;
            throw new SSEClientException(ARGUMENT, VOID, 'Expected ' + getKClass(SSESession).o() + ' content but was ' + toString(this.guv_1));
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(SSE$lambda$slambda_1).ntr = function ($this$intercept, _destruct__k2r9zo, completion) {
    var i = new SSE$lambda$slambda_1(completion);
    i.euv_1 = $this$intercept;
    i.fuv_1 = _destruct__k2r9zo;
    return i;
  };
  function SSE$lambda$slambda_2(resultContinuation) {
    var i = new SSE$lambda$slambda_1(resultContinuation);
    return constructCallableReference(function ($this$intercept, _destruct__k2r9zo, $completion) {
      return i.mtr($this$intercept, _destruct__k2r9zo, $completion);
    }, 2);
  }
  function $checkResponseCOROUTINE$(response, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.lus_1 = response;
  }
  protoOf($checkResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.mus_1 = this.lus_1.zbq();
            this.nus_1 = contentType_1(this.lus_1);
            if (this.mus_1.equals(Companion_getInstance_1().ht3_1)) {
              var this_0 = get_LOGGER_9();
              if (get_isTraceEnabled(this_0)) {
                this_0.hsu('Receive status code NoContent for SSE request to ' + get_request(this.lus_1).ott().toString());
              }
              return Unit_instance;
            }

            if (!this.mus_1.equals(Companion_getInstance_1().dt3_1)) {
              this.n9_1 = 4;
              suspendResult = saved(this.lus_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 1;
              continue $sm;
            }

          case 1:
            var tmp0_safe_receiver = this.nus_1;
            if (!equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ssx(), Text_getInstance().msx_1)) {
              this.n9_1 = 3;
              suspendResult = saved(this.lus_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            return Unit_instance;
          case 3:
            var ARGUMENT = suspendResult;
            throw new SSEClientException(ARGUMENT, VOID, 'Expected Content-Type ' + Text_getInstance().msx_1.toString() + ' but was ' + toString_0(this.nus_1));
          case 4:
            var ARGUMENT_0 = suspendResult;
            throw new SSEClientException(ARGUMENT_0, VOID, 'Expected status code ' + Companion_getInstance_1().dt3_1.yt2_1 + ' but was ' + this.mus_1.yt2_1);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $savedCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zus_1 = _this__u8e3s4;
  }
  protoOf($savedCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = save(this.zus_1.mtt(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var savedCall = suspendResult;
            savedCall.ftt().gtt().ysn(get_sseRequestAttr());
            return savedCall.ytq();
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  var properties_initialized_SSE_kt_scp42z;
  function _init_properties_SSE_kt__ir0g19() {
    if (!properties_initialized_SSE_kt_scp42z) {
      properties_initialized_SSE_kt_scp42z = true;
      LOGGER_8 = KtorSimpleLogger('io.ktor.client.plugins.sse.SSE');
      var tmp = SSEConfig$_init_$ref_nhmcny();
      SSE = createClientPlugin('SSE', tmp, SSE$lambda);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'SSEClientForReconnection';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_0 = getKClass(HttpClient);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_1;
      try {
        tmp_1 = createKType(getKClass(HttpClient), arrayOf([]), false);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_2 = null;
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      var tmp$ret$2 = tmp_1;
      var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
      SSEClientForReconnectionAttr = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'SSEReconnectionRequestAttr';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_3 = PrimitiveClasses_getInstance().jc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_4;
      try {
        tmp_4 = createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false);
      } catch ($p_0) {
        var tmp_5;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_5 = null;
        } else {
          throw $p_0;
        }
        tmp_4 = tmp_5;
      }
      var tmp$ret$2_0 = tmp_4;
      var tmp$ret$1_0 = new TypeInfo(tmp_3, tmp$ret$2_0);
      SSEReconnectionRequestAttr = new AttributeKey(name_0, tmp$ret$1_0);
    }
  }
  var EMPTY;
  function Off() {
  }
  protoOf(Off).toString = function () {
    return 'Off';
  };
  protoOf(Off).hashCode = function () {
    return 1036646776;
  };
  protoOf(Off).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Off))
      return false;
    return true;
  };
  var Off_instance;
  function Off_getInstance() {
    return Off_instance;
  }
  function LastEvents() {
  }
  function LastLines() {
  }
  function LastEvent() {
  }
  function All() {
  }
  function SSEBufferPolicy() {
  }
  function Events_0(capacity) {
    this.juv_1 = capacity;
    this.kuv_1 = ArrayDeque_init_$Create$();
  }
  protoOf(Events_0).cuq = function (event) {
    if (this.kuv_1.sg_1 === this.juv_1) {
      this.kuv_1.bh();
    }
    this.kuv_1.ah(event);
  };
  function Lines(capacity) {
    this.luv_1 = capacity;
    this.muv_1 = ArrayDeque_init_$Create$();
  }
  protoOf(Lines).qur = function (line) {
    if (this.muv_1.sg_1 === this.luv_1) {
      this.muv_1.bh();
    }
    this.muv_1.ah(line);
  };
  function Empty() {
  }
  var Empty_instance;
  function Empty_getInstance() {
    return Empty_instance;
  }
  function BodyBuffer() {
  }
  function toBodyBuffer(_this__u8e3s4) {
    _init_properties_SSEBufferPolicy_kt__kxyzr9();
    var tmp;
    if (_this__u8e3s4 instanceof Off) {
      tmp = Empty_instance;
    } else {
      if (_this__u8e3s4 instanceof LastEvent) {
        tmp = new Events_0(1);
      } else {
        if (_this__u8e3s4 instanceof LastEvents) {
          tmp = new Events_0(_this__u8e3s4.ouv_1);
        } else {
          if (_this__u8e3s4 instanceof LastLines) {
            tmp = new Lines(_this__u8e3s4.nuv_1);
          } else {
            if (_this__u8e3s4 instanceof All) {
              tmp = new Lines(2147483647);
            } else {
              noWhenBranchMatchedException();
            }
          }
        }
      }
    }
    return tmp;
  }
  var properties_initialized_SSEBufferPolicy_kt_up6r5l;
  function _init_properties_SSEBufferPolicy_kt__kxyzr9() {
    if (!properties_initialized_SSEBufferPolicy_kt_up6r5l) {
      properties_initialized_SSEBufferPolicy_kt_up6r5l = true;
      EMPTY = new Int8Array(0);
    }
  }
  function SSEClientContent(reconnectionTime, showCommentEvents, showRetryEvents, maxReconnectionAttempts, bufferPolicy, callContext, initialRequest, requestBody) {
    ContentWrapper.call(this, requestBody);
    this.fun_1 = reconnectionTime;
    this.gun_1 = showCommentEvents;
    this.hun_1 = showRetryEvents;
    this.iun_1 = maxReconnectionAttempts;
    this.jun_1 = bufferPolicy;
    this.kun_1 = callContext;
    this.lun_1 = initialRequest;
    var tmp = this;
    // Inline function 'kotlin.apply' call
    var this_0 = new HeadersBuilder();
    this_0.gsq(requestBody.dt2());
    append(this_0, 'Accept', Text_getInstance().msx_1);
    this_0.fsq('Cache-Control', 'no-store');
    tmp.mun_1 = this_0.g3d();
  }
  protoOf(SSEClientContent).dt2 = function () {
    return this.mun_1;
  };
  protoOf(SSEClientContent).toString = function () {
    return 'SSEClientContent';
  };
  function SSEConfig() {
    this.aut_1 = false;
    this.but_1 = false;
    var tmp = this;
    // Inline function 'kotlin.time.Companion.milliseconds' call
    Companion_getInstance_3();
    tmp.cut_1 = toDuration_0(3000, DurationUnit_MILLISECONDS_getInstance());
    this.dut_1 = 0;
    this.eut_1 = Off_instance;
  }
  function get_sseRequestAttr() {
    _init_properties_builders_kt__ach3uw();
    return sseRequestAttr;
  }
  var sseRequestAttr;
  function get_reconnectionTimeAttr() {
    _init_properties_builders_kt__ach3uw();
    return reconnectionTimeAttr;
  }
  var reconnectionTimeAttr;
  function get_showCommentEventsAttr() {
    _init_properties_builders_kt__ach3uw();
    return showCommentEventsAttr;
  }
  var showCommentEventsAttr;
  function get_showRetryEventsAttr() {
    _init_properties_builders_kt__ach3uw();
    return showRetryEventsAttr;
  }
  var showRetryEventsAttr;
  function get_deserializerAttr() {
    _init_properties_builders_kt__ach3uw();
    return deserializerAttr;
  }
  var deserializerAttr;
  function get_sseBufferPolicyAttr() {
    _init_properties_builders_kt__ach3uw();
    return sseBufferPolicyAttr;
  }
  var sseBufferPolicyAttr;
  var properties_initialized_builders_kt_nukecm;
  function _init_properties_builders_kt__ach3uw() {
    if (!properties_initialized_builders_kt_nukecm) {
      properties_initialized_builders_kt_nukecm = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'SSERequestFlag';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = PrimitiveClasses_getInstance().jc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      sseRequestAttr = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'SSEReconnectionTime';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = getKClass(Duration);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(getKClass(Duration), arrayOf([]), false);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_4 = null;
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$2_0 = tmp_3;
      var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
      reconnectionTimeAttr = new AttributeKey(name_0, tmp$ret$1_0);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_1 = 'SSEShowCommentEvents';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_5 = PrimitiveClasses_getInstance().jc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_6;
      try {
        tmp_6 = createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false);
      } catch ($p_1) {
        var tmp_7;
        if ($p_1 instanceof Error) {
          var _unused_var__etf5q3_1 = $p_1;
          tmp_7 = null;
        } else {
          throw $p_1;
        }
        tmp_6 = tmp_7;
      }
      var tmp$ret$2_1 = tmp_6;
      var tmp$ret$1_1 = new TypeInfo(tmp_5, tmp$ret$2_1);
      showCommentEventsAttr = new AttributeKey(name_1, tmp$ret$1_1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_2 = 'SSEShowRetryEvents';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_8 = PrimitiveClasses_getInstance().jc();
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_9;
      try {
        tmp_9 = createKType(PrimitiveClasses_getInstance().jc(), arrayOf([]), false);
      } catch ($p_2) {
        var tmp_10;
        if ($p_2 instanceof Error) {
          var _unused_var__etf5q3_2 = $p_2;
          tmp_10 = null;
        } else {
          throw $p_2;
        }
        tmp_9 = tmp_10;
      }
      var tmp$ret$2_2 = tmp_9;
      var tmp$ret$1_2 = new TypeInfo(tmp_8, tmp$ret$2_2);
      showRetryEventsAttr = new AttributeKey(name_2, tmp$ret$1_2);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_3 = 'SSEDeserializer';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_11 = PrimitiveClasses_getInstance().functionClass(2);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_12;
      try {
        tmp_12 = createKType(PrimitiveClasses_getInstance().functionClass(2), arrayOf([createInvariantKTypeProjection(createKType(getKClass(TypeInfo), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gc(), arrayOf([]), true))]), false);
      } catch ($p_3) {
        var tmp_13;
        if ($p_3 instanceof Error) {
          var _unused_var__etf5q3_3 = $p_3;
          tmp_13 = null;
        } else {
          throw $p_3;
        }
        tmp_12 = tmp_13;
      }
      var tmp$ret$2_3 = tmp_12;
      var tmp$ret$1_3 = new TypeInfo(tmp_11, tmp$ret$2_3);
      deserializerAttr = new AttributeKey(name_3, tmp$ret$1_3);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_4 = 'bufferPolicy';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_14 = getKClass(SSEBufferPolicy);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_15;
      try {
        tmp_15 = createKType(getKClass(SSEBufferPolicy), arrayOf([]), false);
      } catch ($p_4) {
        var tmp_16;
        if ($p_4 instanceof Error) {
          var _unused_var__etf5q3_4 = $p_4;
          tmp_16 = null;
        } else {
          throw $p_4;
        }
        tmp_15 = tmp_16;
      }
      var tmp$ret$2_4 = tmp_15;
      var tmp$ret$1_4 = new TypeInfo(tmp_14, tmp$ret$2_4);
      sseBufferPolicyAttr = new AttributeKey(name_4, tmp$ret$1_4);
    }
  }
  function DefaultClientWebSocketSession(call, delegate) {
    this.puv_1 = delegate;
    this.quv_1 = call;
  }
  protoOf(DefaultClientWebSocketSession).etf = function (frame, $completion) {
    return this.puv_1.etf(frame, $completion);
  };
  protoOf(DefaultClientWebSocketSession).ksc = function ($completion) {
    return this.puv_1.ksc($completion);
  };
  protoOf(DefaultClientWebSocketSession).atf = function (_set____db54di) {
    this.puv_1.atf(_set____db54di);
  };
  protoOf(DefaultClientWebSocketSession).btf = function () {
    return this.puv_1.btf();
  };
  protoOf(DefaultClientWebSocketSession).ctf = function () {
    return this.puv_1.ctf();
  };
  protoOf(DefaultClientWebSocketSession).dtf = function () {
    return this.puv_1.dtf();
  };
  protoOf(DefaultClientWebSocketSession).q19 = function () {
    return this.puv_1.q19();
  };
  protoOf(DefaultClientWebSocketSession).zte = function (negotiatedExtensions) {
    this.puv_1.zte(negotiatedExtensions);
  };
  function DelegatingClientWebSocketSession(call, session) {
    this.ruv_1 = session;
    this.suv_1 = call;
  }
  protoOf(DelegatingClientWebSocketSession).etf = function (frame, $completion) {
    return this.ruv_1.etf(frame, $completion);
  };
  protoOf(DelegatingClientWebSocketSession).ksc = function ($completion) {
    return this.ruv_1.ksc($completion);
  };
  protoOf(DelegatingClientWebSocketSession).atf = function (_set____db54di) {
    this.ruv_1.atf(_set____db54di);
  };
  protoOf(DelegatingClientWebSocketSession).btf = function () {
    return this.ruv_1.btf();
  };
  protoOf(DelegatingClientWebSocketSession).ctf = function () {
    return this.ruv_1.ctf();
  };
  protoOf(DelegatingClientWebSocketSession).dtf = function () {
    return this.ruv_1.dtf();
  };
  protoOf(DelegatingClientWebSocketSession).q19 = function () {
    return this.ruv_1.q19();
  };
  function WebSocketContent() {
    ClientUpgradeContent.call(this);
    var tmp = this;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    var nonce = generateNonce(16);
    this_0.q(Default_getInstance_0().cl(nonce));
    tmp.vuv_1 = this_0.toString();
    var tmp_0 = this;
    // Inline function 'kotlin.apply' call
    var this_1 = new HeadersBuilder();
    this_1.fsq('Upgrade', 'websocket');
    this_1.fsq('Connection', 'Upgrade');
    this_1.fsq('Sec-WebSocket-Key', this.vuv_1);
    this_1.fsq('Sec-WebSocket-Version', '13');
    tmp_0.wuv_1 = this_1.g3d();
  }
  protoOf(WebSocketContent).dt2 = function () {
    return this.wuv_1;
  };
  protoOf(WebSocketContent).toString = function () {
    return 'WebSocketContent';
  };
  function get_REQUEST_EXTENSIONS_KEY() {
    _init_properties_WebSockets_kt__jaqpbo();
    return REQUEST_EXTENSIONS_KEY;
  }
  var REQUEST_EXTENSIONS_KEY;
  function get_WEBSOCKETS_KEY() {
    _init_properties_WebSockets_kt__jaqpbo();
    return WEBSOCKETS_KEY;
  }
  var WEBSOCKETS_KEY;
  function get_LOGGER_10() {
    _init_properties_WebSockets_kt__jaqpbo();
    return LOGGER_9;
  }
  var LOGGER_9;
  function WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation) {
    this.fuw_1 = $extensionsSupported;
    this.guw_1 = $plugin;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda).rtq = function ($this$intercept, it, $completion) {
    var tmp = this.stq($this$intercept, it, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebSockets$Plugin$install$slambda).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.rtq(tmp, !(p2 == null) ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            if (!isWebsocket(this.huw_1.kst_1.ytr_1.tt5())) {
              var this_0 = get_LOGGER_10();
              if (get_isTraceEnabled(this_0)) {
                this_0.hsu('Skipping WebSocket plugin for non-websocket request: ' + this.huw_1.kst_1.ytr_1.toString());
              }
              return Unit_instance;
            }

            var this_1 = get_LOGGER_10();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Sending WebSocket request ' + this.huw_1.kst_1.ytr_1.toString());
            }

            this.huw_1.kst_1.mui(WebSocketCapability_instance, Unit_instance);
            if (this.fuw_1) {
              installExtensions(this.guw_1, this.huw_1.kst_1);
            }

            this.huw_1.kst_1.dts_1.xsn(get_WEBSOCKETS_KEY(), this.guw_1);
            this.n9_1 = 1;
            suspendResult = this.huw_1.pss(new WebSocketContent(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda).stq = function ($this$intercept, it, completion) {
    var i = new WebSockets$Plugin$install$slambda(this.fuw_1, this.guw_1, completion);
    i.huw_1 = $this$intercept;
    i.iuw_1 = it;
    return i;
  };
  function WebSockets$Plugin$install$slambda_0($extensionsSupported, $plugin, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda($extensionsSupported, $plugin, resultContinuation);
    return constructCallableReference(function ($this$intercept, it, $completion) {
      return i.rtq($this$intercept, it, $completion);
    }, 2);
  }
  function WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation) {
    this.ruw_1 = $plugin;
    this.suw_1 = $extensionsSupported;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(WebSockets$Plugin$install$slambda_1).mtr = function ($this$intercept, _destruct__k2r9zo, $completion) {
    var tmp = this.ntr($this$intercept, _destruct__k2r9zo, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(WebSockets$Plugin$install$slambda_1).ha = function (p1, p2, $completion) {
    var tmp = p1 instanceof PipelineContext ? p1 : THROW_CCE();
    return this.mtr(tmp, p2 instanceof HttpResponseContainer ? p2 : THROW_CCE(), $completion);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var info = this.uuw_1.zh();
            var session = this.uuw_1.ai();
            var response = this.tuw_1.kst_1.ytq();
            var status = response.zbq();
            var requestContent = get_request(response).rj3();
            if (!(requestContent instanceof WebSocketContent)) {
              var this_0 = get_LOGGER_10();
              if (get_isTraceEnabled(this_0)) {
                this_0.hsu('Skipping non-websocket response from ' + this.tuw_1.kst_1.ftt().ott().toString() + ': ' + toString(requestContent));
              }
              return Unit_instance;
            }

            if (!status.equals(Companion_getInstance_1().bt3_1)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected status code ' + Companion_getInstance_1().bt3_1.yt2_1 + ' but was ' + status.yt2_1);
            }

            if (!isInterface(session, WebSocketSession)) {
              throw WebSocketException_init_$Create$('Handshake exception, expected `WebSocketSession` content but was ' + toString(getKClassFromExpression(session)));
            }

            var this_1 = get_LOGGER_10();
            if (get_isTraceEnabled(this_1)) {
              this_1.hsu('Receive websocket session from ' + this.tuw_1.kst_1.ftt().ott().toString() + ': ' + toString(session));
            }

            if (!equalsLong(this.ruw_1.wuw_1, new Long(2147483647, 0))) {
              session.atf(this.ruw_1.wuw_1);
            }

            var tmp_0;
            if (info.bsu_1.equals(getKClass(DefaultClientWebSocketSession))) {
              var defaultSession = this.ruw_1.aux(session);
              var clientSession = new DefaultClientWebSocketSession(this.tuw_1.kst_1, defaultSession);
              var tmp_1;
              if (this.suw_1) {
                tmp_1 = completeNegotiation(this.ruw_1, this.tuw_1.kst_1);
              } else {
                tmp_1 = emptyList();
              }
              var negotiated = tmp_1;
              clientSession.zte(negotiated);
              tmp_0 = clientSession;
            } else {
              tmp_0 = new DelegatingClientWebSocketSession(this.tuw_1.kst_1, session);
            }

            var clientSession_0 = tmp_0;
            this.n9_1 = 1;
            suspendResult = this.tuw_1.pss(new HttpResponseContainer(info, clientSession_0), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(WebSockets$Plugin$install$slambda_1).ntr = function ($this$intercept, _destruct__k2r9zo, completion) {
    var i = new WebSockets$Plugin$install$slambda_1(this.ruw_1, this.suw_1, completion);
    i.tuw_1 = $this$intercept;
    i.uuw_1 = _destruct__k2r9zo;
    return i;
  };
  function WebSockets$Plugin$install$slambda_2($plugin, $extensionsSupported, resultContinuation) {
    var i = new WebSockets$Plugin$install$slambda_1($plugin, $extensionsSupported, resultContinuation);
    return constructCallableReference(function ($this$intercept, _destruct__k2r9zo, $completion) {
      return i.mtr($this$intercept, _destruct__k2r9zo, $completion);
    }, 2);
  }
  function installExtensions($this, context) {
    var installed = $this.xuw_1.g3d();
    context.dts_1.wsn(get_REQUEST_EXTENSIONS_KEY(), installed);
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = installed.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var list = element.utm();
      addAll(destination, list);
    }
    var protocols = destination;
    addNegotiatedProtocols($this, context, protocols);
  }
  function completeNegotiation($this, call) {
    var tmp0_safe_receiver = call.ytq().dt2().je('Sec-WebSocket-Extensions');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = parseWebSocketExtensions(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    var serverExtensions = tmp1_elvis_lhs == null ? emptyList() : tmp1_elvis_lhs;
    var clientExtensions = call.gtt().tsn(get_REQUEST_EXTENSIONS_KEY());
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$();
    var _iterator__ex2g4s = clientExtensions.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      if (element.vtm(serverExtensions)) {
        destination.j1(element);
      }
    }
    return destination;
  }
  function addNegotiatedProtocols($this, context, protocols) {
    if (protocols.r())
      return Unit_instance;
    var headerValue = joinToString(protocols, ',');
    header(context, 'Sec-WebSocket-Extensions', headerValue);
  }
  function Config_0() {
    this.bux_1 = new WebSocketExtensionsConfig();
    this.cux_1 = new WebSocketChannelsConfig();
    this.dux_1 = new Long(0, 0);
    this.eux_1 = new Long(2147483647, 0);
    this.fux_1 = null;
  }
  function Plugin_1() {
    Plugin_instance_1 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'Websocket';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(WebSockets);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(WebSockets), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.gux_1 = new AttributeKey(name, tmp$ret$1);
  }
  protoOf(Plugin_1).t1 = function () {
    return this.gux_1;
  };
  protoOf(Plugin_1).hux = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new Config_0();
    block(this_0);
    var config = this_0;
    return new WebSockets(config.dux_1, config.eux_1, config.bux_1, config.fux_1, config.cux_1);
  };
  protoOf(Plugin_1).ctt = function (block) {
    return this.hux(block);
  };
  protoOf(Plugin_1).iux = function (plugin, scope) {
    var extensionsSupported = scope.ntp_1.btx().m1(WebSocketExtensionsCapability_instance);
    var tmp = Phases_getInstance_0().btz_1;
    scope.ttp_1.ost(tmp, WebSockets$Plugin$install$slambda_0(extensionsSupported, plugin, null));
    var tmp_0 = Phases_getInstance_2().xts_1;
    scope.utp_1.ost(tmp_0, WebSockets$Plugin$install$slambda_2(plugin, extensionsSupported, null));
  };
  protoOf(Plugin_1).dtt = function (plugin, scope) {
    return this.iux(plugin instanceof WebSockets ? plugin : THROW_CCE(), scope);
  };
  var Plugin_instance_1;
  function Plugin_getInstance_1() {
    if (Plugin_instance_1 == null)
      new Plugin_1();
    return Plugin_instance_1;
  }
  function WebSockets(pingIntervalMillis, maxFrameSize, extensionsConfig, contentConverter, channelsConfig) {
    Plugin_getInstance_1();
    contentConverter = contentConverter === VOID ? null : contentConverter;
    channelsConfig = channelsConfig === VOID ? Companion_getInstance_4().ftf_1 : channelsConfig;
    this.vuw_1 = pingIntervalMillis;
    this.wuw_1 = maxFrameSize;
    this.xuw_1 = extensionsConfig;
    this.yuw_1 = contentConverter;
    this.zuw_1 = channelsConfig;
  }
  protoOf(WebSockets).aux = function (session) {
    if (isInterface(session, DefaultWebSocketSession))
      return session;
    // Inline function 'kotlin.Long.times' call
    var this_0 = this.vuw_1;
    var timeoutMillis = multiply(this_0, fromInt(2));
    // Inline function 'kotlin.also' call
    var this_1 = DefaultWebSocketSession_0(session, this.vuw_1, timeoutMillis, this.zuw_1);
    this_1.atf(this.wuw_1);
    return this_1;
  };
  function WebSocketExtensionsCapability() {
  }
  protoOf(WebSocketExtensionsCapability).toString = function () {
    return 'WebSocketExtensionsCapability';
  };
  protoOf(WebSocketExtensionsCapability).hashCode = function () {
    return 806573237;
  };
  protoOf(WebSocketExtensionsCapability).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WebSocketExtensionsCapability))
      return false;
    return true;
  };
  var WebSocketExtensionsCapability_instance;
  function WebSocketExtensionsCapability_getInstance() {
    return WebSocketExtensionsCapability_instance;
  }
  function WebSocketCapability() {
  }
  protoOf(WebSocketCapability).toString = function () {
    return 'WebSocketCapability';
  };
  protoOf(WebSocketCapability).hashCode = function () {
    return -1146563391;
  };
  protoOf(WebSocketCapability).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WebSocketCapability))
      return false;
    return true;
  };
  var WebSocketCapability_instance;
  function WebSocketCapability_getInstance() {
    return WebSocketCapability_instance;
  }
  function WebSocketException_init_$Init$(message, $this) {
    WebSocketException.call($this, message, null);
    return $this;
  }
  function WebSocketException_init_$Create$(message) {
    var tmp = WebSocketException_init_$Init$(message, objectCreate(protoOf(WebSocketException)));
    captureStack(tmp, WebSocketException_init_$Create$);
    return tmp;
  }
  function WebSocketException(message, cause) {
    IllegalStateException_init_$Init$_1(message, cause, this);
    captureStack(this, WebSocketException);
  }
  var properties_initialized_WebSockets_kt_2t2hw2;
  function _init_properties_WebSockets_kt__jaqpbo() {
    if (!properties_initialized_WebSockets_kt_2t2hw2) {
      properties_initialized_WebSockets_kt_2t2hw2 = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'Websocket extensions';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(KtList);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(KtList), arrayOf([createInvariantKTypeProjection(createKType(getKClass(WebSocketExtension), arrayOf([getStarKTypeProjection()]), false))]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      REQUEST_EXTENSIONS_KEY = new AttributeKey(name, tmp$ret$1);
      // Inline function 'io.ktor.util.AttributeKey' call
      var name_0 = 'Websocket plugin config';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp_2 = getKClass(WebSockets);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_3;
      try {
        tmp_3 = createKType(getKClass(WebSockets), arrayOf([]), false);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var _unused_var__etf5q3_0 = $p_0;
          tmp_4 = null;
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      var tmp$ret$2_0 = tmp_3;
      var tmp$ret$1_0 = new TypeInfo(tmp_2, tmp$ret$2_0);
      WEBSOCKETS_KEY = new AttributeKey(name_0, tmp$ret$1_0);
      LOGGER_9 = KtorSimpleLogger('io.ktor.client.plugins.websocket.WebSockets');
    }
  }
  function ClientUpgradeContent$content$delegate$lambda() {
    return new ByteChannel();
  }
  function ClientUpgradeContent() {
    NoContent.call(this);
    var tmp = this;
    tmp.kux_1 = lazy(ClientUpgradeContent$content$delegate$lambda);
  }
  function DefaultHttpRequest(call, data) {
    this.lux_1 = call;
    this.mux_1 = data.vtw_1;
    this.nux_1 = data.utw_1;
    this.oux_1 = data.xtw_1;
    this.pux_1 = data.wtw_1;
    this.qux_1 = data.ztw_1;
  }
  protoOf(DefaultHttpRequest).mtt = function () {
    return this.lux_1;
  };
  protoOf(DefaultHttpRequest).q19 = function () {
    return this.mtt().q19();
  };
  protoOf(DefaultHttpRequest).ntt = function () {
    return this.mux_1;
  };
  protoOf(DefaultHttpRequest).ott = function () {
    return this.nux_1;
  };
  protoOf(DefaultHttpRequest).rj3 = function () {
    return this.oux_1;
  };
  protoOf(DefaultHttpRequest).dt2 = function () {
    return this.pux_1;
  };
  protoOf(DefaultHttpRequest).gtt = function () {
    return this.qux_1;
  };
  function get_ResponseAdapterAttributeKey() {
    _init_properties_HttpRequest_kt__813lx1();
    return ResponseAdapterAttributeKey;
  }
  var ResponseAdapterAttributeKey;
  function Companion_2() {
  }
  var Companion_instance_3;
  function Companion_getInstance_11() {
    return Companion_instance_3;
  }
  function HttpRequestBuilder$setCapability$lambda() {
    // Inline function 'kotlin.collections.mutableMapOf' call
    return LinkedHashMap_init_$Create$();
  }
  function HttpRequestBuilder() {
    this.ytr_1 = new URLBuilder_0();
    this.ztr_1 = Companion_getInstance_2().et2_1;
    this.ats_1 = new HeadersBuilder();
    this.bts_1 = EmptyContent_getInstance();
    this.cts_1 = SupervisorJob();
    this.dts_1 = AttributesJsFn(true);
  }
  protoOf(HttpRequestBuilder).dt2 = function () {
    return this.ats_1;
  };
  protoOf(HttpRequestBuilder).qtx = function (value) {
    if (!(value == null)) {
      this.dts_1.wsn(get_BodyTypeAttributeKey(), value);
    } else {
      this.dts_1.ysn(get_BodyTypeAttributeKey());
    }
  };
  protoOf(HttpRequestBuilder).kum = function () {
    return this.dts_1.usn(get_BodyTypeAttributeKey());
  };
  protoOf(HttpRequestBuilder).g3d = function () {
    var tmp = this.ytr_1.g3d();
    var tmp_0 = this.ztr_1;
    var tmp_1 = this.ats_1.g3d();
    var tmp_2 = this.bts_1;
    var tmp0_elvis_lhs = tmp_2 instanceof OutgoingContent ? tmp_2 : null;
    var tmp_3;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.error' call
      var message = 'No request transformation found: ' + toString(this.bts_1);
      throw IllegalStateException_init_$Create$(toString(message));
    } else {
      tmp_3 = tmp0_elvis_lhs;
    }
    return new HttpRequestData(tmp, tmp_0, tmp_1, tmp_3, this.cts_1, this.dts_1);
  };
  protoOf(HttpRequestBuilder).ptx = function (builder) {
    this.cts_1 = builder.cts_1;
    return this.yue(builder);
  };
  protoOf(HttpRequestBuilder).yue = function (builder) {
    this.ztr_1 = builder.ztr_1;
    this.bts_1 = builder.bts_1;
    this.qtx(builder.kum());
    takeFrom(this.ytr_1, builder.ytr_1);
    this.ytr_1.ot5_1 = this.ytr_1.ot5_1;
    appendAll(this.ats_1, builder.ats_1);
    putAll(this.dts_1, builder.dts_1);
    return this;
  };
  protoOf(HttpRequestBuilder).mui = function (key, capability) {
    var tmp = get_ENGINE_CAPABILITIES_KEY();
    var capabilities = this.dts_1.zsn(tmp, HttpRequestBuilder$setCapability$lambda);
    // Inline function 'kotlin.collections.set' call
    capabilities.z2(key, capability);
  };
  protoOf(HttpRequestBuilder).yuh = function (key) {
    var tmp0_safe_receiver = this.dts_1.usn(get_ENGINE_CAPABILITIES_KEY());
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w2(key);
  };
  function headers(_this__u8e3s4, block) {
    _init_properties_HttpRequest_kt__813lx1();
    // Inline function 'kotlin.apply' call
    var this_0 = _this__u8e3s4.dt2();
    block(this_0);
    return this_0;
  }
  function HttpRequest_0() {
  }
  function HttpRequestData(url, method, headers, body, executionContext, attributes) {
    this.utw_1 = url;
    this.vtw_1 = method;
    this.wtw_1 = headers;
    this.xtw_1 = body;
    this.ytw_1 = executionContext;
    this.ztw_1 = attributes;
    var tmp = this;
    var tmp0_safe_receiver = this.ztw_1.usn(get_ENGINE_CAPABILITIES_KEY());
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.x2();
    tmp.atx_1 = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  }
  protoOf(HttpRequestData).toString = function () {
    return 'HttpRequestData(url=' + this.utw_1.toString() + ', method=' + this.vtw_1.toString() + ')';
  };
  function HttpResponseData(statusCode, requestTime, headers, version, body, callContext) {
    this.ztt_1 = statusCode;
    this.atu_1 = requestTime;
    this.btu_1 = headers;
    this.ctu_1 = version;
    this.dtu_1 = body;
    this.etu_1 = callContext;
    this.ftu_1 = GMTDate();
  }
  protoOf(HttpResponseData).toString = function () {
    return 'HttpResponseData=(statusCode=' + this.ztt_1.toString() + ')';
  };
  function ResponseAdapter() {
  }
  function SSEClientResponseAdapter() {
  }
  protoOf(SSEClientResponseAdapter).rux = function (data, status, headers, responseBody, outgoingContent, callContext) {
    var tmp0_safe_receiver = headers.je('Content-Type');
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = Companion_getInstance_0().jr(tmp0_safe_receiver);
    }
    var contentType = tmp;
    var tmp_0;
    var tmp_1;
    if (isSseRequest(data) && !isSseReconnectionRequest(data)) {
      var tmp_2;
      var tmp_3;
      if (status.equals(Companion_getInstance_1().dt3_1)) {
        tmp_3 = equals(contentType == null ? null : contentType.ssx(), Text_getInstance().msx_1);
      } else {
        tmp_3 = false;
      }
      if (tmp_3) {
        tmp_2 = true;
      } else {
        tmp_2 = status.equals(Companion_getInstance_1().ht3_1);
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      if (!(outgoingContent instanceof SSEClientContent))
        THROW_CCE();
      tmp_0 = DefaultClientSSESession_init_$Create$(outgoingContent, responseBody);
    } else {
      tmp_0 = null;
    }
    return tmp_0;
  };
  function isSseRequest(_this__u8e3s4) {
    _init_properties_HttpRequest_kt__813lx1();
    var tmp = _this__u8e3s4.xtw_1;
    return tmp instanceof SSEClientContent;
  }
  function isSseReconnectionRequest(_this__u8e3s4) {
    _init_properties_HttpRequest_kt__813lx1();
    return _this__u8e3s4.ztw_1.usn(get_SSEReconnectionRequestAttr()) === true;
  }
  function isUpgradeRequest(_this__u8e3s4) {
    _init_properties_HttpRequest_kt__813lx1();
    var tmp = _this__u8e3s4.xtw_1;
    return tmp instanceof ClientUpgradeContent;
  }
  function url(_this__u8e3s4, urlString) {
    _init_properties_HttpRequest_kt__813lx1();
    takeFrom_0(_this__u8e3s4.ytr_1, urlString);
  }
  var properties_initialized_HttpRequest_kt_zh09pz;
  function _init_properties_HttpRequest_kt__813lx1() {
    if (!properties_initialized_HttpRequest_kt_zh09pz) {
      properties_initialized_HttpRequest_kt_zh09pz = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'ResponseAdapterAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(ResponseAdapter);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(ResponseAdapter), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      ResponseAdapterAttributeKey = new AttributeKey(name, tmp$ret$1);
    }
  }
  function Phases() {
    Phases_instance = this;
    this.fts_1 = new PipelinePhase('Before');
    this.gts_1 = new PipelinePhase('State');
    this.hts_1 = new PipelinePhase('Monitoring');
    this.its_1 = new PipelinePhase('Engine');
    this.jts_1 = new PipelinePhase('Receive');
  }
  var Phases_instance;
  function Phases_getInstance() {
    if (Phases_instance == null)
      new Phases();
    return Phases_instance;
  }
  function HttpSendPipeline(developmentMode) {
    Phases_getInstance();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    Pipeline.call(this, [Phases_getInstance().fts_1, Phases_getInstance().gts_1, Phases_getInstance().hts_1, Phases_getInstance().its_1, Phases_getInstance().jts_1]);
    this.zux_1 = developmentMode;
  }
  protoOf(HttpSendPipeline).ist = function () {
    return this.zux_1;
  };
  function Phases_0() {
    Phases_instance_0 = this;
    this.yty_1 = new PipelinePhase('Before');
    this.zty_1 = new PipelinePhase('State');
    this.atz_1 = new PipelinePhase('Transform');
    this.btz_1 = new PipelinePhase('Render');
    this.ctz_1 = new PipelinePhase('Send');
  }
  var Phases_instance_0;
  function Phases_getInstance_0() {
    if (Phases_instance_0 == null)
      new Phases_0();
    return Phases_instance_0;
  }
  function HttpRequestPipeline(developmentMode) {
    Phases_getInstance_0();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    Pipeline.call(this, [Phases_getInstance_0().yty_1, Phases_getInstance_0().zty_1, Phases_getInstance_0().atz_1, Phases_getInstance_0().btz_1, Phases_getInstance_0().ctz_1]);
    this.huy_1 = developmentMode;
  }
  protoOf(HttpRequestPipeline).ist = function () {
    return this.huy_1;
  };
  function get_BodyTypeAttributeKey() {
    _init_properties_RequestBody_kt__bo3lwf();
    return BodyTypeAttributeKey;
  }
  var BodyTypeAttributeKey;
  var properties_initialized_RequestBody_kt_agyv1b;
  function _init_properties_RequestBody_kt__bo3lwf() {
    if (!properties_initialized_RequestBody_kt_agyv1b) {
      properties_initialized_RequestBody_kt_agyv1b = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'BodyTypeAttributeKey';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(TypeInfo);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(TypeInfo), arrayOf([]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      BodyTypeAttributeKey = new AttributeKey(name, tmp$ret$1);
    }
  }
  function url_0(_this__u8e3s4, url) {
    takeFrom_1(_this__u8e3s4.ytr_1, url);
  }
  function accept(_this__u8e3s4, contentType) {
    return _this__u8e3s4.dt2().fsq('Accept', contentType.toString());
  }
  function header(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.dt2().fsq(key, toString(value));
      tmp = Unit_instance;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? Unit_instance : tmp1_elvis_lhs;
  }
  function bearerAuth(_this__u8e3s4, token) {
    return header(_this__u8e3s4, 'Authorization', 'Bearer ' + token);
  }
  function parameter(_this__u8e3s4, key, value) {
    var tmp;
    if (value == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      _this__u8e3s4.ytr_1.qt5_1.fsq(key, toString(value));
      tmp = Unit_instance;
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? Unit_instance : tmp1_elvis_lhs;
  }
  function DefaultHttpResponse(call, responseData) {
    HttpResponse.call(this);
    this.iuy_1 = call;
    this.juy_1 = responseData.etu_1;
    this.kuy_1 = responseData.ztt_1;
    this.luy_1 = responseData.ctu_1;
    this.muy_1 = responseData.atu_1;
    this.nuy_1 = responseData.ftu_1;
    var tmp = this;
    var tmp_0 = responseData.dtu_1;
    var tmp0_elvis_lhs = isInterface(tmp_0, ByteReadChannel) ? tmp_0 : null;
    tmp.ouy_1 = tmp0_elvis_lhs == null ? Companion_getInstance().pse_1 : tmp0_elvis_lhs;
    this.puy_1 = responseData.btu_1;
  }
  protoOf(DefaultHttpResponse).mtt = function () {
    return this.iuy_1;
  };
  protoOf(DefaultHttpResponse).q19 = function () {
    return this.juy_1;
  };
  protoOf(DefaultHttpResponse).zbq = function () {
    return this.kuy_1;
  };
  protoOf(DefaultHttpResponse).vtt = function () {
    return this.luy_1;
  };
  protoOf(DefaultHttpResponse).wtt = function () {
    return this.muy_1;
  };
  protoOf(DefaultHttpResponse).xtt = function () {
    return this.nuy_1;
  };
  protoOf(DefaultHttpResponse).utt = function () {
    return this.ouy_1;
  };
  protoOf(DefaultHttpResponse).dt2 = function () {
    return this.puy_1;
  };
  function HttpResponse() {
  }
  protoOf(HttpResponse).toString = function () {
    return 'HttpResponse[' + get_request(this).ott().toString() + ', ' + this.zbq().toString() + ']';
  };
  function bodyAsChannel(_this__u8e3s4, $completion) {
    var tmp = new $bodyAsChannelCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function get_request(_this__u8e3s4) {
    return _this__u8e3s4.mtt().ftt();
  }
  function bodyAsText(_this__u8e3s4, fallbackCharset, $completion) {
    fallbackCharset = fallbackCharset === VOID ? Charsets_getInstance().psm_1 : fallbackCharset;
    var tmp = new $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $bodyAsChannelCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yuy_1 = _this__u8e3s4;
  }
  protoOf($bodyAsChannelCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var this_0 = this.yuy_1;
            this.n9_1 = 1;
            var tmp_0 = this_0.mtt();
            var tmp_1 = getKClass(ByteReadChannel);
            var tmp_2;
            try {
              tmp_2 = createKType(getKClass(ByteReadChannel), arrayOf([]), false);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_3 = null;
              } else {
                throw $p;
              }
              tmp_2 = tmp_3;
            }

            suspendResult = tmp_0.jtt(new TypeInfo(tmp_1, tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return (!(suspendResult == null) ? isInterface(suspendResult, ByteReadChannel) : false) ? suspendResult : THROW_CCE();
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $bodyAsTextCOROUTINE$(_this__u8e3s4, fallbackCharset, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.huz_1 = _this__u8e3s4;
    this.iuz_1 = fallbackCharset;
  }
  protoOf($bodyAsTextCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp0_elvis_lhs = charset_0(this.huz_1);
            var originCharset = tmp0_elvis_lhs == null ? this.iuz_1 : tmp0_elvis_lhs;
            this.juz_1 = originCharset.ssm();
            var this_0 = this.huz_1;
            this.n9_1 = 1;
            var tmp_0 = this_0.mtt();
            var tmp_1 = getKClass(Source);
            var tmp_2;
            try {
              tmp_2 = createKType(getKClass(Source), arrayOf([]), false);
            } catch ($p) {
              var tmp_3;
              if ($p instanceof Error) {
                var _unused_var__etf5q3 = $p;
                tmp_3 = null;
              } else {
                throw $p;
              }
              tmp_2 = tmp_3;
            }

            suspendResult = tmp_0.jtt(new TypeInfo(tmp_1, tmp_2), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var input = (!(suspendResult == null) ? isInterface(suspendResult, Source) : false) ? suspendResult : THROW_CCE();
            return decode(this.juz_1, input);
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpResponseContainer(expectedType, response) {
    this.rtu_1 = expectedType;
    this.stu_1 = response;
  }
  protoOf(HttpResponseContainer).zh = function () {
    return this.rtu_1;
  };
  protoOf(HttpResponseContainer).ai = function () {
    return this.stu_1;
  };
  protoOf(HttpResponseContainer).toString = function () {
    return 'HttpResponseContainer(expectedType=' + this.rtu_1.toString() + ', response=' + toString(this.stu_1) + ')';
  };
  protoOf(HttpResponseContainer).hashCode = function () {
    var result = this.rtu_1.hashCode();
    result = imul(result, 31) + hashCode(this.stu_1) | 0;
    return result;
  };
  protoOf(HttpResponseContainer).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HttpResponseContainer))
      return false;
    if (!this.rtu_1.equals(other.rtu_1))
      return false;
    if (!equals(this.stu_1, other.stu_1))
      return false;
    return true;
  };
  function Phases_1() {
    Phases_instance_1 = this;
    this.stz_1 = new PipelinePhase('Before');
    this.ttz_1 = new PipelinePhase('State');
    this.utz_1 = new PipelinePhase('After');
  }
  var Phases_instance_1;
  function Phases_getInstance_1() {
    if (Phases_instance_1 == null)
      new Phases_1();
    return Phases_instance_1;
  }
  function HttpReceivePipeline(developmentMode) {
    Phases_getInstance_1();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    Pipeline.call(this, [Phases_getInstance_1().stz_1, Phases_getInstance_1().ttz_1, Phases_getInstance_1().utz_1]);
    this.ruz_1 = developmentMode;
  }
  protoOf(HttpReceivePipeline).ist = function () {
    return this.ruz_1;
  };
  function Phases_2() {
    Phases_instance_2 = this;
    this.vts_1 = new PipelinePhase('Receive');
    this.wts_1 = new PipelinePhase('Parse');
    this.xts_1 = new PipelinePhase('Transform');
    this.yts_1 = new PipelinePhase('State');
    this.zts_1 = new PipelinePhase('After');
  }
  var Phases_instance_2;
  function Phases_getInstance_2() {
    if (Phases_instance_2 == null)
      new Phases_2();
    return Phases_instance_2;
  }
  function HttpResponsePipeline(developmentMode) {
    Phases_getInstance_2();
    developmentMode = developmentMode === VOID ? true : developmentMode;
    Pipeline.call(this, [Phases_getInstance_2().vts_1, Phases_getInstance_2().wts_1, Phases_getInstance_2().xts_1, Phases_getInstance_2().yts_1, Phases_getInstance_2().zts_1]);
    this.zuz_1 = developmentMode;
  }
  protoOf(HttpResponsePipeline).ist = function () {
    return this.zuz_1;
  };
  function HttpStatement$execute$slambda($block, $response, resultContinuation) {
    this.iv0_1 = $block;
    this.jv0_1 = $response;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(HttpStatement$execute$slambda).ch6 = function ($this$withContext, $completion) {
    var tmp = this.q24($this$withContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpStatement$execute$slambda).ja = function (p1, $completion) {
    return this.ch6((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(HttpStatement$execute$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.iv0_1(this.jv0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return suspendResult;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(HttpStatement$execute$slambda).q24 = function ($this$withContext, completion) {
    var i = new HttpStatement$execute$slambda(this.iv0_1, this.jv0_1, completion);
    i.kv0_1 = $this$withContext;
    return i;
  };
  function HttpStatement$execute$slambda_0($block, $response, resultContinuation) {
    var i = new HttpStatement$execute$slambda($block, $response, resultContinuation);
    return constructCallableReference(function ($this$withContext, $completion) {
      return i.ch6($this$withContext, $completion);
    }, 1);
  }
  function $executeCOROUTINE$_1(_this__u8e3s4, block, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tv0_1 = _this__u8e3s4;
    this.uv0_1 = block;
  }
  protoOf($executeCOROUTINE$_1).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 17;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 16;
            this.n9_1 = 2;
            suspendResult = this.tv0_1.ev1(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.xv0_1 = suspendResult;
            this.wv0_1 = null;
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.o9_1 = 11;
            this.o9_1 = 10;
            if (get_useEngineDispatcher()) {
              this.n9_1 = 6;
              var tmp_0 = ensureNotNull(this.xv0_1.q19().aa(Key_instance_0));
              suspendResult = withContext(tmp_0, HttpStatement$execute$slambda_0(this.uv0_1, this.xv0_1, null), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 5;
              suspendResult = this.uv0_1(this.xv0_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 5:
            this.bv1_1 = suspendResult;
            this.n9_1 = 7;
            continue $sm;
          case 6:
            this.bv1_1 = suspendResult;
            this.n9_1 = 7;
            continue $sm;
          case 7:
            this.av1_1 = this.bv1_1;
            this.n9_1 = 8;
            var tmp_1 = this;
            continue $sm;
          case 8:
            this.zv0_1 = this.av1_1;
            this.o9_1 = 16;
            this.n9_1 = 9;
            suspendResult = this.tv0_1.fv1(this.xv0_1, this.wv0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            return this.zv0_1;
          case 10:
            this.o9_1 = 11;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var cause = this.q9_1;
              var tmp_3 = this;
              this.wv0_1 = cause;
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 11:
            this.o9_1 = 16;
            this.yv0_1 = this.q9_1;
            this.n9_1 = 12;
            suspendResult = this.tv0_1.fv1(this.xv0_1, this.wv0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 12:
            throw this.yv0_1;
          case 13:
            this.o9_1 = 16;
            this.n9_1 = 14;
            suspendResult = this.tv0_1.fv1(this.xv0_1, this.wv0_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 14:
            var tmp_4 = this;
            tmp_4.vv0_1 = Unit_instance;
            this.o9_1 = 17;
            this.n9_1 = 15;
            continue $sm;
          case 15:
            return this.vv0_1;
          case 16:
            this.o9_1 = 17;
            var tmp_5 = this.q9_1;
            if (tmp_5 instanceof CancellationException) {
              var cause_0 = this.q9_1;
              throw unwrapCancellationException(cause_0);
            } else {
              throw this.q9_1;
            }

          case 17:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 17) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $fetchStreamingResponseCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.ov1_1 = _this__u8e3s4;
  }
  protoOf($fetchStreamingResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 4;
            var builder = (new HttpRequestBuilder()).ptx(this.ov1_1.cv1_1);
            skipSaveBody(builder);
            this.n9_1 = 2;
            suspendResult = this.ov1_1.dv1_1.att(builder, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var call = suspendResult;
            var tmp_0 = this;
            return call.ytq();
          case 3:
            return this.pv1_1;
          case 4:
            this.o9_1 = 5;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.q9_1;
              throw unwrapCancellationException(cause);
            } else {
              throw this.q9_1;
            }

          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $fetchResponseCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yv1_1 = _this__u8e3s4;
  }
  protoOf($fetchResponseCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 7;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.o9_1 = 6;
            var builder = (new HttpRequestBuilder()).ptx(this.yv1_1.cv1_1);
            this.n9_1 = 2;
            suspendResult = this.yv1_1.dv1_1.att(builder, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.bv2_1 = suspendResult;
            this.n9_1 = 3;
            suspendResult = save(this.bv2_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            this.av2_1 = suspendResult.ytq();
            this.n9_1 = 4;
            suspendResult = this.yv1_1.fv1(this.bv2_1.ytq(), null, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var tmp_0 = this;
            return this.av2_1;
          case 5:
            return this.zv1_1;
          case 6:
            this.o9_1 = 7;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof CancellationException) {
              var cause = this.q9_1;
              throw unwrapCancellationException(cause);
            } else {
              throw this.q9_1;
            }

          case 7:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 7) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $cleanupCOROUTINE$(_this__u8e3s4, _this__u8e3s4_0, cause, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kv2_1 = _this__u8e3s4;
    this.lv2_1 = _this__u8e3s4_0;
    this.mv2_1 = cause;
  }
  protoOf($cleanupCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            var tmp_0 = get_job(this.lv2_1.q19());
            var job = isInterface(tmp_0, CompletableJob) ? tmp_0 : THROW_CCE();
            this.nv2_1 = job;
            var $this$apply = this.nv2_1;
            var tmp0_subject = this.mv2_1;
            if (tmp0_subject == null)
              $this$apply.w1g();
            else {
              if (tmp0_subject instanceof CancellationException) {
                $this$apply.a1b(this.mv2_1);
              } else {
                $this$apply.a1b(CancellationException_init_$Create$('Exception occurred during request execution', this.mv2_1));
              }
            }

            if (!get_isSaved(this.lv2_1)) {
              try {
                cancel_1(this.lv2_1.utt());
              } catch ($p) {
                if ($p instanceof Error) {
                  var _unused_var__etf5q3 = $p;
                } else {
                  throw $p;
                }
              }
            }

            this.n9_1 = 1;
            suspendResult = $this$apply.x1a(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p_0) {
        var e = $p_0;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function HttpStatement(builder, client) {
    this.cv1_1 = builder;
    this.dv1_1 = client;
  }
  protoOf(HttpStatement).ov2 = function (block, $completion) {
    var tmp = new $executeCOROUTINE$_1(this, block, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpStatement).pv2 = function ($completion) {
    return this.qv2($completion);
  };
  protoOf(HttpStatement).ev1 = function ($completion) {
    var tmp = new $fetchStreamingResponseCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpStatement).qv2 = function ($completion) {
    var tmp = new $fetchResponseCOROUTINE$(this, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpStatement).fv1 = function (_this__u8e3s4, cause, $completion) {
    var tmp = new $cleanupCOROUTINE$(this, _this__u8e3s4, cause, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(HttpStatement).toString = function () {
    return 'HttpStatement[' + this.cv1_1.ytr_1.toString() + ']';
  };
  function readRawBytes(_this__u8e3s4, $completion) {
    var tmp = new $readRawBytesCOROUTINE$(_this__u8e3s4, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function $readRawBytesCOROUTINE$(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.zv2_1 = _this__u8e3s4;
  }
  protoOf($readRawBytesCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = readRemaining(this.zv2_1.utt(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readByteArray(ARGUMENT);
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function observable(_this__u8e3s4, context, contentLength, listener) {
    var tmp = GlobalScope_instance;
    return writer(tmp, context, true, observable$slambda_0(_this__u8e3s4, listener, contentLength, null)).lse_1;
  }
  function observable$slambda($this_observable, $listener, $contentLength, resultContinuation) {
    this.iv3_1 = $this_observable;
    this.jv3_1 = $listener;
    this.kv3_1 = $contentLength;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(observable$slambda).vtc = function ($this$writer, $completion) {
    var tmp = this.wtc($this$writer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(observable$slambda).ja = function (p1, $completion) {
    return this.vtc(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(observable$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 16;
            this.rv3_1 = get_ByteArrayPool();
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.nv3_1 = this.rv3_1;
            this.mv3_1 = this.nv3_1.esn();
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 15;
            this.qv3_1 = this.mv3_1;
            this.ov3_1 = new Long(0, 0);
            this.n9_1 = 4;
            continue $sm;
          case 4:
            if (!!this.iv3_1.qsc()) {
              this.n9_1 = 9;
              continue $sm;
            }

            this.n9_1 = 5;
            suspendResult = readAvailable(this.iv3_1, this.qv3_1, VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.pv3_1 = suspendResult;
            if (this.pv3_1 <= 0) {
              this.n9_1 = 4;
              continue $sm;
            } else {
              this.n9_1 = 6;
              continue $sm;
            }

          case 6:
            this.n9_1 = 7;
            suspendResult = writeFully(this.lv3_1.xsk_1, this.qv3_1, 0, this.pv3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 7:
            var tmp_0 = this;
            var tmp0 = this.ov3_1;
            var other = this.pv3_1;
            tmp_0.ov3_1 = add(tmp0, fromInt(other));
            this.n9_1 = 8;
            suspendResult = this.jv3_1.jtw(this.ov3_1, this.kv3_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 8:
            this.n9_1 = 4;
            continue $sm;
          case 9:
            var closedCause = this.iv3_1.psc();
            close(this.lv3_1.xsk_1, closedCause);
            if (closedCause == null && equalsLong(this.ov3_1, new Long(0, 0))) {
              this.n9_1 = 10;
              suspendResult = this.jv3_1.jtw(this.ov3_1, this.kv3_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 11;
              continue $sm;
            }

          case 10:
            this.n9_1 = 11;
            continue $sm;
          case 11:
            this.o9_1 = 16;
            this.n9_1 = 12;
            var tmp_1 = this;
            continue $sm;
          case 12:
            this.o9_1 = 16;
            this.nv3_1.fsn(this.mv3_1);
            this.n9_1 = 14;
            continue $sm;
          case 13:
            this.o9_1 = 16;
            this.nv3_1.fsn(this.mv3_1);
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 14;
            continue $sm;
          case 14:
            return Unit_instance;
          case 15:
            this.o9_1 = 16;
            var t = this.q9_1;
            this.nv3_1.fsn(this.mv3_1);
            throw t;
          case 16:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 16) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(observable$slambda).wtc = function ($this$writer, completion) {
    var i = new observable$slambda(this.iv3_1, this.jv3_1, this.kv3_1, completion);
    i.lv3_1 = $this$writer;
    return i;
  };
  function observable$slambda_0($this_observable, $listener, $contentLength, resultContinuation) {
    var i = new observable$slambda($this_observable, $listener, $contentLength, resultContinuation);
    return constructCallableReference(function ($this$writer, $completion) {
      return i.vtc($this$writer, $completion);
    }, 1);
  }
  function get_HttpRequestCreated() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestCreated;
  }
  var HttpRequestCreated;
  function get_HttpRequestIsReadyForSending() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpRequestIsReadyForSending;
  }
  var HttpRequestIsReadyForSending;
  function get_HttpResponseReceived() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceived;
  }
  var HttpResponseReceived;
  function get_HttpResponseReceiveFailed() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseReceiveFailed;
  }
  var HttpResponseReceiveFailed;
  function get_HttpResponseCancelled() {
    _init_properties_ClientEvents_kt__xuvbz8();
    return HttpResponseCancelled;
  }
  var HttpResponseCancelled;
  function HttpResponseReceiveFail(response, cause) {
    this.sv3_1 = response;
    this.tv3_1 = cause;
  }
  var properties_initialized_ClientEvents_kt_rdee4m;
  function _init_properties_ClientEvents_kt__xuvbz8() {
    if (!properties_initialized_ClientEvents_kt_rdee4m) {
      properties_initialized_ClientEvents_kt_rdee4m = true;
      HttpRequestCreated = new EventDefinition();
      HttpRequestIsReadyForSending = new EventDefinition();
      HttpResponseReceived = new EventDefinition();
      HttpResponseReceiveFailed = new EventDefinition();
      HttpResponseCancelled = new EventDefinition();
    }
  }
  function EmptyContent() {
    EmptyContent_instance = this;
    NoContent.call(this);
    this.vv3_1 = new Long(0, 0);
  }
  protoOf(EmptyContent).wt7 = function () {
    return this.vv3_1;
  };
  protoOf(EmptyContent).toString = function () {
    return 'EmptyContent';
  };
  protoOf(EmptyContent).hashCode = function () {
    return 1450860306;
  };
  protoOf(EmptyContent).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof EmptyContent))
      return false;
    return true;
  };
  var EmptyContent_instance;
  function EmptyContent_getInstance() {
    if (EmptyContent_instance == null)
      new EmptyContent();
    return EmptyContent_instance;
  }
  function get_DecompressionListAttribute() {
    _init_properties_HeadersUtils_kt__fb6dxx();
    return DecompressionListAttribute;
  }
  var DecompressionListAttribute;
  function dropCompressionHeaders(_this__u8e3s4, method, attributes, alwaysRemove) {
    alwaysRemove = alwaysRemove === VOID ? false : alwaysRemove;
    _init_properties_HeadersUtils_kt__fb6dxx();
    if (method.equals(Companion_getInstance_2().jt2_1) || method.equals(Companion_getInstance_2().kt2_1))
      return Unit_instance;
    var header = _this__u8e3s4.je('Content-Encoding');
    if (header == null) {
      if (!alwaysRemove)
        return Unit_instance;
    } else {
      var tmp = get_DecompressionListAttribute();
      attributes.zsn(tmp, dropCompressionHeaders$lambda).j1(header);
    }
    _this__u8e3s4.jsq('Content-Encoding');
    _this__u8e3s4.jsq('Content-Length');
  }
  function dropCompressionHeaders$lambda() {
    _init_properties_HeadersUtils_kt__fb6dxx();
    // Inline function 'kotlin.collections.mutableListOf' call
    return ArrayList_init_$Create$();
  }
  var properties_initialized_HeadersUtils_kt_8c3zal;
  function _init_properties_HeadersUtils_kt__fb6dxx() {
    if (!properties_initialized_HeadersUtils_kt_8c3zal) {
      properties_initialized_HeadersUtils_kt_8c3zal = true;
      // Inline function 'io.ktor.util.AttributeKey' call
      var name = 'DecompressionListAttribute';
      // Inline function 'io.ktor.util.reflect.typeInfo' call
      var tmp = getKClass(KtMutableList);
      // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
      var tmp_0;
      try {
        tmp_0 = createKType(getKClass(KtMutableList), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().rc(), arrayOf([]), false))]), false);
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var _unused_var__etf5q3 = $p;
          tmp_1 = null;
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      var tmp$ret$2 = tmp_0;
      var tmp$ret$1 = new TypeInfo(tmp, tmp$ret$2);
      DecompressionListAttribute = new AttributeKey(name, tmp$ret$1);
    }
  }
  function buildHeaders(block) {
    var tmp;
    if (block === VOID) {
      tmp = buildHeaders$lambda;
    } else {
      tmp = block;
    }
    block = tmp;
    // Inline function 'kotlin.apply' call
    var this_0 = new HeadersBuilder();
    block(this_0);
    return this_0.g3d();
  }
  function buildHeaders$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function Companion_3() {
    Companion_instance_4 = this;
    var tmp = this;
    // Inline function 'io.ktor.util.AttributeKey' call
    var name = 'FetchOptions';
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = getKClass(FetchOptions);
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(getKClass(FetchOptions), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$2 = tmp_1;
    var tmp$ret$1 = new TypeInfo(tmp_0, tmp$ret$2);
    tmp.wv3_1 = new AttributeKey(name, tmp$ret$1);
  }
  var Companion_instance_4;
  function Companion_getInstance_12() {
    if (Companion_instance_4 == null)
      new Companion_3();
    return Companion_instance_4;
  }
  function FetchOptions(requestInit) {
    Companion_getInstance_12();
    this.xv3_1 = requestInit;
  }
  function get_initHook() {
    return initHook;
  }
  var initHook;
  function Js() {
  }
  protoOf(Js).yv3 = function (block) {
    // Inline function 'kotlin.apply' call
    var this_0 = new JsClientEngineConfig();
    block(this_0);
    return new JsClientEngine(this_0);
  };
  protoOf(Js).btt = function (block) {
    return this.yv3(block);
  };
  protoOf(Js).toString = function () {
    return 'Js';
  };
  protoOf(Js).hashCode = function () {
    return -527824213;
  };
  protoOf(Js).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Js))
      return false;
    return true;
  };
  var Js_instance;
  function Js_getInstance() {
    return Js_instance;
  }
  function JsClientEngineConfig$requestInit$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function JsClientEngineConfig() {
    HttpClientEngineConfig.call(this);
    var tmp = this;
    tmp.dv4_1 = JsClientEngineConfig$requestInit$lambda;
    this.ev4_1 = Object.create(null);
  }
  function initHook$init$() {
    engines_getInstance().gv4(Js_instance);
    return Unit_instance;
  }
  function createWebSocket($this, urlString_capturingHack, headers, $completion) {
    var tmp = new $createWebSocketCOROUTINE$($this, urlString_capturingHack, headers, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function executeWebSocketRequest($this, request, callContext, $completion) {
    var tmp = new $executeWebSocketRequestCOROUTINE$($this, request, callContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function JsClientEngine$execute$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function JsClientEngine$createWebSocket$headers_capturingHack$1() {
  }
  function JsClientEngine$createWebSocket$lambda($headers_capturingHack) {
    return function (name, values) {
      $headers_capturingHack[name] = joinToString(values, ',');
      return Unit_instance;
    };
  }
  function $executeCOROUTINE$_2(_this__u8e3s4, data, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.tv5_1 = _this__u8e3s4;
    this.uv5_1 = data;
  }
  protoOf($executeCOROUTINE$_2).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 6;
            this.n9_1 = 1;
            suspendResult = callContext(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.vv5_1 = suspendResult;
            this.xv5_1 = this.uv5_1.ztw_1.tsn(get_CLIENT_CONFIG());
            if (isUpgradeRequest(this.uv5_1)) {
              this.n9_1 = 5;
              suspendResult = executeWebSocketRequest(this.tv5_1, this.uv5_1, this.vv5_1, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.n9_1 = 2;
              continue $sm;
            }

          case 2:
            this.wv5_1 = GMTDate();
            this.n9_1 = 3;
            suspendResult = ktor_toRaw(this.uv5_1, this.xv5_1, this.vv5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 3:
            var rawRequest = suspendResult;
            var tmp0_safe_receiver = this.uv5_1.ztw_1.usn(Companion_getInstance_12().wv3_1);
            var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.xv3_1;
            var tmp_0;
            if (tmp1_elvis_lhs == null) {
              tmp_0 = JsClientEngine$execute$lambda;
            } else {
              tmp_0 = tmp1_elvis_lhs;
            }

            var fetchOptions = tmp_0;
            this.n9_1 = 4;
            suspendResult = commonFetch(this.uv5_1.utw_1.toString(), rawRequest, fetchOptions, this.tv5_1.dv6_1, get_job(this.vv5_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            var rawResponse = suspendResult;
            var status = new HttpStatusCode(rawResponse.status, rawResponse.statusText);
            var headers = mapToKtor(rawResponse.headers, this.uv5_1.vtw_1, this.uv5_1.ztw_1);
            var version = Companion_getInstance_5().rt2_1;
            var body = readBody(CoroutineScope_0(this.vv5_1), rawResponse);
            var tmp2_safe_receiver = this.uv5_1.ztw_1.usn(get_ResponseAdapterAttributeKey());
            var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.rux(this.uv5_1, status, headers, body, this.uv5_1.xtw_1, this.vv5_1);
            var responseBody = tmp3_elvis_lhs == null ? body : tmp3_elvis_lhs;
            return new HttpResponseData(status, this.wv5_1, headers, version, responseBody, this.vv5_1);
          case 5:
            return suspendResult;
          case 6:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 6) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $createWebSocketCOROUTINE$(_this__u8e3s4, urlString_capturingHack, headers, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.pv4_1 = _this__u8e3s4;
    this.qv4_1 = urlString_capturingHack;
    this.rv4_1 = headers;
  }
  protoOf($createWebSocketCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 3;
            var tmp0 = this.rv4_1.csq();
            var destination = ArrayList_init_$Create$();
            var _iterator__ex2g4s = tmp0.t();
            while (_iterator__ex2g4s.u()) {
              var element = _iterator__ex2g4s.v();
              if (equals_0(element, 'Sec-WebSocket-Protocol', true)) {
                destination.j1(element);
              }
            }

            var protocolHeaderNames = destination;
            var tmp_0 = this;
            var destination_0 = ArrayList_init_$Create$();
            var _iterator__ex2g4s_0 = protocolHeaderNames.t();
            while (_iterator__ex2g4s_0.u()) {
              var element_0 = _iterator__ex2g4s_0.v();
              var tmp0_safe_receiver = this.rv4_1.bsq(element_0);
              if (tmp0_safe_receiver == null)
                null;
              else {
                destination_0.j1(tmp0_safe_receiver);
              }
            }

            var this_0 = flatten(destination_0);
            tmp_0.tv4_1 = copyToArray(this_0);
            if (PlatformUtils_getInstance().nsp_1) {
              this.sv4_1 = new WebSocket(this.qv4_1, this.tv4_1);
              this.n9_1 = 2;
              continue $sm;
            } else {
              var ws_import = import('ws');
              this.n9_1 = 1;
              suspendResult = await_0(ws_import, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            }

          case 1:
            var ws_capturingHack = suspendResult.default;
            var headers_capturingHack = new JsClientEngine$createWebSocket$headers_capturingHack$1();
            this.rv4_1.hsq(JsClientEngine$createWebSocket$lambda(headers_capturingHack));
            this.sv4_1 = new ws_capturingHack(this.qv4_1, this.tv4_1, {headers: headers_capturingHack});
            this.n9_1 = 2;
            continue $sm;
          case 2:
            return this.sv4_1;
          case 3:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 3) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $executeWebSocketRequestCOROUTINE$(_this__u8e3s4, request, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.cv5_1 = _this__u8e3s4;
    this.dv5_1 = request;
    this.ev5_1 = callContext;
  }
  protoOf($executeWebSocketRequestCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 5;
            this.gv5_1 = GMTDate();
            this.jv5_1 = this.dv5_1.utw_1.toString();
            this.kv5_1 = this.dv5_1.ztw_1.tsn(get_WEBSOCKETS_KEY());
            this.n9_1 = 1;
            suspendResult = createWebSocket(this.cv5_1, this.jv5_1, this.dv5_1.wtw_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.hv5_1 = suspendResult;
            this.fv5_1 = new JsWebSocketSession(this.ev5_1, this.hv5_1, this.kv5_1.zuw_1);
            this.o9_1 = 3;
            this.n9_1 = 2;
            suspendResult = awaitConnection(this.hv5_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.iv5_1 = suspendResult;
            this.o9_1 = 5;
            this.n9_1 = 4;
            continue $sm;
          case 3:
            this.o9_1 = 5;
            var tmp_0 = this.q9_1;
            if (tmp_0 instanceof Error) {
              var cause = this.q9_1;
              var tmp_1 = this;
              cancel_3(this.ev5_1, CancellationException_0('Failed to connect to ' + this.jv5_1, cause));
              throw cause;
            } else {
              throw this.q9_1;
            }

          case 4:
            this.o9_1 = 5;
            var this_0 = this.hv5_1.protocol;
            var tmp_2;
            if (charSequenceLength(this_0) > 0) {
              tmp_2 = this_0;
            } else {
              tmp_2 = null;
            }

            var protocol = tmp_2;
            var headers = !(protocol == null) ? headersOf('Sec-WebSocket-Protocol', protocol) : Companion_getInstance_6().yt1_1;
            return new HttpResponseData(Companion_getInstance_1().bt3_1, this.gv5_1, headers, Companion_getInstance_5().rt2_1, this.fv5_1, this.ev5_1);
          case 5:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 5) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function JsClientEngine(config) {
    HttpClientEngineBase.call(this, 'ktor-js');
    this.dv6_1 = config;
    this.ev6_1 = setOf_0([HttpTimeoutCapability_instance, WebSocketCapability_instance, SSECapability_instance]);
    // Inline function 'kotlin.check' call
    if (!(this.dv6_1.hty_1 == null)) {
      var message = 'Proxy unsupported in Js engine.';
      throw IllegalStateException_init_$Create$(toString(message));
    }
  }
  protoOf(JsClientEngine).ebw = function () {
    return this.dv6_1;
  };
  protoOf(JsClientEngine).btx = function () {
    return this.ev6_1;
  };
  protoOf(JsClientEngine).dty = function (data, $completion) {
    var tmp = new $executeCOROUTINE$_2(this, data, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  function mapToKtor(_this__u8e3s4, method, attributes) {
    return buildHeaders(mapToKtor$lambda(_this__u8e3s4, method, attributes));
  }
  function awaitConnection(_this__u8e3s4, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    $l$block: {
      if (cancellable.n1a()) {
        break $l$block;
      }
      // Inline function 'io.ktor.client.utils.addEventListener' call
      var events = ['error'];
      var events_0 = listOf(arrayConcat([['open'], events]));
      var callback = {_v: null};
      var tmp = awaitConnection$lambda(events_0, _this__u8e3s4, callback);
      var disposable = new sam$kotlinx_coroutines_DisposableHandle$0(tmp);
      callback._v = awaitConnection$lambda_0(true, disposable, cancellable, _this__u8e3s4);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = events_0.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp_0;
        if (callback._v == null) {
          throwUninitializedPropertyAccessException('callback');
        } else {
          tmp_0 = callback._v;
        }
        _this__u8e3s4.addEventListener(element, tmp_0);
      }
      var disposable_0 = disposable;
      cancellable.f1d(awaitConnection$lambda_1(disposable_0, _this__u8e3s4));
    }
    return cancellable.x1b();
  }
  function sam$kotlinx_coroutines_DisposableHandle$0(function_0) {
    this.fv6_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).s1d = function () {
    return this.fv6_1();
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).q3 = function () {
    return this.fv6_1;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function mapToKtor$lambda$lambda($this_buildHeaders) {
    return function (value, key) {
      $this_buildHeaders.fsq(key, value);
      return Unit_instance;
    };
  }
  function mapToKtor$lambda($this_mapToKtor, $method, $attributes) {
    return function ($this$buildHeaders) {
      // Inline function 'kotlin.js.asDynamic' call
      $this_mapToKtor.forEach(mapToKtor$lambda$lambda($this$buildHeaders));
      dropCompressionHeaders($this$buildHeaders, $method, $attributes, PlatformUtils_getInstance().nsp_1);
      return Unit_instance;
    };
  }
  function awaitConnection$lambda($events, $this, $callback) {
    return function () {
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s = $events.t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        var tmp;
        if ($callback._v == null) {
          throwUninitializedPropertyAccessException('callback');
        } else {
          tmp = $callback._v;
        }
        $this.removeEventListener(element, tmp);
      }
      return Unit_instance;
    };
  }
  function awaitConnection$lambda_0($once, $disposable, $continuation, $this_awaitConnection) {
    return function (event) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      if ($once) {
        $disposable.s1d();
      }
      var tmp0_subject = event.type;
      if (tmp0_subject === 'open') {
        var tmp0 = $continuation;
        // Inline function 'kotlin.coroutines.resume' call
        // Inline function 'kotlin.Companion.success' call
        var value = $this_awaitConnection;
        var tmp$ret$5 = _Result___init__impl__xyqfz8(value);
        tmp0.y9(tmp$ret$5);
      } else if (tmp0_subject === 'error') {
        var tmp0_0 = $continuation;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception = WebSocketException_init_$Create$(asString(event));
        var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception));
        tmp0_0.y9(tmp$ret$7);
      }
      return Unit_instance;
    };
  }
  function awaitConnection$lambda_1($disposable, $this_awaitConnection) {
    return function (cause) {
      $disposable.s1d();
      var tmp;
      if (!(cause == null)) {
        $this_awaitConnection.close();
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  function asByteArray(_this__u8e3s4) {
    // Inline function 'kotlin.js.asDynamic' call
    return new Int8Array(_this__u8e3s4.buffer, _this__u8e3s4.byteOffset, _this__u8e3s4.length);
  }
  function readBodyBrowser(_this__u8e3s4, response) {
    var tmp0_elvis_lhs = response.body;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Companion_getInstance().pse_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var stream = tmp;
    return channelFromStream(_this__u8e3s4, stream);
  }
  function channelFromStream(_this__u8e3s4, stream) {
    return writer(_this__u8e3s4, VOID, VOID, channelFromStream$slambda_0(stream, null)).lse_1;
  }
  function readChunk(_this__u8e3s4, $completion) {
    var safe = SafeContinuation_init_$Create$(intercepted($completion));
    var tmp = _this__u8e3s4.read();
    var tmp_0 = tmp.then(readChunk$lambda(safe));
    tmp_0.catch(readChunk$lambda_0(safe));
    return safe.fa();
  }
  function channelFromStream$slambda$lambda(it) {
    return Unit_instance;
  }
  function channelFromStream$slambda($stream, resultContinuation) {
    this.ov6_1 = $stream;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(channelFromStream$slambda).vtc = function ($this$writer, $completion) {
    var tmp = this.wtc($this$writer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(channelFromStream$slambda).ja = function (p1, $completion) {
    return this.vtc(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(channelFromStream$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 9;
            this.rv6_1 = this.ov6_1.getReader();
            this.o9_1 = 7;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            if (!true) {
              this.n9_1 = 6;
              continue $sm;
            }

            this.n9_1 = 2;
            suspendResult = readChunk(this.rv6_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            var tmp0_elvis_lhs = suspendResult;
            if (tmp0_elvis_lhs == null) {
              this.n9_1 = 6;
              var tmp_0 = this;
              continue $sm;
            } else {
              this.sv6_1 = tmp0_elvis_lhs;
              this.n9_1 = 3;
              continue $sm;
            }

          case 3:
            var chunk = this.sv6_1;
            this.n9_1 = 4;
            suspendResult = writeFully(this.pv6_1.xsk_1, asByteArray(chunk), VOID, VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.pv6_1.xsk_1.ksc(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.n9_1 = 1;
            continue $sm;
          case 6:
            this.o9_1 = 9;
            this.n9_1 = 10;
            continue $sm;
          case 7:
            this.o9_1 = 9;
            var tmp_1 = this.q9_1;
            if (tmp_1 instanceof Error) {
              this.qv6_1 = this.q9_1;
              this.n9_1 = 8;
              var tmp_2 = this.rv6_1.cancel(this.qv6_1);
              suspendResult = await_0(tmp_2.catch(channelFromStream$slambda$lambda), this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              throw this.q9_1;
            }

          case 8:
            throw this.qv6_1;
          case 9:
            throw this.q9_1;
          case 10:
            this.o9_1 = 9;
            return Unit_instance;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 9) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(channelFromStream$slambda).wtc = function ($this$writer, completion) {
    var i = new channelFromStream$slambda(this.ov6_1, completion);
    i.pv6_1 = $this$writer;
    return i;
  };
  function channelFromStream$slambda_0($stream, resultContinuation) {
    var i = new channelFromStream$slambda($stream, resultContinuation);
    return constructCallableReference(function ($this$writer, $completion) {
      return i.vtc($this$writer, $completion);
    }, 1);
  }
  function readChunk$lambda($continuation) {
    return function (it) {
      var chunk = it.value;
      var result = it.done ? null : chunk;
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(result);
      this_0.y9(tmp$ret$1);
      return Unit_instance;
    };
  }
  function readChunk$lambda_0($continuation) {
    return function (cause) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
      this_0.y9(tmp$ret$1);
      return Unit_instance;
    };
  }
  function commonFetch(input, init, requestConfig, config, callJob, $completion) {
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v1e();
    var controller = AbortController_0();
    init.signal = controller.signal;
    config.dv4_1(init);
    requestConfig(init);
    callJob.v1a(true, VOID, commonFetch$lambda(controller));
    var tmp;
    if (PlatformUtils_getInstance().nsp_1) {
      tmp = fetch(input, init);
    } else {
      var options = Object.assign(Object.create(null), init, config.ev4_1);
      tmp = fetch(input, options);
    }
    var promise = tmp;
    var tmp_0 = commonFetch$lambda_0(cancellable);
    promise.then(tmp_0, commonFetch$lambda_1(cancellable));
    return cancellable.x1b();
  }
  function readBody(_this__u8e3s4, response) {
    return readBodyBrowser(_this__u8e3s4, response);
  }
  function AbortController_0() {
    return new AbortController();
  }
  function commonFetch$lambda($controller) {
    return function (it) {
      $controller.abort();
      return Unit_instance;
    };
  }
  function commonFetch$lambda_0($continuation) {
    return function (it) {
      // Inline function 'kotlin.coroutines.resume' call
      var this_0 = $continuation;
      // Inline function 'kotlin.Companion.success' call
      var tmp$ret$1 = _Result___init__impl__xyqfz8(it);
      this_0.y9(tmp$ret$1);
      return Unit_instance;
    };
  }
  function commonFetch$lambda_1($continuation) {
    return function (it) {
      var tmp0 = $continuation;
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception = Error_init_$Create$('Fail to fetch', it);
      var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(exception));
      tmp0.y9(tmp$ret$1);
      return Unit_instance;
    };
  }
  function isReservedStatusCode($this, $receiver) {
    // Inline function 'kotlin.let' call
    var resolved = Companion_getInstance_7().vte($receiver);
    return resolved == null || equals(resolved, Codes_CLOSED_ABNORMALLY_getInstance());
  }
  function sam$kotlinx_coroutines_DisposableHandle$0_0(function_0) {
    this.tv6_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0_0).s1d = function () {
    return this.tv6_1();
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0_0).q3 = function () {
    return this.tv6_1;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DisposableHandle) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$kotlinx_coroutines_DisposableHandle$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function JsWebSocketSession$lambda(this$0) {
    return function (event) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var data = event.data;
      var tmp;
      if (data instanceof ArrayBuffer) {
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$3 = new Int8Array(data);
        tmp = Binary_init_$Create$(true, tmp$ret$3);
      } else {
        if (!(data == null) ? typeof data === 'string' : false) {
          tmp = Text_init_$Create$(data);
        } else {
          var error = IllegalStateException_init_$Create$('Unknown frame type: ' + event.type);
          this$0.wv6_1.v1g(error);
          throw error;
        }
      }
      var frame = tmp;
      this$0.xv6_1.s1s(frame);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_0($this, $event, $callback) {
    return function () {
      $this.removeEventListener($event, $callback);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_1(this$0) {
    return function (event) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var cause = WebSocketException_init_$Create$(asString(event));
      this$0.wv6_1.v1g(cause);
      this$0.xv6_1.z1s(cause);
      this$0.yv6_1.d1t();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_2($this, $event, $callback) {
    return function () {
      $this.removeEventListener($event, $callback);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_3(this$0) {
    return function (event) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var reason = new CloseReason(event.code, event.reason);
      this$0.wv6_1.u1g(reason);
      this$0.xv6_1.s1s(Close_init_$Create$(reason));
      this$0.xv6_1.b1t();
      this$0.yv6_1.d1t();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_4($this, $event, $callback) {
    return function () {
      $this.removeEventListener($event, $callback);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda$lambda($cause, this$0) {
    return function (event) {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      if ($cause == null) {
        this$0.vv6_1.close();
      } else {
        this$0.vv6_1.close(Codes_NORMAL_getInstance().ste_1, 'Client failed');
      }
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda$lambda_0($this, $event, $callback) {
    return function () {
      $this.removeEventListener($event, $callback);
      return Unit_instance;
    };
  }
  function JsWebSocketSession$lambda_5(this$0, $onMessage, $onError) {
    return function (cause) {
      var tmp0 = this$0;
      $l$block: {
        // Inline function 'io.ktor.client.plugins.websocket.JsWebSocketSession.runWhenOpen' call
        if (tmp0.vv6_1.readyState === WebSocket.OPEN) {
          if (cause == null) {
            this$0.vv6_1.close();
          } else {
            this$0.vv6_1.close(Codes_NORMAL_getInstance().ste_1, 'Client failed');
          }
          break $l$block;
        }
        // Inline function 'io.ktor.client.utils.addEventListener' call
        var this_0 = tmp0.vv6_1;
        var callback = JsWebSocketSession$lambda$lambda(cause, this$0);
        // Inline function 'org.w3c.dom.AddEventListenerOptions' call
        var o = {};
        o['passive'] = false;
        o['once'] = true;
        o['capture'] = false;
        var options = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
        this_0.addEventListener('open', callback, options);
        var tmp = JsWebSocketSession$lambda$lambda_0(this_0, 'open', callback);
        new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp);
      }
      $onMessage.s1d();
      $onError.s1d();
      return Unit_instance;
    };
  }
  function JsWebSocketSession$slambda(this$0, resultContinuation) {
    this.kv7_1 = this$0;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(JsWebSocketSession$slambda).p24 = function ($this$launch, $completion) {
    var tmp = this.q24($this$launch, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(JsWebSocketSession$slambda).ja = function (p1, $completion) {
    return this.p24((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(JsWebSocketSession$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 10;
            this.pv7_1 = this.kv7_1.yv6_1;
            this.n9_1 = 1;
            continue $sm;
          case 1:
            this.nv7_1 = this.pv7_1;
            this.mv7_1 = null;
            this.n9_1 = 2;
            continue $sm;
          case 2:
            this.n9_1 = 3;
            continue $sm;
          case 3:
            this.o9_1 = 9;
            this.o9_1 = 8;
            this.ov7_1 = this.nv7_1.t();
            this.n9_1 = 4;
            continue $sm;
          case 4:
            this.n9_1 = 5;
            suspendResult = this.ov7_1.d1q(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            if (!suspendResult) {
              this.n9_1 = 6;
              continue $sm;
            }

            var e = this.ov7_1.v();
            switch (e.uti_1.a1_1) {
              case 0:
                var text = e.vti_1;
                this.kv7_1.vv6_1.send(decodeToString(text, 0, 0 + text.length | 0));
                break;
              case 1:
                var tmp_0 = e.vti_1;
                var source = tmp_0 instanceof Int8Array ? tmp_0 : THROW_CCE();
                var frameData = source.buffer.slice(source.byteOffset, source.byteOffset + source.byteLength | 0);
                this.kv7_1.vv6_1.send(frameData);
                break;
              case 2:
                var builder = new Buffer();
                writeFully_0(builder, e.vti_1);
                var data = builder;
                var code = data.zs7();
                var reason = readText(data);
                this.kv7_1.wv6_1.u1g(new CloseReason(code, reason));
                if (isReservedStatusCode(this.kv7_1, code)) {
                  this.kv7_1.vv6_1.close();
                } else {
                  this.kv7_1.vv6_1.close(code, reason);
                }

                break;
              case 3:
              case 4:
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }

            this.n9_1 = 4;
            continue $sm;
          case 6:
            this.o9_1 = 10;
            this.n9_1 = 7;
            var tmp_1 = this;
            continue $sm;
          case 7:
            this.o9_1 = 10;
            cancelConsumed(this.nv7_1, this.mv7_1);
            this.n9_1 = 12;
            continue $sm;
          case 8:
            this.o9_1 = 9;
            var tmp_2 = this.q9_1;
            if (tmp_2 instanceof Error) {
              var e_0 = this.q9_1;
              var tmp_3 = this;
              this.mv7_1 = e_0;
              throw e_0;
            } else {
              throw this.q9_1;
            }

          case 9:
            this.o9_1 = 10;
            var t = this.q9_1;
            cancelConsumed(this.nv7_1, this.mv7_1);
            throw t;
          case 10:
            throw this.q9_1;
          case 11:
            this.o9_1 = 10;
            cancelConsumed(this.nv7_1, this.mv7_1);
            if (false) {
              this.n9_1 = 1;
              continue $sm;
            }

            this.n9_1 = 12;
            continue $sm;
          case 12:
            return Unit_instance;
        }
      } catch ($p) {
        var e_1 = $p;
        if (this.o9_1 === 10) {
          throw e_1;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e_1;
        }
      }
     while (true);
  };
  protoOf(JsWebSocketSession$slambda).q24 = function ($this$launch, completion) {
    var i = new JsWebSocketSession$slambda(this.kv7_1, completion);
    i.lv7_1 = $this$launch;
    return i;
  };
  function JsWebSocketSession$slambda_0(this$0, resultContinuation) {
    var i = new JsWebSocketSession$slambda(this$0, resultContinuation);
    return constructCallableReference(function ($this$launch, $completion) {
      return i.p24($this$launch, $completion);
    }, 1);
  }
  function JsWebSocketSession(coroutineContext, websocket, channelsConfig) {
    this.uv6_1 = coroutineContext;
    this.vv6_1 = websocket;
    this.wv6_1 = CompletableDeferred();
    this.xv6_1 = from(Factory_getInstance(), channelsConfig.gtf_1);
    this.yv6_1 = from(Factory_getInstance(), channelsConfig.htf_1);
    this.zv6_1 = this.xv6_1;
    this.av7_1 = this.yv6_1;
    this.bv7_1 = this.wv6_1;
    // Inline function 'io.ktor.client.utils.addEventListener' call
    var this_0 = this.vv6_1;
    var callback = JsWebSocketSession$lambda(this);
    // Inline function 'org.w3c.dom.AddEventListenerOptions' call
    var o = {};
    o['passive'] = false;
    o['once'] = false;
    o['capture'] = false;
    var options = (!(o == null) ? !(o == null) : false) ? o : THROW_CCE();
    this_0.addEventListener('message', callback, options);
    var tmp = JsWebSocketSession$lambda_0(this_0, 'message', callback);
    var onMessage = new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp);
    // Inline function 'io.ktor.client.utils.addEventListener' call
    var this_1 = this.vv6_1;
    var callback_0 = JsWebSocketSession$lambda_1(this);
    // Inline function 'org.w3c.dom.AddEventListenerOptions' call
    var o_0 = {};
    o_0['passive'] = false;
    o_0['once'] = false;
    o_0['capture'] = false;
    var options_0 = (!(o_0 == null) ? !(o_0 == null) : false) ? o_0 : THROW_CCE();
    this_1.addEventListener('error', callback_0, options_0);
    var tmp_0 = JsWebSocketSession$lambda_2(this_1, 'error', callback_0);
    var onError = new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_0);
    // Inline function 'io.ktor.client.utils.addEventListener' call
    var this_2 = this.vv6_1;
    var callback_1 = JsWebSocketSession$lambda_3(this);
    // Inline function 'org.w3c.dom.AddEventListenerOptions' call
    var o_1 = {};
    o_1['passive'] = false;
    o_1['once'] = true;
    o_1['capture'] = false;
    var options_1 = (!(o_1 == null) ? !(o_1 == null) : false) ? o_1 : THROW_CCE();
    this_2.addEventListener('close', callback_1, options_1);
    var tmp_1 = JsWebSocketSession$lambda_4(this_2, 'close', callback_1);
    new sam$kotlinx_coroutines_DisposableHandle$0_0(tmp_1);
    var tmp0_safe_receiver = this.uv6_1.aa(Key_instance);
    if (tmp0_safe_receiver == null)
      null;
    else {
      tmp0_safe_receiver.t1a(JsWebSocketSession$lambda_5(this, onMessage, onError));
    }
    // Inline function 'org.w3c.dom.ARRAYBUFFER' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$9 = 'arraybuffer';
    this.vv6_1.binaryType = tmp$ret$9;
    launch(this, VOID, VOID, JsWebSocketSession$slambda_0(this, null));
    // Inline function 'kotlin.require' call
    if (!!channelsConfig.gtf_1.mtm()) {
      var message = 'Suspendable channels are not supported in JS.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  }
  protoOf(JsWebSocketSession).q19 = function () {
    return this.uv6_1;
  };
  protoOf(JsWebSocketSession).ctf = function () {
    return this.zv6_1;
  };
  protoOf(JsWebSocketSession).dtf = function () {
    return this.av7_1;
  };
  protoOf(JsWebSocketSession).atf = function (_) {
    throw WebSocketException_init_$Create$('Max frame size switch is not supported in Js engine.');
  };
  protoOf(JsWebSocketSession).btf = function () {
    return new Long(-1, 2147483647);
  };
  protoOf(JsWebSocketSession).zte = function (negotiatedExtensions) {
    // Inline function 'kotlin.require' call
    if (!negotiatedExtensions.r()) {
      var message = 'Extensions are not supported.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
  };
  protoOf(JsWebSocketSession).ksc = function ($completion) {
    return Unit_instance;
  };
  function ktor_toRaw(_this__u8e3s4, clientConfig, callContext, $completion) {
    var tmp = new $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function asString(_this__u8e3s4) {
    var tmp = JSON;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$0 = ['message', 'target', 'type', 'isTrusted'];
    return tmp.stringify(_this__u8e3s4, tmp$ret$0);
  }
  function getBodyBytes(content, callContext, $completion) {
    var tmp = new $getBodyBytesCOROUTINE$(content, callContext, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  }
  function buildObject(block) {
    // Inline function 'kotlin.apply' call
    var this_0 = {};
    block(this_0);
    return this_0;
  }
  function toRaw$lambda($skipContentLengthHeader, $jsHeaders) {
    return function (key, value) {
      var tmp;
      if ($skipContentLengthHeader && key === 'Content-Length') {
        return Unit_instance;
      }
      $jsHeaders[key] = value;
      return Unit_instance;
    };
  }
  function toRaw$lambda_0($this_toRaw, $jsHeaders, $clientConfig, $bodyBytes) {
    return function ($this$buildObject) {
      $this$buildObject.method = $this_toRaw.vtw_1.ot2_1;
      $this$buildObject.headers = $jsHeaders;
      var tmp;
      if ($clientConfig.ots_1) {
        // Inline function 'org.w3c.fetch.FOLLOW' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'follow';
      } else {
        // Inline function 'org.w3c.fetch.MANUAL' call
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.unsafeCast' call
        tmp = 'manual';
      }
      $this$buildObject.redirect = tmp;
      var tmp0_safe_receiver = $bodyBytes;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        $this$buildObject.body = new Uint8Array(toTypedArray(tmp0_safe_receiver));
      }
      return Unit_instance;
    };
  }
  function getBodyBytes$slambda($content, resultContinuation) {
    this.vv8_1 = $content;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(getBodyBytes$slambda).vtc = function ($this$writer, $completion) {
    var tmp = this.wtc($this$writer, $completion);
    tmp.p9_1 = Unit_instance;
    tmp.q9_1 = null;
    return tmp.v9();
  };
  protoOf(getBodyBytes$slambda).ja = function (p1, $completion) {
    return this.vtc(p1 instanceof WriterScope ? p1 : THROW_CCE(), $completion);
  };
  protoOf(getBodyBytes$slambda).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.n9_1 = 1;
            suspendResult = this.vv8_1.ct8(this.wv8_1.xsk_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  protoOf(getBodyBytes$slambda).wtc = function ($this$writer, completion) {
    var i = new getBodyBytes$slambda(this.vv8_1, completion);
    i.wv8_1 = $this$writer;
    return i;
  };
  function getBodyBytes$slambda_0($content, resultContinuation) {
    var i = new getBodyBytes$slambda($content, resultContinuation);
    return constructCallableReference(function ($this$writer, $completion) {
      return i.vtc($this$writer, $completion);
    }, 1);
  }
  function $toRawCOROUTINE$(_this__u8e3s4, clientConfig, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.yv7_1 = _this__u8e3s4;
    this.zv7_1 = clientConfig;
    this.av8_1 = callContext;
  }
  protoOf($toRawCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 2;
            this.bv8_1 = {};
            var this_0 = this.yv7_1;
            var skipContentLengthHeader = !get_supportsRequestBody(this_0.vtw_1) && isEmpty(this_0.xtw_1);
            mergeHeaders(this_0.wtw_1, this_0.xtw_1, toRaw$lambda(skipContentLengthHeader, this.bv8_1));
            this.n9_1 = 1;
            suspendResult = getBodyBytes(this.yv7_1.xtw_1, this.av8_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var bodyBytes = suspendResult;
            return buildObject(toRaw$lambda_0(this.yv7_1, this.bv8_1, this.zv7_1, bodyBytes));
          case 2:
            throw this.q9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 2) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function $getBodyBytesCOROUTINE$(content, callContext, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.kv8_1 = content;
    this.lv8_1 = callContext;
  }
  protoOf($getBodyBytesCOROUTINE$).v9 = function () {
    var suspendResult = this.p9_1;
    $sm: do
      try {
        var tmp = this.n9_1;
        switch (tmp) {
          case 0:
            this.o9_1 = 4;
            var tmp0_subject = this.kv8_1;
            if (tmp0_subject instanceof ByteArrayContent) {
              this.mv8_1 = this.kv8_1.xt7();
              this.n9_1 = 5;
              continue $sm;
            } else {
              if (tmp0_subject instanceof ReadChannelContent) {
                this.n9_1 = 3;
                suspendResult = readRemaining(this.kv8_1.at8(), this);
                if (suspendResult === get_COROUTINE_SUSPENDED()) {
                  return suspendResult;
                }
                continue $sm;
              } else {
                if (tmp0_subject instanceof WriteChannelContent) {
                  this.n9_1 = 2;
                  var tmp_0 = GlobalScope_instance;
                  suspendResult = readRemaining(writer(tmp_0, this.lv8_1, VOID, getBodyBytes$slambda_0(this.kv8_1, null)).lse_1, this);
                  if (suspendResult === get_COROUTINE_SUSPENDED()) {
                    return suspendResult;
                  }
                  continue $sm;
                } else {
                  if (tmp0_subject instanceof ContentWrapper) {
                    this.n9_1 = 1;
                    suspendResult = getBodyBytes(this.kv8_1.gt8(), this.lv8_1, this);
                    if (suspendResult === get_COROUTINE_SUSPENDED()) {
                      return suspendResult;
                    }
                    continue $sm;
                  } else {
                    if (tmp0_subject instanceof NoContent) {
                      this.mv8_1 = null;
                      this.n9_1 = 5;
                      continue $sm;
                    } else {
                      if (tmp0_subject instanceof ProtocolUpgrade) {
                        var tmp_1 = this;
                        throw new UnsupportedContentTypeException(this.kv8_1);
                      } else {
                        var tmp_2 = this;
                        noWhenBranchMatchedException();
                      }
                    }
                  }
                }
              }
            }

            break;
          case 1:
            this.mv8_1 = suspendResult;
            this.n9_1 = 5;
            continue $sm;
          case 2:
            var ARGUMENT = suspendResult;
            this.mv8_1 = readByteArray(ARGUMENT);
            this.n9_1 = 5;
            continue $sm;
          case 3:
            var ARGUMENT_0 = suspendResult;
            this.mv8_1 = readByteArray(ARGUMENT_0);
            this.n9_1 = 5;
            continue $sm;
          case 4:
            throw this.q9_1;
          case 5:
            return this.mv8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.o9_1 === 4) {
          throw e;
        } else {
          this.n9_1 = this.o9_1;
          this.q9_1 = e;
        }
      }
     while (true);
  };
  function Node(item, next) {
    this.xv8_1 = item;
    this.yv8_1 = next;
  }
  function engines$iterator$1() {
    this.zv8_1 = engines_getInstance().fv4_1.kotlinx$atomicfu$value;
  }
  protoOf(engines$iterator$1).v = function () {
    var result = ensureNotNull(this.zv8_1);
    this.zv8_1 = result.yv8_1;
    return result.xv8_1;
  };
  protoOf(engines$iterator$1).u = function () {
    return !(null == this.zv8_1);
  };
  function engines() {
    engines_instance = this;
    this.fv4_1 = atomic$ref$1(null);
  }
  protoOf(engines).gv4 = function (item) {
    $l$loop: while (true) {
      var current = this.fv4_1.kotlinx$atomicfu$value;
      var new_0 = new Node(item, current);
      if (this.fv4_1.atomicfu$compareAndSet(current, new_0))
        break $l$loop;
    }
  };
  protoOf(engines).t = function () {
    return new engines$iterator$1();
  };
  var engines_instance;
  function engines_getInstance() {
    if (engines_instance == null)
      new engines();
    return engines_instance;
  }
  function ConnectTimeoutException() {
  }
  function SocketTimeoutException() {
  }
  function InterruptedIOException() {
  }
  function get_useEngineDispatcher() {
    return useEngineDispatcher;
  }
  var useEngineDispatcher;
  function unwrapCancellationException(_this__u8e3s4) {
    var exception = _this__u8e3s4;
    $l$loop: while (exception instanceof CancellationException) {
      if (equals(exception, exception.cause)) {
        return _this__u8e3s4;
      }
      exception = exception.cause;
    }
    var tmp0_elvis_lhs = exception;
    return tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  }
  function get_FACTORY() {
    _init_properties_HttpClient_web_kt__pyfqvb();
    return FACTORY;
  }
  var FACTORY;
  function HttpClient_2(block) {
    var tmp;
    if (block === VOID) {
      tmp = HttpClient$lambda_1;
    } else {
      tmp = block;
    }
    block = tmp;
    _init_properties_HttpClient_web_kt__pyfqvb();
    return HttpClient_0(get_FACTORY(), block);
  }
  function HttpClient$lambda_1(_this__u8e3s4) {
    _init_properties_HttpClient_web_kt__pyfqvb();
    return Unit_instance;
  }
  var properties_initialized_HttpClient_web_kt_zbb0cl;
  function _init_properties_HttpClient_web_kt__pyfqvb() {
    if (!properties_initialized_HttpClient_web_kt_zbb0cl) {
      properties_initialized_HttpClient_web_kt_zbb0cl = true;
      var tmp0 = engines_getInstance();
      var tmp$ret$0;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.t();
        while (_iterator__ex2g4s.u()) {
          var element = _iterator__ex2g4s.v();
          if (!equals(element, Js_instance)) {
            tmp$ret$0 = element;
            break $l$block;
          }
        }
        tmp$ret$0 = null;
      }
      var tmp0_elvis_lhs = tmp$ret$0;
      FACTORY = tmp0_elvis_lhs == null ? Js_instance : tmp0_elvis_lhs;
    }
  }
  function checkContentLength(contentLength, bodySize, method) {
  }
  function platformRequestDefaultTransform(contentType, context, body) {
    return null;
  }
  function platformResponseDefaultTransformers(_this__u8e3s4) {
  }
  //region block: post-declaration
  defineProp(protoOf(DoubleReceiveException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(NoTransformationFoundException), 'message', function () {
    return this.e();
  });
  protoOf(HttpClientEngineBase).btx = get_supportedCapabilities;
  protoOf(HttpClientEngineBase).ets = install;
  defineProp(protoOf(ClientEngineClosedException), 'cause', function () {
    return this.f();
  });
  protoOf(KtorCallContextElement).aa = get;
  protoOf(KtorCallContextElement).wj = fold;
  protoOf(KtorCallContextElement).vj = minusKey;
  protoOf(KtorCallContextElement).xj = plus;
  defineProp(protoOf(RedirectResponseException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(ClientRequestException), 'message', function () {
    return this.e();
  });
  defineProp(protoOf(ServerResponseException), 'message', function () {
    return this.e();
  });
  protoOf(HttpRequest$1).q19 = get_coroutineContext;
  defineProp(protoOf(SSEClientException), 'cause', function () {
    return this.f();
  });
  defineProp(protoOf(SSEClientException), 'message', function () {
    return this.e();
  });
  protoOf(Events_0).qur = appendLine;
  protoOf(Lines).cuq = appendEvent;
  protoOf(Empty).qur = appendLine;
  protoOf(Empty).cuq = appendEvent;
  protoOf(Js).kty = create$default;
  protoOf(JsWebSocketSession).etf = send;
  //endregion
  //region block: init
  Companion_instance_1 = new Companion_0();
  AfterRenderHook_instance = new AfterRenderHook();
  AfterReceiveHook_instance = new AfterReceiveHook();
  RequestError_instance = new RequestError();
  ReceiveError_instance = new ReceiveError();
  RenderRequestHook_instance = new RenderRequestHook();
  SetupRequestContext_instance = new SetupRequestContext();
  HttpTimeoutCapability_instance = new HttpTimeoutCapability();
  Send_instance = new Send();
  SetupRequest_instance = new SetupRequest();
  RequestHook_instance = new RequestHook();
  TransformRequestBodyHook_instance = new TransformRequestBodyHook();
  TransformResponseBodyHook_instance = new TransformResponseBodyHook();
  AfterRender_instance = new AfterRender();
  SSECapability_instance = new SSECapability();
  Off_instance = new Off();
  Empty_instance = new Empty();
  WebSocketExtensionsCapability_instance = new WebSocketExtensionsCapability();
  WebSocketCapability_instance = new WebSocketCapability();
  Companion_instance_3 = new Companion_2();
  Js_instance = new Js();
  useEngineDispatcher = true;
  //endregion
  //region block: eager init
  initHook = initHook$init$();
  //endregion
  //region block: exports
  function $jsExportAll$(_) {
    var io = _.io || (_.io = {});
    var ktor = io.ktor || (io.ktor = {});
    var client = ktor.client || (ktor.client = {});
    var engine = client.engine || (client.engine = {});
    var js = engine.js || (engine.js = {});
    defineProp(js, 'initHook', get_initHook, VOID, true);
  }
  $jsExportAll$(_);
  _.$jsExportAll$ = $jsExportAll$;
  _.$_$ = _.$_$ || {};
  _.$_$.a = Js_instance;
  _.$_$.b = Plugin_getInstance_1;
  _.$_$.c = Plugin_getInstance;
  _.$_$.d = EmptyContent_getInstance;
  _.$_$.e = bodyAsChannel;
  _.$_$.f = bodyAsText;
  _.$_$.g = readRawBytes;
  _.$_$.h = TransformRequestBodyContext;
  _.$_$.i = TransformResponseBodyContext;
  _.$_$.j = createClientPlugin;
  _.$_$.k = ClientSSESessionWithDeserialization;
  _.$_$.l = ClientSSESession;
  _.$_$.m = get_SSE;
  _.$_$.n = HttpRequestTimeoutException;
  _.$_$.o = get_HttpTimeout;
  _.$_$.p = timeout;
  _.$_$.q = HttpRequestBuilder;
  _.$_$.r = accept;
  _.$_$.s = bearerAuth;
  _.$_$.t = headers;
  _.$_$.u = header;
  _.$_$.v = parameter;
  _.$_$.w = url;
  _.$_$.x = url_0;
  _.$_$.y = HttpResponse;
  _.$_$.z = HttpStatement;
  _.$_$.a1 = get_request;
  _.$_$.b1 = HttpClient_1;
  _.$_$.c1 = HttpClient_2;
  _.$_$.d1 = HttpClient;
  //endregion
  return _;
}));

//# sourceMappingURL=ktor-ktor-client-core.js.map
